import { useInView } from "react-intersection-observer";
export function Mathematics() {
  const [ref, inView] = useInView({ threshold: 0.5 });
  return (
    <svg
      ref={ref}
      className={`h-full mx-auto ${inView ? "animated" : ""}`}
      id="freepik_stories-mathematics"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
    >
      <g
        id="freepik--Floor--inject-26"
        style={{ transformOrigin: "250.004px 345.963px 0px" }}
        className="animable"
      >
        <path
          d="M419.52,247.47c-94.24-54.41-246.52-54.41-340.14,0s-93.13,142.62,1.1,197,246.52,54.4,340.15,0S513.75,301.88,419.52,247.47Z"
          style={{
            fill: "#f8e0d3",
            transformOrigin: "250.004px 345.963px 0px",
          }}
          id="elnoy588x7lse"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Shadows--inject-26"
        style={{ transformOrigin: "251.729px 341.736px 0px" }}
        className="animable"
      >
        <polygon
          points="434.65 400.48 423.39 393.93 396.99 409.17 383.09 417.19 394.36 423.74 408.26 415.72 408.26 415.72 434.65 400.48"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "408.87px 408.835px 0px",
          }}
          id="eloyhylg0xxco"
          className="animable"
        ></polygon>
        <polygon
          points="246.67 437.56 256.26 443.09 304.23 415.4 294.5 409.8 246.67 437.56"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "275.45px 426.445px 0px",
          }}
          id="ela7t3sg55z1t"
          className="animable"
        ></polygon>
        <polygon
          points="393.55 294.22 439.29 320.62 454.55 311.81 408.75 285.36 393.55 294.22"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "424.05px 302.99px 0px",
          }}
          id="elagme3ydo88f"
          className="animable"
        ></polygon>
        <path
          d="M340.31,241.59l-8.62-5a8.29,8.29,0,0,0-7.53,0L50.48,394.7c-2.09,1.21-2.1,3.17,0,4.37l8.62,5a8.28,8.28,0,0,0,7.54,0L340.3,246C342.38,244.75,342.39,242.79,340.31,241.59Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "195.387px 320.332px 0px",
          }}
          id="els2xe0w5xidk"
          className="animable"
        ></path>
        <path
          d="M205.91,398.3c-19.61-11.32-51.31-11.32-70.8,0s-19.39,29.69.23,41,51.31,11.32,70.8,0S225.53,409.63,205.91,398.3Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "170.625px 418.798px 0px",
          }}
          id="eleubwdqxtbed"
          className="animable"
        ></path>
        <path
          d="M375.74,343.56c-18.9-10.92-49.45-10.92-68.23,0s-18.68,28.61.22,39.52,49.45,10.91,68.23,0S394.65,354.47,375.74,343.56Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "341.737px 363.316px 0px",
          }}
          id="elxkdp4q8o3f"
          className="animable"
        ></path>
        <polygon
          points="256.26 332.32 265.86 337.86 313.82 310.17 304.16 304.61 256.26 332.32"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "285.04px 321.235px 0px",
          }}
          id="elu56zpd5tvhf"
          className="animable"
        ></polygon>
        <polygon
          points="78.84 416.08 88.43 421.62 130.22 397.41 120.56 391.85 78.84 416.08"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "104.53px 406.735px 0px",
          }}
          id="elxtpfqvgkz2e"
          className="animable"
        ></polygon>
      </g>
      <g
        id="freepik--Symbols--inject-26"
        style={{ transformOrigin: "261.041px 243.257px 0px" }}
        className="animable"
      >
        <path
          d="M421.61,258.69c0-.39,0-.81,0-1.4l-8.89-5.13c0,1.11,0,2.08,0,3.07.18,10.27.42,20.57.51,30.79,0,3.76-.76,6.89-2.62,9a4,4,0,0,1-1.07.88l9.11-5.25h0a4.23,4.23,0,0,0,1.11-.91,8.93,8.93,0,0,0,1.4-2.21c-.18-2.25-.29-4.46-.31-6.61C420.76,273.31,421.33,266.08,421.61,258.69Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "415.575px 274.03px 0px",
          }}
          id="elvdlq3z09y4a"
          className="animable"
        ></path>
        <path
          d="M454.54,259.66a10.48,10.48,0,0,0-5.61-10q-8-4.68-16.1-9.33-9.13-5.28-18.29-10.49a10.56,10.56,0,0,0-4.85-1.59,10.82,10.82,0,0,0-6,1.84h0l-7.75,4.49a11.12,11.12,0,0,1,4.61-1,10.56,10.56,0,0,1,4.85,1.59q9.15,5.2,18.29,10.49,8.06,4.65,16.1,9.33a10.49,10.49,0,0,1,5.61,10,4,4,0,0,1-1.22,3.15h0L453,263h0C453.94,262.53,454.45,261.4,454.54,259.66Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "425.252px 248.195px 0px",
          }}
          id="elvl3meda34o8"
          className="animable"
        ></path>
        <path
          d="M441.4,313.17l.08-.05-.08,0Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "441.44px 313.145px 0px",
          }}
          id="eltk07u2svrar"
          className="animable"
        ></path>
        <path
          d="M409.41,296l.06,0-.06,0Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "409.44px 296px 0px",
          }}
          id="elf7cj1bfq8u"
          className="animable"
        ></path>
        <path
          d="M445.39,265a10.49,10.49,0,0,0-5.61-10q-8-4.68-16.1-9.33-9.14-5.28-18.29-10.49a10.56,10.56,0,0,0-4.85-1.59,11.12,11.12,0,0,0-4.61,1,12,12,0,0,0-1.55.9l-.06,0a18.46,18.46,0,0,0-4.95,5.65c-.08.13.06.5.17,1.31,1.34.32,2.6.59,3.87.94,3.23.89,6.46,1.78,9.71,2.77a3,3,0,0,1,.52.23,2.84,2.84,0,0,1,1.3,2.57c.22,10.69.92,21.7-3.75,28.86a15.07,15.07,0,0,0-1.9,6.3c-.39,3.31,1.67,7.54,4.59,10.29a9.36,9.36,0,0,0,1.61,1.22,3.94,3.94,0,0,0,3.92.31l.06,0,.07,0a4,4,0,0,0,1.07-.88c1.86-2.1,2.66-5.23,2.62-9-.09-10.22-.33-20.52-.51-30.79,0-1,0-2,0-3.07l8.89,5.13c0,.59,0,1,0,1.4-.28,7.39-.85,14.62-.76,22.22,0,2.15.13,4.36.31,6.61a87,87,0,0,0,1.37,10,21.27,21.27,0,0,0,10,14.25,16.5,16.5,0,0,0,2.11,1,8.61,8.61,0,0,0,6.79.34l.08,0a5.43,5.43,0,0,0,.91-.51,7.28,7.28,0,0,0,2.8-5.9,10.73,10.73,0,0,0-3.1-8,6.45,6.45,0,0,0-.26,1.25c-.21,3.5-1.7,4.76-4.69,3.91a5.92,5.92,0,0,1-1.38-.59c-2-1.13-3.66-3.42-4.87-6.7a28,28,0,0,1-1.38-5c-1.74-10.57-.7-19.46.93-27.95.1-.5,1-.68,1.62-.38.94.49,1.87,1,2.81,1.57.42.23.83.47,1.24.71l1,.57,1.18.67c.63.36,1.26.71,1.89,1,1.77.93,3.12,1,4,.35A4,4,0,0,0,445.39,265Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "417.38px 273.64px 0px",
          }}
          id="elby2lxpc2ezs"
          className="animable"
        ></path>
        <path
          d="M440,291.24a28.18,28.18,0,0,1-1.38-5,69.45,69.45,0,0,1-.39-19.53l-1.18-.67-1-.57c-.41-.24-.82-.48-1.24-.71-.94-.55-1.87-1.08-2.81-1.57-.58-.3-1.52-.12-1.62.38-1.63,8.49-2.67,17.38-.93,27.95a28,28,0,0,0,1.38,5c1.21,3.28,2.91,5.57,4.87,6.7a5.92,5.92,0,0,0,1.38.59c3,.85,4.48-.41,4.69-3.91a6.45,6.45,0,0,1,.26-1.25l2.08-1.2A13.59,13.59,0,0,1,440,291.24Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "436.33px 283.555px 0px",
          }}
          id="elpmt5qgqh1se"
          className="animable"
        ></path>
        <path
          d="M451.24,293.38l-7.07,4.08-2.08,1.2a10.73,10.73,0,0,1,3.1,8,7.28,7.28,0,0,1-2.8,5.9l8.7-5,.07,0,.08-.05h0c1.82-1.11,3-3.21,3.1-6.1A10.73,10.73,0,0,0,451.24,293.38Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "448.22px 302.97px 0px",
          }}
          id="eltnreoymc4cn"
          className="animable"
        ></path>
        <g id="el1o9kcjx4c0k">
          <path
            d="M421.61,258.69c0-.39,0-.81,0-1.4l-8.89-5.13c0,1.11,0,2.08,0,3.07.18,10.27.42,20.57.51,30.79,0,3.76-.76,6.89-2.62,9a4,4,0,0,1-1.07.88l9.11-5.25h0a4.23,4.23,0,0,0,1.11-.91,8.93,8.93,0,0,0,1.4-2.21c-.18-2.25-.29-4.46-.31-6.61C420.76,273.31,421.33,266.08,421.61,258.69Z"
            style={{
              opacity: "0.3",
              transformOrigin: "415.575px 274.03px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elspfn7l5gbjh">
          <path
            d="M454.54,259.66a10.48,10.48,0,0,0-5.61-10q-8-4.68-16.1-9.33-9.13-5.28-18.29-10.49a10.56,10.56,0,0,0-4.85-1.59,10.82,10.82,0,0,0-6,1.84h0l-7.75,4.49a11.12,11.12,0,0,1,4.61-1,10.56,10.56,0,0,1,4.85,1.59q9.15,5.2,18.29,10.49,8.06,4.65,16.1,9.33a10.49,10.49,0,0,1,5.61,10,4,4,0,0,1-1.22,3.15h0L453,263h0C453.94,262.53,454.45,261.4,454.54,259.66Z"
            style={{
              opacity: "0.3",
              transformOrigin: "425.252px 248.195px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el1c6va7vl7m8">
          <path
            d="M440,291.24a28.18,28.18,0,0,1-1.38-5,69.45,69.45,0,0,1-.39-19.53l-1.18-.67-1-.57c-.41-.24-.82-.48-1.24-.71-.94-.55-1.87-1.08-2.81-1.57-.58-.3-1.52-.12-1.62.38-1.63,8.49-2.67,17.38-.93,27.95a28,28,0,0,0,1.38,5c1.21,3.28,2.91,5.57,4.87,6.7a5.92,5.92,0,0,0,1.38.59c3,.85,4.48-.41,4.69-3.91a6.45,6.45,0,0,1,.26-1.25l2.08-1.2A13.59,13.59,0,0,1,440,291.24Z"
            style={{
              opacity: "0.3",
              transformOrigin: "436.33px 283.555px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elb120lqqfuac">
          <path
            d="M451.24,293.38l-7.07,4.08-2.08,1.2a10.73,10.73,0,0,1,3.1,8,7.28,7.28,0,0,1-2.8,5.9l8.7-5,.07,0,.08-.05h0c1.82-1.11,3-3.21,3.1-6.1A10.73,10.73,0,0,0,451.24,293.38Z"
            style={{ opacity: "0.3", transformOrigin: "448.22px 302.97px 0px" }}
            className="animable"
          ></path>
        </g>
        <path
          d="M302.25,397.17c0-1.82-.56-2.87-1.5-3a2.47,2.47,0,0,0-1.62.41c-1.82,1.1-2.9,3.3-2.94,6,0,2,0,3.94,0,6l-28.28,16.33,7-12.05c2.08-3.55,4.11-7,6.13-10.52,2.22-3.83,2.25-5.3.2-6.88-4-3.08-8-6.12-12-9.18-.58-.44-1.16-.91-1.94-1.55L296,366.2c.05.68.1,1.27.15,1.86.18,2.2,1.35,3,3.1,2a6.89,6.89,0,0,0,2.95-5.62c0-1.52,0-3,0-4.49s-.33-2.5-1-2.82-1.58-.07-2.92.71l-16.17,9.32-20.78,12a7,7,0,0,0-3.36,4c-.71,2.08-.1,3.07.84,3.79,2.15,1.62,4.28,3.27,6.41,4.91l10.42,8c-.39.71-.66,1.24-1,1.76l-15.52,27c-1.06,1.85-1.78,3.62-1.08,5a1.78,1.78,0,0,0,.57.68l.1.06,0,0c.71.37,1.69,0,2.81-.62L281.87,422l16.62-9.61a6.76,6.76,0,0,0,3.78-6.45C302.3,403,302.28,400.07,302.25,397.17Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "279.973px 395.751px 0px",
          }}
          id="elogo3fybamag"
          className="animable"
        ></path>
        <path
          d="M267.9,397.49q-7.75,13.5-15.52,27c-1.06,1.85-1.78,3.62-1.08,5a1.66,1.66,0,0,0,.73.77l6.58,4a1.78,1.78,0,0,1-.57-.68c-.7-1.39,0-3.16,1.08-5l15.52-27c.3-.52.57-1.05,1-1.76l-6.74-4.09C268.47,396.44,268.2,397,267.9,397.49Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "263.331px 414.995px 0px",
          }}
          id="eldz8xwd4t6ka"
          className="animable"
        ></path>
        <path
          d="M294.42,352.86l-.08.1c-.63-.25-1.55,0-2.84.74L275.34,363l-20.79,12a7,7,0,0,0-3.36,4c-.71,2.08-.1,3.07.84,3.78,2.15,1.63,4.28,3.28,6.42,4.92l10.41,8,6.74,4.09-10.42-8c-2.13-1.64-4.26-3.29-6.41-4.91-.94-.72-1.55-1.71-.84-3.79a7,7,0,0,1,3.36-4l20.78-12,16.17-9.32c1.34-.78,2.29-1,2.92-.71h0Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "276.02px 376.325px 0px",
          }}
          id="elfm1fs8tachm"
          className="animable"
        ></path>
        <path
          d="M275,410.84l-7,12.05,28.28-16.33-6.74-4.1Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "282.14px 412.675px 0px",
          }}
          id="elh8kpnuwn0qf"
          className="animable"
        ></path>
        <path
          d="M296.19,400.6c0-2.74,1.12-4.94,2.94-6a2.47,2.47,0,0,1,1.62-.41h0l-6-3.74a1.5,1.5,0,0,0-.49-.31h0a2.31,2.31,0,0,0-1.84.37c-1.82,1.1-2.9,3.3-2.94,6,0,2,0,3.94,0,5.95l6.74,4.1C296.2,404.54,296.17,402.58,296.19,400.6Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "295.115px 398.322px 0px",
          }}
          id="el7g1kcvo74jp"
          className="animable"
        ></path>
        <g id="elz2fx4d96nwh">
          <path
            d="M267.9,397.49q-7.75,13.5-15.52,27c-1.06,1.85-1.78,3.62-1.08,5a1.66,1.66,0,0,0,.73.77l6.58,4a1.78,1.78,0,0,1-.57-.68c-.7-1.39,0-3.16,1.08-5l15.52-27c.3-.52.57-1.05,1-1.76l-6.74-4.09C268.47,396.44,268.2,397,267.9,397.49Z"
            style={{
              opacity: "0.4",
              transformOrigin: "263.331px 414.995px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el13xh56t770y9">
          <path
            d="M294.42,352.86l-.08.1c-.63-.25-1.55,0-2.84.74L275.34,363l-20.79,12a7,7,0,0,0-3.36,4c-.71,2.08-.1,3.07.84,3.78,2.15,1.63,4.28,3.28,6.42,4.92l10.41,8,6.74,4.09-10.42-8c-2.13-1.64-4.26-3.29-6.41-4.91-.94-.72-1.55-1.71-.84-3.79a7,7,0,0,1,3.36-4l20.78-12,16.17-9.32c1.34-.78,2.29-1,2.92-.71h0Z"
            style={{
              opacity: "0.3",
              transformOrigin: "276.02px 376.325px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elx9i1hqgkqq">
          <path
            d="M275,410.84l-7,12.05,28.28-16.33-6.74-4.1Z"
            style={{
              opacity: "0.3",
              transformOrigin: "282.14px 412.675px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elrvjnwdz5msm">
          <path
            d="M296.19,400.6c0-2.74,1.12-4.94,2.94-6a2.47,2.47,0,0,1,1.62-.41h0l-6-3.74a1.5,1.5,0,0,0-.49-.31h0a2.31,2.31,0,0,0-1.84.37c-1.82,1.1-2.9,3.3-2.94,6,0,2,0,3.94,0,5.95l6.74,4.1C296.2,404.54,296.17,402.58,296.19,400.6Z"
            style={{
              opacity: "0.4",
              transformOrigin: "295.115px 398.322px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M86.74,113c2.58-4,4.78-8.24,7.1-12.42a7.51,7.51,0,0,0-4.43,1.19A16.52,16.52,0,0,0,87.68,103a21.42,21.42,0,0,0-7.11,12,10.37,10.37,0,0,0,0,3.73,8.37,8.37,0,0,0,1.18-.56A15.4,15.4,0,0,0,86.74,113Z"
          style={{ fill: "none", transformOrigin: "87.1205px 109.651px 0px" }}
          id="el903olnnh17n"
          className="animable"
        ></path>
        <path
          d="M115,98.55a13.44,13.44,0,0,0,5.21-5.89,20.52,20.52,0,0,0,2-9.78c-.21.11-.42.21-.64.34A17.76,17.76,0,0,0,118,86c-3.66,3.64-6.09,8.32-8.54,12.94-.14.26-.28.53-.41.8a8.06,8.06,0,0,0,1,.1A9.4,9.4,0,0,0,115,98.55Z"
          style={{ fill: "none", transformOrigin: "115.64px 91.361px 0px" }}
          id="elj2mbmf6cy4"
          className="animable"
        ></path>
        <path
          d="M107.88,104.7a5,5,0,0,1,1.73-1.94c1-.6,2.25-.41,3.86.46a8,8,0,0,0,3.6,1A9.22,9.22,0,0,0,122,102.9,13.41,13.41,0,0,0,127.2,97c2.66-5.51,2.78-12.38.24-14.45-1.16-1-3.1-.76-5.24.32a20.52,20.52,0,0,1-2,9.78A13.44,13.44,0,0,1,115,98.55,9.4,9.4,0,0,1,110,99.84a8.06,8.06,0,0,1-1-.1c-1.4,2.66-2.73,5.37-4.1,8l4,2.47h0C106.85,108.84,106.55,107,107.88,104.7Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "117.086px 96.063px 0px",
          }}
          id="el0he89vgf4r4"
          className="animable"
        ></path>
        <path
          d="M131.61,75.18c-1.8-1.18-4.29-1.33-7.55,0a22,22,0,0,0-2.94,1.42,26.82,26.82,0,0,0-9.14,9c-3.74,5.87-7,12.12-10.44,18.21C99,108.32,96.6,113,93.78,117.39a15.6,15.6,0,0,1-5,5.08,6.1,6.1,0,0,1-4.27.9c-2-.42-3.48-2.25-4-4.7a10.37,10.37,0,0,1,0-3.73,21.42,21.42,0,0,1,7.11-12,16.52,16.52,0,0,1,1.73-1.17,7.51,7.51,0,0,1,4.43-1.19,6.3,6.3,0,0,1,3.54,1.6,2,2,0,0,0,2.46.2,6.23,6.23,0,0,0,1.89-2c1.48-2.25,1.32-3.88.31-5.05-2.84-3.28-7.8-3.15-12.76-.28a26.86,26.86,0,0,0-7.47,6.6,37.15,37.15,0,0,0-6.31,12.16,19.5,19.5,0,0,0-.14,11.62,8.92,8.92,0,0,0,3.13,4.28,7,7,0,0,0,.74.46l.12.06c2.57,1.3,5.87,1,9.29-1a22.75,22.75,0,0,0,5.19-4.26,62.89,62.89,0,0,0,7.58-10.73c1.25-2.14,2.4-4.33,3.53-6.54,1.37-2.67,2.7-5.38,4.1-8,.13-.27.27-.54.41-.8,2.45-4.62,4.88-9.3,8.54-12.94a17.76,17.76,0,0,1,3.57-2.78c.22-.13.43-.23.64-.34,2.14-1.08,4.08-1.27,5.24-.32,2.54,2.07,2.42,8.94-.24,14.45A13.41,13.41,0,0,1,122,102.9a9.22,9.22,0,0,1-4.91,1.29,8,8,0,0,1-3.6-1c-1.61-.87-2.82-1.06-3.86-.46a5,5,0,0,0-1.73,1.94c-1.33,2.33-1,4.14,1,5.55l.36.23c3.49,2.1,7.54,2.17,12.12-.48a26.08,26.08,0,0,0,4.27-3.13c5.8-5.13,8.53-12,9.32-18.84C135.66,82.1,134.63,77.17,131.61,75.18Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "104.829px 102.627px 0px",
          }}
          id="elqam3qv3798p"
          className="animable"
        ></path>
        <path
          d="M100.23,93.89Z"
          style={{ fill: "none", transformOrigin: "100.23px 93.89px 0px" }}
          id="elwz0bbpnhbu"
          className="animable"
        ></path>
        <path
          d="M94.16,90.21h0c-2.92-2.41-7.41-2.07-11.91.53a27.19,27.19,0,0,0-7.47,6.61,37.35,37.35,0,0,0-6.31,12.16,19.6,19.6,0,0,0-.14,11.62,8.94,8.94,0,0,0,3.11,4.26h0l.2.12a4.94,4.94,0,0,0,.49.3l6.37,3.94a8.92,8.92,0,0,1-3.13-4.28,19.5,19.5,0,0,1,.14-11.62,37.15,37.15,0,0,1,6.31-12.16,26.86,26.86,0,0,1,7.47-6.6c4-2.33,8.06-2.85,11-1.21l-2-1.2Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "83.9038px 109.166px 0px",
          }}
          id="elxhiqqo5r8f"
          className="animable"
        ></path>
        <path
          d="M124.33,70.68h0c-1.78-1-4.19-1.13-7.31.11a22.18,22.18,0,0,0-3,1.43,26.76,26.76,0,0,0-9.13,9c-2.38,3.72-4.55,7.6-6.7,11.49l2,1.2h0l.33.2h0A7.18,7.18,0,0,1,102,95.38c1,1.17,1.17,2.8-.31,5.05a6.23,6.23,0,0,1-1.89,2,2,2,0,0,1-2.46-.2,6.3,6.3,0,0,0-3.54-1.6c-2.32,4.18-4.52,8.45-7.1,12.42a15.4,15.4,0,0,1-5,5.08,8.37,8.37,0,0,1-1.18.56c.47,2.45,1.91,4.28,4,4.7a6.1,6.1,0,0,0,4.27-.9,15.6,15.6,0,0,0,5-5.08c2.82-4.36,5.18-9.07,7.76-13.62,3.45-6.09,6.7-12.34,10.44-18.21a26.82,26.82,0,0,1,9.14-9,22,22,0,0,1,2.94-1.42c3.26-1.3,5.75-1.15,7.55,0h0Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "106.07px 96.6805px 0px",
          }}
          id="elz0njhbtvo4p"
          className="animable"
        ></path>
        <g id="el4j36k7nv3vc">
          <path
            d="M107.88,104.7a5,5,0,0,1,1.73-1.94c1-.6,2.25-.41,3.86.46a8,8,0,0,0,3.6,1A9.22,9.22,0,0,0,122,102.9,13.41,13.41,0,0,0,127.2,97c2.66-5.51,2.78-12.38.24-14.45-1.16-1-3.1-.76-5.24.32a20.52,20.52,0,0,1-2,9.78A13.44,13.44,0,0,1,115,98.55,9.4,9.4,0,0,1,110,99.84a8.06,8.06,0,0,1-1-.1c-1.4,2.66-2.73,5.37-4.1,8l4,2.47h0C106.85,108.84,106.55,107,107.88,104.7Z"
            style={{
              opacity: "0.3",
              transformOrigin: "117.086px 96.063px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elo7eewwqsjr">
          <path
            d="M94.16,90.21h0c-2.92-2.41-7.41-2.07-11.91.53a27.19,27.19,0,0,0-7.47,6.61,37.35,37.35,0,0,0-6.31,12.16,19.6,19.6,0,0,0-.14,11.62,8.94,8.94,0,0,0,3.11,4.26h0l.2.12a4.94,4.94,0,0,0,.49.3l6.37,3.94a8.92,8.92,0,0,1-3.13-4.28,19.5,19.5,0,0,1,.14-11.62,37.15,37.15,0,0,1,6.31-12.16,26.86,26.86,0,0,1,7.47-6.6c4-2.33,8.06-2.85,11-1.21l-2-1.2Z"
            style={{
              opacity: "0.3",
              transformOrigin: "83.9038px 109.166px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elbr31g7ekar4">
          <path
            d="M124.33,70.68h0c-1.78-1-4.19-1.13-7.31.11a22.18,22.18,0,0,0-3,1.43,26.76,26.76,0,0,0-9.13,9c-2.38,3.72-4.55,7.6-6.7,11.49l2,1.2h0l.33.2h0A7.18,7.18,0,0,1,102,95.38c1,1.17,1.17,2.8-.31,5.05a6.23,6.23,0,0,1-1.89,2,2,2,0,0,1-2.46-.2,6.3,6.3,0,0,0-3.54-1.6c-2.32,4.18-4.52,8.45-7.1,12.42a15.4,15.4,0,0,1-5,5.08,8.37,8.37,0,0,1-1.18.56c.47,2.45,1.91,4.28,4,4.7a6.1,6.1,0,0,0,4.27-.9,15.6,15.6,0,0,0,5-5.08c2.82-4.36,5.18-9.07,7.76-13.62,3.45-6.09,6.7-12.34,10.44-18.21a26.82,26.82,0,0,1,9.14-9,22,22,0,0,1,2.94-1.42c3.26-1.3,5.75-1.15,7.55,0h0Z"
            style={{
              opacity: "0.3",
              transformOrigin: "106.07px 96.6805px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M100.23,93.89l.32.21h0Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "100.39px 93.995px 0px",
          }}
          id="elckek1wmi53o"
          className="animable"
        ></path>
        <path
          d="M368.67,69.05A5.64,5.64,0,0,1,370,70.16a7.6,7.6,0,0,1,1.72,3.16l6.68,25.9,4.92-16.65L379.8,68.85a7.75,7.75,0,0,0-1.72-3.17,5.89,5.89,0,0,0-1.35-1.11,3.21,3.21,0,0,0-1.21-.43l-11.15-1.28-8.06,4.48,11.15,1.28A3.05,3.05,0,0,1,368.67,69.05Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "369.815px 81.04px 0px",
          }}
          id="elxxt4205ivi"
          className="animable"
        ></path>
        <path
          d="M381.83,114.54a1.87,1.87,0,0,1-.73,1.06l7.66-4.27h0a1.77,1.77,0,0,0,1.13-1.26L402,69.12l-5.75-3.32Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "391.55px 90.7px 0px",
          }}
          id="elsova1kli4jj"
          className="animable"
        ></path>
        <path
          d="M393.79,56.9l30.44,17.58L432.29,70,401.84,52.42a2.45,2.45,0,0,0-2-.33h0l-.07,0a1.87,1.87,0,0,0-.31.17l-7.82,4.34A2.33,2.33,0,0,1,393.79,56.9Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "411.965px 63.2429px 0px",
          }}
          id="eld7nuoghn9s"
          className="animable"
        ></path>
        <path
          d="M380.83,115.75l.12-.06-.12,0Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "380.89px 115.72px 0px",
          }}
          id="elyufk1n2knu"
          className="animable"
        ></path>
        <path
          d="M391.33,56.77h0l0,0Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "391.33px 56.77px 0px",
          }}
          id="eliv9vewmv8r"
          className="animable"
        ></path>
        <polygon
          points="414.25 94.56 405.86 89.72 397.81 94.2 406.19 99.04 414.25 94.56"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "406.03px 94.38px 0px",
          }}
          id="ell4jrefmww1a"
          className="animable"
        ></polygon>
        <polygon
          points="409.93 107.38 413.87 103.47 417.37 101.53 414.25 94.56 406.19 99.04 409.93 107.38"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "411.78px 100.97px 0px",
          }}
          id="elkegn8lkljxl"
          className="animable"
        ></polygon>
        <path
          d="M393.79,56.9a2.33,2.33,0,0,0-2.21-.27l-.21.11,0,0a2,2,0,0,0-.69,1l-7.31,24.77-4.92,16.65-6.68-25.9A7.6,7.6,0,0,0,370,70.16a5.64,5.64,0,0,0-1.35-1.11,3.05,3.05,0,0,0-1.21-.43l-11.15-1.28,2.41,8.34,8,.92,8.92,34.57a7.23,7.23,0,0,0,3.16,4.32,2.33,2.33,0,0,0,2,.25l.12,0,.15-.09a1.87,1.87,0,0,0,.73-1.06L396.22,65.8,402,69.12,424.21,82l0-7.48Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "390.25px 86.1636px 0px",
          }}
          id="elfqsvdbqlvtp"
          className="animable"
        ></path>
        <polygon
          points="421.74 108.02 413.87 103.47 409.93 107.38 406.19 99.04 397.81 94.2 405.61 110.92 397.5 118.46 405.57 123.12 409.66 119.08 413.45 127.67 421.95 132.58 413.87 115.38 421.74 108.02"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "409.725px 113.39px 0px",
          }}
          id="elm9un4o6mzz"
          className="animable"
        ></polygon>
        <polygon
          points="424.23 74.48 424.21 81.96 432.27 77.49 432.29 70 424.23 74.48"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "428.25px 75.98px 0px",
          }}
          id="elevmml5qe8yd"
          className="animable"
        ></polygon>
        <polygon
          points="421.74 108.02 429.8 103.54 421.93 99 417.37 101.53 413.87 103.47 421.74 108.02"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "421.835px 103.51px 0px",
          }}
          id="elgq2g0bwzk3d"
          className="animable"
        ></polygon>
        <g id="elrvh6fx08gwd">
          <path
            d="M368.67,69.05A5.64,5.64,0,0,1,370,70.16a7.6,7.6,0,0,1,1.72,3.16l6.68,25.9,4.92-16.65L379.8,68.85a7.75,7.75,0,0,0-1.72-3.17,5.89,5.89,0,0,0-1.35-1.11,3.21,3.21,0,0,0-1.21-.43l-11.15-1.28-8.06,4.48,11.15,1.28A3.05,3.05,0,0,1,368.67,69.05Z"
            style={{ opacity: "0.2", transformOrigin: "369.815px 81.04px 0px" }}
            className="animable"
          ></path>
        </g>
        <g id="el23xgi3wlet2">
          <path
            d="M381.83,114.54a1.87,1.87,0,0,1-.73,1.06l7.66-4.27h0a1.77,1.77,0,0,0,1.13-1.26L402,69.12l-5.75-3.32Z"
            style={{ opacity: "0.2", transformOrigin: "391.55px 90.7px 0px" }}
            className="animable"
          ></path>
        </g>
        <g id="eldltk362cqag">
          <path
            d="M393.79,56.9l30.44,17.58L432.29,70,401.84,52.42a2.45,2.45,0,0,0-2-.33h0l-.07,0a1.87,1.87,0,0,0-.31.17l-7.82,4.34A2.33,2.33,0,0,1,393.79,56.9Z"
            style={{
              opacity: "0.2",
              transformOrigin: "411.965px 63.2429px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elqglbilavpd">
          <path
            d="M380.83,115.75l.12-.06-.12,0Z"
            style={{ opacity: "0.2", transformOrigin: "380.89px 115.72px 0px" }}
            className="animable"
          ></path>
        </g>
        <g id="elvewqu7x391l">
          <path
            d="M391.33,56.77h0l0,0Z"
            style={{ opacity: "0.2", transformOrigin: "391.33px 56.77px 0px" }}
            className="animable"
          ></path>
        </g>
        <g id="elq1szuaqi0d">
          <polygon
            points="414.25 94.56 405.86 89.72 397.81 94.2 406.19 99.04 414.25 94.56"
            style={{ opacity: "0.2", transformOrigin: "406.03px 94.38px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="elmtayc1u2x7e">
          <polygon
            points="421.74 108.02 429.8 103.54 421.93 99 417.37 101.53 413.87 103.47 421.74 108.02"
            style={{
              opacity: "0.2",
              transformOrigin: "421.835px 103.51px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="413.87 115.38 421.93 110.9 429.8 103.54 421.74 108.02 413.87 115.38"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "421.835px 109.46px 0px",
          }}
          id="el19opine5l2kj"
          className="animable"
        ></polygon>
        <g id="elgvq7x267yd4">
          <polygon
            points="413.87 115.38 421.93 110.9 429.8 103.54 421.74 108.02 413.87 115.38"
            style={{
              opacity: "0.4",
              transformOrigin: "421.835px 109.46px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="413.87 115.38 421.95 132.58 430.01 128.1 421.93 110.9 413.87 115.38"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "421.94px 121.74px 0px",
          }}
          id="elr0ljlmniu6a"
          className="animable"
        ></polygon>
        <g id="eluo2oxhbbpdl">
          <polygon
            points="409.93 107.38 413.87 103.47 417.37 101.53 414.25 94.56 406.19 99.04 409.93 107.38"
            style={{ opacity: "0.3", transformOrigin: "411.78px 100.97px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="elqboyk1m9d4">
          <polygon
            points="424.23 74.48 424.21 81.96 432.27 77.49 432.29 70 424.23 74.48"
            style={{ opacity: "0.3", transformOrigin: "428.25px 75.98px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="elzctl3bm8gj9">
          <polygon
            points="413.87 115.38 421.95 132.58 430.01 128.1 421.93 110.9 413.87 115.38"
            style={{ opacity: "0.3", transformOrigin: "421.94px 121.74px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="434.65 371.13 423.39 364.58 420.8 366.07 420.84 379.11 434.65 371.13"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "427.725px 371.845px 0px",
          }}
          id="eloocxd21p5l"
          className="animable"
        ></polygon>
        <polygon
          points="397.06 406.56 397.07 409.03 408.34 415.58 408.3 400.08 397.06 406.56"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "402.7px 407.83px 0px",
          }}
          id="eluq4tdrp7d5"
          className="animable"
        ></polygon>
        <polygon
          points="408.21 370.88 396.94 364.33 396.99 379.82 408.26 386.37 408.21 370.88"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "402.6px 375.35px 0px",
          }}
          id="elar9b4aq5tm5"
          className="animable"
        ></polygon>
        <polygon
          points="420.8 363.62 409.53 357.07 396.94 364.33 408.21 370.88 420.8 363.62"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "408.87px 363.975px 0px",
          }}
          id="el9psmvy3gkv9"
          className="animable"
        ></polygon>
        <polygon
          points="434.69 384.84 434.65 371.13 420.84 379.11 420.8 366.07 420.8 363.62 408.21 370.88 408.26 386.37 394.36 394.4 394.4 408.1 397.06 406.56 408.3 400.08 408.34 415.58 420.92 408.31 420.88 392.82 434.69 384.84"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "414.525px 389.6px 0px",
          }}
          id="ela5h0k5aaebf"
          className="animable"
        ></polygon>
        <polygon
          points="383.09 387.85 383.13 401.56 394.4 408.1 394.36 394.4 383.09 387.85"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "388.745px 397.975px 0px",
          }}
          id="elnqw8xsra6jj"
          className="animable"
        ></polygon>
        <polygon
          points="408.26 386.37 396.99 379.82 383.09 387.85 394.36 394.4 408.26 386.37"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "395.675px 387.11px 0px",
          }}
          id="el227kwzpen0y"
          className="animable"
        ></polygon>
        <g id="elylbl2th5tz">
          <polygon
            points="434.65 371.13 423.39 364.58 420.8 366.07 420.84 379.11 434.65 371.13"
            style={{
              opacity: "0.2",
              transformOrigin: "427.725px 371.845px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="el2ahz6vjnkce">
          <polygon
            points="397.06 406.56 397.07 409.03 408.34 415.58 408.3 400.08 397.06 406.56"
            style={{ opacity: "0.3", transformOrigin: "402.7px 407.83px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="eldzxwlv5i4sh">
          <polygon
            points="408.21 370.88 396.94 364.33 396.99 379.82 408.26 386.37 408.21 370.88"
            style={{ opacity: "0.3", transformOrigin: "402.6px 375.35px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="elblcu2wcpqrl">
          <polygon
            points="420.8 363.62 409.53 357.07 396.94 364.33 408.21 370.88 420.8 363.62"
            style={{
              opacity: "0.2",
              transformOrigin: "408.87px 363.975px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="elwbb9ro3e7er">
          <polygon
            points="383.09 387.85 383.13 401.56 394.4 408.1 394.36 394.4 383.09 387.85"
            style={{
              opacity: "0.3",
              transformOrigin: "388.745px 397.975px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="el8pbk6k06hqc">
          <polygon
            points="408.26 386.37 396.99 379.82 383.09 387.85 394.36 394.4 408.26 386.37"
            style={{
              opacity: "0.2",
              transformOrigin: "395.675px 387.11px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <path
          d="M303.52,292.1l-6.4-3.71-.16-.1-.23-.13h0c-1.75-.87-4.12-.54-6.83,1-5.73,3.31-9.94,10.42-9.92,18.16,0,3.81,1,6.26,2.73,7.4h0l.05,0,.23.13,6.95,4,2.45-2.43,8.81-5.65,3.19-10.38Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "292.185px 303.269px 0px",
          }}
          id="ely7t1e30ulzm"
          className="animable"
        ></path>
        <polygon
          points="285.18 271.22 292.18 275.25 300.19 270.62 293.2 266.59 285.18 271.22"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "292.685px 270.92px 0px",
          }}
          id="elo6mjb8kkt2"
          className="animable"
        ></polygon>
        <polygon
          points="285.18 271.22 292.18 275.25 265.71 335.37 258.72 331.34 285.18 271.22"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "275.45px 303.295px 0px",
          }}
          id="elujir1uhs7pj"
          className="animable"
        ></polygon>
        <g id="elmrjiz93cb4i">
          <path
            d="M303.52,292.1l-6.4-3.71-.16-.1-.23-.13h0c-1.75-.87-4.12-.54-6.83,1-5.73,3.31-9.94,10.42-9.92,18.16,0,3.81,1,6.26,2.73,7.4h0l.05,0,.23.13,6.95,4,2.45-2.43,8.81-5.65,3.19-10.38Z"
            style={{
              opacity: "0.3",
              transformOrigin: "292.185px 303.269px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el183roa8w7ed">
          <polygon
            points="285.18 271.22 292.18 275.25 300.19 270.62 293.2 266.59 285.18 271.22"
            style={{
              opacity: "0.2",
              transformOrigin: "292.685px 270.92px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="elzxdrmeqqt2">
          <polygon
            points="285.18 271.22 292.18 275.25 265.71 335.37 258.72 331.34 285.18 271.22"
            style={{
              opacity: "0.3",
              transformOrigin: "275.45px 303.295px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <path
          d="M306.93,299.84c0,7.8-4.2,14.85-10,18.19s-10,1.15-10-6.65,4.19-14.85,9.92-18.16S306.91,292.1,306.93,299.84Zm-13.3,7.68c0,4.54,1.51,5.46,3.3,4.43s3.27-3.68,3.26-8.22-1.41-5.53-3.3-4.43-3.28,3.68-3.26,8.22"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "296.93px 305.634px 0px",
          }}
          id="elxhy3n2v621n"
          className="animable"
        ></path>
        <polygon
          points="292.18 275.25 300.19 270.62 273.72 330.75 265.71 335.37 292.18 275.25"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "282.95px 302.995px 0px",
          }}
          id="elo22fu8jw2ys"
          className="animable"
        ></polygon>
        <path
          d="M275.78,286.85l-6.39-3.7-.17-.1-.23-.13h0c-1.76-.87-4.13-.55-6.84,1-5.73,3.31-9.94,10.42-9.92,18.16,0,3.8,1,6.26,2.74,7.4h0l.06,0,.22.12,7,4,2.45-2.43,8.81-5.65,3.19-10.38Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "264.465px 298.022px 0px",
          }}
          id="el4bxgoto1lgt"
          className="animable"
        ></path>
        <g id="el154f5ylx0rv">
          <path
            d="M275.78,286.85l-6.39-3.7-.17-.1-.23-.13h0c-1.76-.87-4.13-.55-6.84,1-5.73,3.31-9.94,10.42-9.92,18.16,0,3.8,1,6.26,2.74,7.4h0l.06,0,.22.12,7,4,2.45-2.43,8.81-5.65,3.19-10.38Z"
            style={{
              opacity: "0.3",
              transformOrigin: "264.465px 298.022px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M279.19,294.6c0,7.8-4.2,14.84-10,18.18s-10,1.15-10-6.65,4.19-14.84,9.93-18.15S279.17,286.86,279.19,294.6Zm-13.3,7.68c0,4.54,1.52,5.46,3.3,4.43s3.28-3.68,3.26-8.22-1.4-5.53-3.3-4.44-3.27,3.69-3.26,8.23"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "269.19px 300.389px 0px",
          }}
          id="el39xxj8p7crh"
          className="animable"
        ></path>
        <path
          d="M109.16,393.55,104.84,391l-.12-.06-.15-.09h0c-1.19-.59-2.79-.37-4.62.69a14.32,14.32,0,0,0-6.7,12.26c0,2.57.7,4.23,1.85,5h0l0,0,.15.09,4.7,2.71,1.65-1.64,5.95-3.81,2.16-7Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "101.48px 401.065px 0px",
          }}
          id="elua8ofaiy77c"
          className="animable"
        ></path>
        <g id="elp3pc6tsb7ja">
          <path
            d="M109.16,393.55,104.84,391l-.12-.06-.15-.09h0c-1.19-.59-2.79-.37-4.62.69a14.32,14.32,0,0,0-6.7,12.26c0,2.57.7,4.23,1.85,5h0l0,0,.15.09,4.7,2.71,1.65-1.64,5.95-3.81,2.16-7Z"
            style={{
              opacity: "0.3",
              transformOrigin: "101.48px 401.065px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M111.46,398.78a14.3,14.3,0,0,1-6.75,12.28c-3.87,2.24-6.73.78-6.75-4.49a14.31,14.31,0,0,1,6.71-12.26C108.57,392.05,111.44,393.55,111.46,398.78Zm-9,5.19c0,3.06,1,3.68,2.23,3s2.22-2.49,2.21-5.55-1-3.74-2.23-3-2.22,2.49-2.21,5.56"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "104.71px 402.682px 0px",
          }}
          id="elslafa2pgpl"
          className="animable"
        ></path>
        <polygon
          points="125.86 370.82 86.45 393.65 86.48 403.07 125.88 380.25 125.86 370.82"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "106.165px 386.945px 0px",
          }}
          id="el715hgcgh713"
          className="animable"
        ></polygon>
        <polygon
          points="78.84 389.15 78.87 398.57 86.48 403.07 86.45 393.65 78.84 389.15"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "82.66px 396.11px 0px",
          }}
          id="el34n4pg897pf"
          className="animable"
        ></polygon>
        <polygon
          points="125.86 370.82 118.25 366.32 78.84 389.15 86.45 393.65 125.86 370.82"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "102.35px 379.985px 0px",
          }}
          id="elz755736gxj"
          className="animable"
        ></polygon>
        <g id="el6j70urojs5">
          <polygon
            points="78.84 389.15 78.87 398.57 86.48 403.07 86.45 393.65 78.84 389.15"
            style={{ opacity: "0.3", transformOrigin: "82.66px 396.11px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="ell80x54vguor">
          <polygon
            points="125.86 370.82 118.25 366.32 78.84 389.15 86.45 393.65 125.86 370.82"
            style={{
              opacity: "0.2",
              transformOrigin: "102.35px 379.985px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <path
          d="M109.16,363.47,104.84,361l-.12-.06-.15-.09h0c-1.19-.58-2.79-.36-4.62.69a14.35,14.35,0,0,0-6.7,12.27c0,2.57.7,4.23,1.85,5h0l0,0,.15.09,4.7,2.71,1.65-1.64,5.95-3.82,2.16-7Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "101.48px 371.073px 0px",
          }}
          id="el8ab4tg7n713"
          className="animable"
        ></path>
        <g id="elg2utc81c41n">
          <path
            d="M109.16,363.47,104.84,361l-.12-.06-.15-.09h0c-1.19-.58-2.79-.36-4.62.69a14.35,14.35,0,0,0-6.7,12.27c0,2.57.7,4.23,1.85,5h0l0,0,.15.09,4.7,2.71,1.65-1.64,5.95-3.82,2.16-7Z"
            style={{
              opacity: "0.3",
              transformOrigin: "101.48px 371.073px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M111.46,368.7A14.3,14.3,0,0,1,104.71,381c-3.87,2.23-6.73.78-6.75-4.49a14.34,14.34,0,0,1,6.71-12.27C108.57,362,111.44,363.47,111.46,368.7Zm-9,5.18c0,3.07,1,3.69,2.23,3s2.22-2.48,2.21-5.55-1-3.73-2.23-3-2.22,2.49-2.21,5.55"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "104.71px 372.618px 0px",
          }}
          id="ellh49mbu86t"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Blackboard--inject-26"
        style={{ transformOrigin: "188.64px 190.62px 0px" }}
        className="animable"
      >
        <path
          d="M327.66,38l.27.13a1.92,1.92,0,0,0-.25-.12Z"
          style={{ fill: "none", transformOrigin: "327.795px 38.065px 0px" }}
          id="el5t1h1oyoftt"
          className="animable"
        ></path>
        <path
          d="M322.59,38.43l.11,0-.11,0Z"
          style={{ fill: "none", transformOrigin: "322.645px 38.43px 0px" }}
          id="elsh2kku06nes"
          className="animable"
        ></path>
        <path
          d="M64.07,188.8l.27-.31h0Z"
          style={{ fill: "none", transformOrigin: "64.205px 188.645px 0px" }}
          id="elase5d4ht5yr"
          className="animable"
        ></path>
        <path
          d="M324.49,37.83l.18,0-.17,0Z"
          style={{ fill: "none", transformOrigin: "324.58px 37.83px 0px" }}
          id="eli2fqr92yzho"
          className="animable"
        ></path>
        <path
          d="M63.15,189.94c.07-.1.16-.2.24-.3-.08.1-.17.2-.24.3Z"
          style={{ fill: "none", transformOrigin: "63.27px 189.79px 0px" }}
          id="el0exh4f7testc"
          className="animable"
        ></path>
        <path
          d="M326.07,37.71a1.86,1.86,0,0,1,.33,0,1.75,1.75,0,0,0-.32,0Z"
          style={{ fill: "none", transformOrigin: "326.235px 37.7063px 0px" }}
          id="eljrhglc8n76"
          className="animable"
        ></path>
        <path
          d="M327,37.83l.25.07a1.41,1.41,0,0,0-.22-.06Z"
          style={{ fill: "none", transformOrigin: "327.125px 37.865px 0px" }}
          id="el1lvjv1vphe3"
          className="animable"
        ></path>
        <path
          d="M325.3,37.72h0Z"
          style={{ fill: "none", transformOrigin: "325.3px 37.72px 0px" }}
          id="elihfw9vss56e"
          className="animable"
        ></path>
        <path
          d="M323.66,38l.08,0-.07,0Z"
          style={{ fill: "none", transformOrigin: "323.7px 38px 0px" }}
          id="el58me2dq6v8f"
          className="animable"
        ></path>
        <path
          d="M62.78,190.45l.09-.14h0Z"
          style={{ fill: "none", transformOrigin: "62.825px 190.38px 0px" }}
          id="elhccfegtwesf"
          className="animable"
        ></path>
        <path
          d="M58.86,200a.77.77,0,0,1,0-.15h0A.77.77,0,0,0,58.86,200Z"
          style={{ fill: "none", transformOrigin: "58.8582px 199.925px 0px" }}
          id="elm0st9suyt9"
          className="animable"
        ></path>
        <path
          d="M59.24,198c0-.13.07-.26.1-.39,0,.13-.07.26-.1.39Z"
          style={{ fill: "none", transformOrigin: "59.29px 197.805px 0px" }}
          id="el0o6c25zt0c39"
          className="animable"
        ></path>
        <path
          d="M59.55,196.9c.07-.25.16-.5.24-.74-.08.24-.17.49-.24.74Z"
          style={{ fill: "none", transformOrigin: "59.67px 196.53px 0px" }}
          id="elcc70vhu1zs6"
          className="animable"
        ></path>
        <path
          d="M60.59,194.22l.27-.58h0Z"
          style={{ fill: "none", transformOrigin: "60.725px 193.93px 0px" }}
          id="elyqibw7lesj"
          className="animable"
        ></path>
        <path
          d="M61.58,192.3h0c.2-.34.41-.68.62-1h0C62,191.62,61.78,192,61.58,192.3Z"
          style={{ fill: "none", transformOrigin: "61.89px 191.8px 0px" }}
          id="elrtmx86eo48l"
          className="animable"
        ></path>
        <path
          d="M61.3,192.81c.06-.11.12-.23.19-.34h0C61.42,192.58,61.36,192.7,61.3,192.81Z"
          style={{ fill: "none", transformOrigin: "61.395px 192.64px 0px" }}
          id="eldig8bkhoblo"
          className="animable"
        ></path>
        <path
          d="M323.77,194.94h0l.05-.07h0Z"
          style={{ fill: "none", transformOrigin: "323.795px 194.905px 0px" }}
          id="el2f0fahg26q"
          className="animable"
        ></path>
        <path
          d="M309.21,188.58a1.71,1.71,0,0,0,.2-.18,4.47,4.47,0,0,0,.45-.42l.12-.12a7.91,7.91,0,0,0,.52-.63l.05-.07a8.32,8.32,0,0,0,.5-.76v0c.15-.27.29-.55.42-.83v0a7.63,7.63,0,0,0,.31-.84.25.25,0,0,1,0-.07,7.74,7.74,0,0,0,.18-.77s0-.09,0-.13a5.79,5.79,0,0,0,.07-.82l-.38-131.12L68.49,192.21a7.82,7.82,0,0,0-3.55,6.14l.37,131.12L308.54,189.05A5.81,5.81,0,0,0,309.21,188.58Z"
          style={{ fill: "none", transformOrigin: "188.485px 190.645px 0px" }}
          id="el04l1bv5mqsle"
          className="animable"
        ></path>
        <path
          d="M325.07,192.38l0,0h0Z"
          style={{ fill: "none", transformOrigin: "325.07px 192.38px 0px" }}
          id="elf2w1rr7qw0g"
          className="animable"
        ></path>
        <path
          d="M323.22,195.59l0,0h0Z"
          style={{ fill: "none", transformOrigin: "323.22px 195.59px 0px" }}
          id="eljqzt3bxymg"
          className="animable"
        ></path>
        <polygon
          points="324.31 194.11 324.32 194.11 324.31 194.11 324.31 194.11"
          style={{ fill: "none", transformOrigin: "324.315px 194.11px 0px" }}
          id="el6t5wr2vkt5n"
          className="animable"
        ></polygon>
        <path
          d="M324.88,47.53c0-.06,0-.12,0-.18a2.83,2.83,0,0,0-.14-.44,1,1,0,0,0-.07-.15,2,2,0,0,0-.29-.45,1.35,1.35,0,0,0-.19-.16,2.33,2.33,0,0,0-2.77.05l-9.67,5.58.38,131.12a5.79,5.79,0,0,1-.07.82s0,.08,0,.13a7.74,7.74,0,0,1-.18.77.25.25,0,0,0,0,.07,7.63,7.63,0,0,1-.31.84v0c-.13.28-.27.56-.42.83v0a8.32,8.32,0,0,1-.5.76l-.05.07a7.91,7.91,0,0,1-.52.63l-.12.12a4.47,4.47,0,0,1-.45.42,1.71,1.71,0,0,1-.2.18,5.81,5.81,0,0,1-.67.47l13.27,7.71a7.37,7.37,0,0,0,.67-.47c.07,0,.13-.12.2-.18s.3-.27.45-.42l.09-.1,0,0h0c.18-.2.35-.41.52-.63h0l.05-.07h0a8.25,8.25,0,0,0,.49-.76h0v0c.15-.27.29-.55.42-.83v0a6.39,6.39,0,0,0,.31-.83v-.08h0a7.64,7.64,0,0,0,.17-.77l0-.13a5.76,5.76,0,0,0,.06-.82L325,48.24A3.88,3.88,0,0,0,324.88,47.53Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "316.99px 121.219px 0px",
          }}
          id="elp7sbsuovia"
          className="animable"
        ></path>
        <g id="elg7cmo2568yc">
          <path
            d="M324.88,47.53c0-.06,0-.12,0-.18a2.83,2.83,0,0,0-.14-.44,1,1,0,0,0-.07-.15,2,2,0,0,0-.29-.45,1.35,1.35,0,0,0-.19-.16,2.33,2.33,0,0,0-2.77.05l-9.67,5.58.38,131.12a5.79,5.79,0,0,1-.07.82s0,.08,0,.13a7.74,7.74,0,0,1-.18.77.25.25,0,0,0,0,.07,7.63,7.63,0,0,1-.31.84v0c-.13.28-.27.56-.42.83v0a8.32,8.32,0,0,1-.5.76l-.05.07a7.91,7.91,0,0,1-.52.63l-.12.12a4.47,4.47,0,0,1-.45.42,1.71,1.71,0,0,1-.2.18,5.81,5.81,0,0,1-.67.47l13.27,7.71a7.37,7.37,0,0,0,.67-.47c.07,0,.13-.12.2-.18s.3-.27.45-.42l.09-.1,0,0h0c.18-.2.35-.41.52-.63h0l.05-.07h0a8.25,8.25,0,0,0,.49-.76h0v0c.15-.27.29-.55.42-.83v0a6.39,6.39,0,0,0,.31-.83v-.08h0a7.64,7.64,0,0,0,.17-.77l0-.13a5.76,5.76,0,0,0,.06-.82L325,48.24A3.88,3.88,0,0,0,324.88,47.53Z"
            style={{
              opacity: "0.4",
              transformOrigin: "316.99px 121.219px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M308.54,189.05,65.31,329.47l0,11.21v.05a4.17,4.17,0,0,0,0,.52c0,.15,0,.3.08.43s.07.21.1.31.07.17.11.24a1.64,1.64,0,0,0,.14.22l.11.16a1.19,1.19,0,0,0,.2.19l.2.16.06.05.07,0,.11,0,.12,0a1.45,1.45,0,0,0,.22.09h.6l.16,0a1.59,1.59,0,0,0,.3-.06h0l.16,0c.08,0,.17-.08.26-.11a4.61,4.61,0,0,0,.52-.23l252.89-146Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "193.511px 266.075px 0px",
          }}
          id="elk9gc7ozreq"
          className="animable"
        ></path>
        <g id="elgqhln8tte6">
          <path
            d="M308.54,189.05,65.31,329.47l0,11.21v.05a4.17,4.17,0,0,0,0,.52c0,.15,0,.3.08.43s.07.21.1.31.07.17.11.24a1.64,1.64,0,0,0,.14.22l.11.16a1.19,1.19,0,0,0,.2.19l.2.16.06.05.07,0,.11,0,.12,0a1.45,1.45,0,0,0,.22.09h.6l.16,0a1.59,1.59,0,0,0,.3-.06h0l.16,0c.08,0,.17-.08.26-.11a4.61,4.61,0,0,0,.52-.23l252.89-146Z"
            style={{
              opacity: "0.3",
              transformOrigin: "193.511px 266.075px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M314.75,42.34c2-1.13,3.56-.22,3.56,2l.41,142.38a7.85,7.85,0,0,1-3.55,6.14L62.29,338.9c-2,1.14-3.57.23-3.58-2l-.4-142.38a7.82,7.82,0,0,1,3.55-6.14Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "188.515px 190.623px 0px",
          }}
          id="elmxuk29liwdc"
          className="animable"
        ></path>
        <g id="elkdo4859soua">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: "188.515px 190.623px 0px",
            }}
            className="animable"
          >
            <path
              d="M314.75,42.34c2-1.13,3.56-.22,3.56,2l.41,142.38a7.85,7.85,0,0,1-3.55,6.14L62.29,338.9c-2,1.14-3.57.23-3.58-2l-.4-142.38a7.82,7.82,0,0,1,3.55-6.14Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "188.515px 190.623px 0px",
              }}
              id="elgfkrikqoful"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M61.05,349.88c-.08-.08-.17-.15-.25-.24s-.18-.24-.27-.35-.15-.19-.22-.3a2.71,2.71,0,0,1-.23-.41,3.47,3.47,0,0,1-.18-.33c-.08-.15-.13-.33-.2-.49s-.09-.23-.13-.35-.1-.38-.15-.57-.07-.24-.1-.37-.06-.43-.09-.65,0-.25-.06-.38c0-.36-.05-.73-.05-1.12L58.71,202c0-.31,0-.62,0-.93s0-.53.08-.79h0l0-.27a.77.77,0,0,1,0-.15h0c0-.26.08-.52.13-.78s.07-.35.11-.53.08-.34.12-.5h0c0-.13.07-.26.1-.39s0-.21.08-.31.09-.27.13-.4h0c.07-.25.16-.5.24-.74l0,0h0l.12-.32c.13-.36.27-.72.43-1.08a.61.61,0,0,0,0-.12l.18-.37.27-.58h0l.15-.29c.09-.18.19-.36.29-.54s.12-.23.19-.34h0l.09-.17h0c.2-.34.41-.68.62-1h0l.19-.28.39-.56.09-.14h0l.28-.37h0c.07-.1.16-.2.24-.3s.13-.17.2-.26.25-.31.38-.46h0l.1-.12.27-.3h0c.21-.23.43-.47.65-.69l.42-.42h0l.33-.31h0l.44-.38.11-.1.34-.28h0l.42-.31.19-.15.3-.21h0q.46-.33.93-.6L321.36,39a11.68,11.68,0,0,1,1.23-.61h0l.11,0,.27-.11c.24-.09.47-.17.69-.23h0l.07,0,.36-.1.39-.08h0l.17,0,.35,0,.28,0h.78a1.75,1.75,0,0,1,.32,0,2.7,2.7,0,0,1,.41,0l.14,0h0a1.41,1.41,0,0,1,.22.06l.32.09.14,0h0a1.92,1.92,0,0,1,.25.12c.13.06.26.11.38.18h0l-13.27-7.71-.05,0a4.59,4.59,0,0,0-.5-.24l-.09,0-.17-.06-.25-.09-.29-.06-.17,0-.09,0a3.81,3.81,0,0,0-.59-.07h0a.65.65,0,0,0-.14,0,3.69,3.69,0,0,0-.47,0l-.16,0c-.1,0-.2,0-.3,0a2.48,2.48,0,0,0-.27,0l-.25.05-.4.08-.21.05-.22.07-.69.24-.25.09-.14.07a11.68,11.68,0,0,0-1.23.61l-252.88,146c-.32.19-.63.39-.94.6l-.29.21c-.21.15-.42.3-.62.46l-.34.28-.55.48-.33.31-.21.2-.2.22c-.23.23-.44.46-.66.69-.06.08-.14.15-.2.23s-.11.13-.17.2l-.38.46-.25.3-.19.26-.27.37-.19.26-.3.44-.19.29a.76.76,0,0,1-.08.11c-.17.28-.34.55-.5.83l0,.06a1,1,0,0,0-.1.17c-.11.2-.23.39-.33.6l-.15.28-.15.29-.12.26c-.11.23-.22.46-.32.69l-.06.12v0c-.13.29-.25.58-.36.88l-.06.16-.12.32c0,.15-.11.29-.15.44s-.07.23-.11.34l-.12.41a1.83,1.83,0,0,0-.08.25c0,.15-.07.3-.11.45l-.12.5c0,.05,0,.11,0,.17s0,.24-.07.36-.09.52-.13.78c0,.07,0,.15,0,.22s0,.13,0,.2a14.32,14.32,0,0,0-.11,1.72l.4,142.37c0,2.71.84,4.71,2.23,5.85a5.47,5.47,0,0,0,.63.44L62,350.61l-.32-.23-.29-.2C61.25,350.09,61.15,350,61.05,349.88Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "186.885px 190.346px 0px",
          }}
          id="elvthcgn4uj7"
          className="animable"
        ></path>
        <path
          d="M331.18,44.64c0-3.1-1.1-5.28-2.87-6.29-.12-.07-.25-.12-.38-.18l-.27-.13-.14,0-.32-.09-.25-.07-.14,0a2.7,2.7,0,0,0-.41,0,1.86,1.86,0,0,0-.33,0h-.77l-.28,0-.35,0-.18,0-.39.08-.36.1-.08,0c-.22.06-.45.14-.69.23l-.27.11-.11,0a11.68,11.68,0,0,0-1.23.61L68.47,185q-.47.27-.93.6h0l-.3.21-.19.15-.42.31h0l-.34.28-.11.1-.44.38h0l-.33.31h0l-.42.42c-.22.22-.44.46-.65.69l-.27.31-.1.12h0c-.13.15-.26.3-.38.46s-.14.17-.2.26-.17.2-.24.3l-.28.37-.09.14-.39.56-.19.28c-.21.33-.42.67-.62,1l-.09.17c-.07.11-.13.23-.19.34s-.2.36-.29.54l-.15.29-.27.58-.18.37a.61.61,0,0,1,0,.12c-.16.36-.3.72-.43,1.08l-.12.32h0l0,0c-.08.24-.17.49-.24.74s-.09.26-.13.4-.05.21-.08.31-.07.26-.1.39-.09.33-.12.5-.08.35-.11.53-.1.52-.13.78a.77.77,0,0,0,0,.15l0,.27h0c0,.26-.06.53-.08.79s0,.62,0,.93l.41,142.37c0,.39,0,.76.05,1.12,0,.13,0,.25.06.38s.05.44.09.65.07.25.1.37.09.39.15.57.09.23.13.35.12.34.2.49a3.47,3.47,0,0,0,.18.33,2.71,2.71,0,0,0,.23.41c.07.11.15.2.22.3s.17.24.27.35.17.16.25.24.2.21.31.3l.29.2c1.8,1.26,4.4,1.21,7.29-.46l252.89-146c5.41-3.12,9.77-10.69,9.76-16.9Zm-5.89,146.79,0,.13a7.64,7.64,0,0,1-.17.77l0,0v0a6.39,6.39,0,0,1-.31.83v0c-.13.28-.27.56-.42.83v0h0a8.25,8.25,0,0,1-.49.76l-.05.07c-.17.22-.34.43-.52.63l0,0-.09.1q-.22.23-.45.42c-.07.06-.13.13-.2.18a7.37,7.37,0,0,1-.67.47l-252.89,146a4.61,4.61,0,0,1-.52.23c-.09,0-.18.09-.26.11l-.16,0h0a1.59,1.59,0,0,1-.3.06l-.16,0h-.6a1.45,1.45,0,0,1-.22-.09l-.12,0-.11,0-.07,0-.06-.05-.2-.16a1.19,1.19,0,0,1-.2-.19l-.11-.16a1.64,1.64,0,0,1-.14-.22c0-.07-.07-.16-.11-.24s-.07-.2-.1-.31-.06-.28-.08-.43a4.17,4.17,0,0,1,0-.52v-.05l0-11.21-.37-131.12a7.82,7.82,0,0,1,3.55-6.14L311.71,51.78l9.67-5.58a2.33,2.33,0,0,1,2.77-.05,1.35,1.35,0,0,1,.19.16,2,2,0,0,1,.29.45,1,1,0,0,1,.07.15,2.83,2.83,0,0,1,.14.44c0,.06,0,.12,0,.18a3.88,3.88,0,0,1,.07.71l.4,142.37A5.76,5.76,0,0,1,325.29,191.43Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "195.306px 194.515px 0px",
          }}
          id="elrmpbvcbsywh"
          className="animable"
        ></path>
        <g id="el196rdgp0dy8">
          <path
            d="M331.18,44.64c0-3.1-1.1-5.28-2.87-6.29-.12-.07-.25-.12-.38-.18l-.27-.13-.14,0-.32-.09-.25-.07-.14,0a2.7,2.7,0,0,0-.41,0,1.86,1.86,0,0,0-.33,0h-.77l-.28,0-.35,0-.18,0-.39.08-.36.1-.08,0c-.22.06-.45.14-.69.23l-.27.11-.11,0a11.68,11.68,0,0,0-1.23.61L68.47,185q-.47.27-.93.6h0l-.3.21-.19.15-.42.31h0l-.34.28-.11.1-.44.38h0l-.33.31h0l-.42.42c-.22.22-.44.46-.65.69l-.27.31-.1.12h0c-.13.15-.26.3-.38.46s-.14.17-.2.26-.17.2-.24.3l-.28.37-.09.14-.39.56-.19.28c-.21.33-.42.67-.62,1l-.09.17c-.07.11-.13.23-.19.34s-.2.36-.29.54l-.15.29-.27.58-.18.37a.61.61,0,0,1,0,.12c-.16.36-.3.72-.43,1.08l-.12.32h0l0,0c-.08.24-.17.49-.24.74s-.09.26-.13.4-.05.21-.08.31-.07.26-.1.39-.09.33-.12.5-.08.35-.11.53-.1.52-.13.78a.77.77,0,0,0,0,.15l0,.27h0c0,.26-.06.53-.08.79s0,.62,0,.93l.41,142.37c0,.39,0,.76.05,1.12,0,.13,0,.25.06.38s.05.44.09.65.07.25.1.37.09.39.15.57.09.23.13.35.12.34.2.49a3.47,3.47,0,0,0,.18.33,2.71,2.71,0,0,0,.23.41c.07.11.15.2.22.3s.17.24.27.35.17.16.25.24.2.21.31.3l.29.2c1.8,1.26,4.4,1.21,7.29-.46l252.89-146c5.41-3.12,9.77-10.69,9.76-16.9Zm-5.89,146.79,0,.13a7.64,7.64,0,0,1-.17.77l0,0v0a6.39,6.39,0,0,1-.31.83v0c-.13.28-.27.56-.42.83v0h0a8.25,8.25,0,0,1-.49.76l-.05.07c-.17.22-.34.43-.52.63l0,0-.09.1q-.22.23-.45.42c-.07.06-.13.13-.2.18a7.37,7.37,0,0,1-.67.47l-252.89,146a4.61,4.61,0,0,1-.52.23c-.09,0-.18.09-.26.11l-.16,0h0a1.59,1.59,0,0,1-.3.06l-.16,0h-.6a1.45,1.45,0,0,1-.22-.09l-.12,0-.11,0-.07,0-.06-.05-.2-.16a1.19,1.19,0,0,1-.2-.19l-.11-.16a1.64,1.64,0,0,1-.14-.22c0-.07-.07-.16-.11-.24s-.07-.2-.1-.31-.06-.28-.08-.43a4.17,4.17,0,0,1,0-.52v-.05l0-11.21-.37-131.12a7.82,7.82,0,0,1,3.55-6.14L311.71,51.78l9.67-5.58a2.33,2.33,0,0,1,2.77-.05,1.35,1.35,0,0,1,.19.16,2,2,0,0,1,.29.45,1,1,0,0,1,.07.15,2.83,2.83,0,0,1,.14.44c0,.06,0,.12,0,.18a3.88,3.88,0,0,1,.07.71l.4,142.37A5.76,5.76,0,0,1,325.29,191.43Z"
            style={{
              opacity: "0.2",
              transformOrigin: "195.306px 194.515px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elwvs7cxuycz">
          <path
            d="M47.89,185.36l-.15.28-.15.29-.12.26c-.11.23-.22.46-.32.69l-.06.12v0c-.13.29-.25.58-.36.88l-.06.16-.12.32c0,.15-.11.29-.15.44s-.07.23-.11.34l-.12.41a1.83,1.83,0,0,0-.08.25c0,.15-.07.3-.11.45l-.12.5c0,.05,0,.11,0,.17s0,.24-.07.36-.09.52-.13.78c0,.07,0,.15,0,.22s0,.13,0,.2a14.32,14.32,0,0,0-.11,1.72l.4,142.37c0,2.71.84,4.71,2.23,5.85a5.47,5.47,0,0,0,.63.44L62,350.61l-.32-.23-.29-.2c-.11-.09-.21-.2-.31-.3s-.17-.15-.25-.24-.18-.24-.27-.35-.15-.19-.22-.3a2.71,2.71,0,0,1-.23-.41,3.47,3.47,0,0,1-.18-.33c-.08-.15-.13-.33-.2-.49s-.09-.23-.13-.35-.1-.38-.15-.57-.07-.24-.1-.37-.06-.43-.09-.65,0-.25-.06-.38c0-.36-.05-.73-.05-1.12L58.71,202c0-.31,0-.62,0-.93s0-.53.08-.79h0l0-.27a.77.77,0,0,1,0-.15h0c0-.26.08-.52.13-.78s.07-.35.11-.53.08-.34.12-.5h0c0-.13.07-.26.1-.39s0-.21.08-.31.09-.27.13-.4h0c.07-.25.16-.5.24-.74l0,0h0l.12-.32c.13-.36.27-.72.43-1.08a.61.61,0,0,0,0-.12l.18-.37.27-.58h0l.15-.29.27-.51L48,185.17C48,185.23,47.92,185.29,47.89,185.36Z"
            style={{ opacity: "0.4", transformOrigin: "53.775px 267.89px 0px" }}
            className="animable"
          ></path>
        </g>
        <g id="elbucgt8awep8">
          <path
            d="M328.33,38.36l-13.27-7.71-.05,0a4.59,4.59,0,0,0-.5-.24l-.09,0-.17-.06-.25-.09-.29-.06-.17,0-.09,0a3.81,3.81,0,0,0-.59-.07h0a.65.65,0,0,0-.14,0,3.69,3.69,0,0,0-.47,0l-.16,0c-.1,0-.2,0-.3,0a2.48,2.48,0,0,0-.27,0l-.25.05-.4.08-.21.05-.22.07-.69.24-.25.09-.14.07a11.68,11.68,0,0,0-1.23.61l-252.88,146c-.32.19-.63.39-.94.6l-.29.21c-.21.15-.42.3-.62.46l-.34.28-.55.48-.33.31-.21.2-.2.22c-.23.23-.44.46-.66.69-.06.08-.14.15-.2.23s-.11.13-.17.2l-.38.46-.25.3-.19.26-.27.37-.19.26-.3.44-.19.29a.76.76,0,0,1-.08.11c-.17.28-.34.55-.5.83l0,.06a1,1,0,0,0-.1.17l-.23.41,13.29,7.67,0,0c.06-.11.12-.23.19-.34h0l.09-.17h0c.2-.34.41-.68.62-1h0l.19-.28.39-.56.09-.14h0l.28-.37h0c.07-.1.16-.2.24-.3s.13-.17.2-.26.25-.31.38-.46h0l.1-.12.27-.3h0c.21-.23.43-.47.65-.69l.42-.42h0l.33-.31h0l.44-.38.11-.1.34-.28h0l.42-.31.19-.15.3-.21h0q.46-.33.93-.6L321.36,39a11.68,11.68,0,0,1,1.23-.61h0l.11,0,.27-.11c.24-.09.47-.17.69-.23h0l.07,0,.36-.1.39-.08h0l.17,0,.35,0,.28,0h.78a1.75,1.75,0,0,1,.32,0,2.7,2.7,0,0,1,.41,0l.14,0h0a1.41,1.41,0,0,1,.22.06l.32.09.14,0h0a1.92,1.92,0,0,1,.25.12c.13.06.26.11.38.18Z"
            style={{
              opacity: "0.3",
              transformOrigin: "188.195px 111.511px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M101.26,187.21c.24-.14.45-.05.48.21a1,1,0,0,1-.42.86c-1.61,1.17-3.24,2.25-4.82,3.29s-3,2-4.46,3c-.37,1.75-.73,3.53-1.08,5.25s-.77,3.78-1.18,5.67a1.06,1.06,0,0,1-.44.66c-.22.12-.4.09-.47-.08L87,202a.94.94,0,0,1,.26-.88.9.9,0,0,1,.19-.15c.19-.11.37-.08.44.09l1.31,3c.27-1.29.54-2.59.79-3.86.38-1.86.77-3.78,1.18-5.67a1.11,1.11,0,0,1,.4-.64c1.62-1.16,3.25-2.24,4.83-3.28s3.18-2.11,4.77-3.26Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "94.3589px 196.683px 0px",
          }}
          id="eld5ftdhf8dfb"
          className="animable"
        ></path>
        <path
          d="M91.09,234.85c.27-.15.49,0,.5.27a1.08,1.08,0,0,1-.48.84l-7.33,4.34c-.27.16-.48,0-.48-.27a1,1,0,0,1,.47-.84Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "87.445px 237.577px 0px",
          }}
          id="elzphrtxfi3wp"
          className="animable"
        ></path>
        <path
          d="M96.63,228.33c.27-.15.48,0,.48.29l0,3.92c1.12-.8,2.24-1.6,3.35-2.41l.07,0c.23-.13.44-.05.48.21a1,1,0,0,1-.42.86c-1.16.85-2.33,1.68-3.5,2.51l0,2.46a1.06,1.06,0,0,1-.48.82c-.28.16-.49,0-.49-.29l0-2.3c-.75.52-1.49,1-2.24,1.56l0,0c-.24.14-.45,0-.48-.22a1,1,0,0,1,.43-.86l2.35-1.66.06-4.06A1.09,1.09,0,0,1,96.63,228.33Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "97.2051px 232.662px 0px",
          }}
          id="elyhtggo5aixf"
          className="animable"
        ></path>
        <path
          d="M108,224.88a6,6,0,0,1-1.24,4A13.82,13.82,0,0,1,104,232c.08.33.15.66.2,1a1,1,0,0,1-.4.87l-.07.05c-.24.13-.45.07-.48-.19a9.12,9.12,0,0,0-.22-1l-.39.24a6.73,6.73,0,0,1-.76.38c-.27.12-.46-.06-.42-.38a1.07,1.07,0,0,1,.47-.76l.07,0,.66-.33.09-.06c-.3-.88-.67-1.75-1-2.61a20.74,20.74,0,0,1-1.59-4.75,1,1,0,0,1,.22-.68,24.5,24.5,0,0,1,2.48-3,8.19,8.19,0,0,1,1.54-1.2,3.42,3.42,0,0,1,1.47-.5,1.35,1.35,0,0,1,.9.25,1.88,1.88,0,0,1,.52,1.67,6.83,6.83,0,0,1-.9,2.75A1.34,1.34,0,0,1,108,224.88ZM102.05,227a1.19,1.19,0,0,1,.16-.23,14.8,14.8,0,0,1,2.78-2.54,7,7,0,0,0,.45-.62,4.91,4.91,0,0,0,.79-2.19,1.14,1.14,0,0,0-.28-1,.84.84,0,0,0-.57-.14,2.32,2.32,0,0,0-1.07.37,6.06,6.06,0,0,0-1.22,1,18.91,18.91,0,0,0-2,2.38,15.94,15.94,0,0,0,1,3m4.06,1.31a4.91,4.91,0,0,0,.92-2.72c-.14-.77-1-.81-1.78-.4a17.86,17.86,0,0,1-2.76,2.48l-.13.08c.07.16.14.32.2.48.4.93.81,1.87,1.12,2.84a11.88,11.88,0,0,0,2.43-2.76"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "104.084px 226.531px 0px",
          }}
          id="el5gjlxymi4eq"
          className="animable"
        ></path>
        <path
          d="M114.63,217.61c.26-.15.47,0,.48.25a1.06,1.06,0,0,1-.45.85l-4.6,2.94,0,0a.29.29,0,0,1-.48-.25,1.06,1.06,0,0,1,.45-.85l4.6-2.94Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "112.344px 219.636px 0px",
          }}
          id="eldtn6cecclyg"
          className="animable"
        ></path>
        <path
          d="M114.83,220.62c.23-.13.44-.06.48.18a1,1,0,0,1-.39.88,18.94,18.94,0,0,1-2.25,1.52A16.17,16.17,0,0,1,111,224c-.27.11-.45-.06-.42-.38a1.09,1.09,0,0,1,.48-.77l.06,0a13.69,13.69,0,0,0,1.53-.77,17.43,17.43,0,0,0,2.09-1.41Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "112.945px 222.295px 0px",
          }}
          id="elzuwpsrqf9fd"
          className="animable"
        ></path>
        <path
          d="M150.7,200.08a5.12,5.12,0,0,1-1,3.07,17.61,17.61,0,0,1-4,4.33l-.07.06a.33.33,0,0,1-.33,0c-.11,0-.16-.18-.15-.35l.44-9.3a.59.59,0,0,1,0-.23,20.91,20.91,0,0,0-2.07,2.13.7.7,0,0,1-.23.2c-.17.1-.34.09-.42-.05a.83.83,0,0,1,.2-.87,21.15,21.15,0,0,1,4.62-4.15l.36-.22c.63-.36,1.39-.66,1.92-.33.82.53.54,2.29-.19,3.62a9.66,9.66,0,0,1-.68,1A1.17,1.17,0,0,1,150.7,200.08ZM149,202.7a3.63,3.63,0,0,0,.7-1.91c-.05-.46-.48-.59-.87-.51a3.44,3.44,0,0,0-1,.43c-.22.12-.44.26-.65.39s-.45.08-.5-.16a1,1,0,0,1,.33-.82,10.79,10.79,0,0,0,2.09-2.45c.43-.78.62-1.83.21-2.1-.24-.15-.64-.06-1.24.29l-.28.17c-.48.31-.95.65-1.43,1,.13,0,.2.17.19.37l-.4,8.56A16,16,0,0,0,149,202.7"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "146.761px 200.906px 0px",
          }}
          id="elzq32kgklnlp"
          className="animable"
        ></path>
        <path
          d="M155.75,244.93a.35.35,0,0,1,.34,0l5.38,3.23a.37.37,0,0,1,.13.4,1,1,0,0,1-.26.56,140,140,0,0,0-9,11.52.91.91,0,0,1-.29.27c-.15.09-.3.1-.39,0s-.11-.53.1-.84c2.71-3.84,5.6-7.54,8.6-11l-4.92-2.94c-.19-.11-.18-.47,0-.79A1,1,0,0,1,155.75,244.93Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "156.606px 252.934px 0px",
          }}
          id="eltlzmasbft8"
          className="animable"
        ></path>
        <path
          d="M114.12,279.18a2.21,2.21,0,0,1,1.25-.35,2.28,2.28,0,0,1,.88.28,2.61,2.61,0,0,0,.5.2,1,1,0,0,0,.74-.1.89.89,0,0,0,.29-.26.84.84,0,0,1,.28-.26.3.3,0,0,1,.39,0c.16.16.1.54-.11.84a2.76,2.76,0,0,1-.84.78,1.79,1.79,0,0,1-1.32.22,3.34,3.34,0,0,1-.58-.23,2,2,0,0,0-.7-.24,1.45,1.45,0,0,0-.78.23,3.49,3.49,0,0,0-1.31,1.42,1,1,0,0,1-.37.42.33.33,0,0,1-.31.05c-.21-.07-.24-.4-.07-.74A5.59,5.59,0,0,1,114.12,279.18Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "115.246px 280.408px 0px",
          }}
          id="elkfvz5czjh"
          className="animable"
        ></path>
        <path
          d="M113.49,281.09c.27-.16.46,0,.47.26l.24,6.41a1.06,1.06,0,0,1-.46.84l0,0c-.26.15-.48,0-.49-.26L113,282a1,1,0,0,1,.47-.84Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "113.6px 284.843px 0px",
          }}
          id="elaz3e3or5dfc"
          className="animable"
        ></path>
        <path
          d="M115.5,282.29c.22-.12.42-.06.47.16a20.47,20.47,0,0,1,.49,4.55,1.05,1.05,0,0,1-.46.82l0,0c-.25.14-.46.05-.49-.23l0-.46a.72.72,0,0,1,0-.25,19,19,0,0,0-.45-3.65,1,1,0,0,1,.36-.88Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "115.757px 285.057px 0px",
          }}
          id="el76qxhimicc"
          className="animable"
        ></path>
        <path
          d="M145.09,263.3c.26-.14.48,0,.49.25l.2,4.63a1,1,0,0,1-.46.84l0,0c-.26.15-.48,0-.49-.25l-.19-4.63a1,1,0,0,1,.46-.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "145.21px 266.162px 0px",
          }}
          id="elslyri3sctdb"
          className="animable"
        ></path>
        <path
          d="M143.32,262.12a2,2,0,0,1,1.16-.28l.33,0a3.64,3.64,0,0,0,.57,0,2.08,2.08,0,0,0,.73-.26,3.41,3.41,0,0,0,.8-.65.9.9,0,0,1,.19-.16c.19-.1.37-.08.44.08a.91.91,0,0,1-.24.88,5.66,5.66,0,0,1-1.18,1,3,3,0,0,1-1.1.39,3.14,3.14,0,0,1-.69,0l-.3,0a1.26,1.26,0,0,0-.72.16l0,0a1,1,0,0,0-.39.5,1.1,1.1,0,0,1-.46.64.47.47,0,0,1-.15.06c-.25,0-.39-.19-.31-.53a3.15,3.15,0,0,1,1.26-1.75Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "144.774px 262.594px 0px",
          }}
          id="elzb83yy0ogoh"
          className="animable"
        ></path>
        <path
          d="M143.34,264.09c.26-.15.46,0,.48.24l.19,3.24a1.07,1.07,0,0,1-.45.85l0,0c-.26.14-.47,0-.49-.24l-.19-3.24a1.09,1.09,0,0,1,.45-.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "143.445px 266.253px 0px",
          }}
          id="elaopj1vu2a3h"
          className="animable"
        ></path>
        <path
          d="M140.36,265.64c.53-.3,1-.31,1.29,0a2.26,2.26,0,0,1,.13,1.63,15.12,15.12,0,0,1-1.08,3.41l2-1.35.05,0c.25-.14.46,0,.48.23a1.06,1.06,0,0,1-.43.86l-3.15,2.16-.05,0c-.18.1-.35.08-.43-.07a.78.78,0,0,1,.09-.69,13.32,13.32,0,0,0,1.6-4.25,1.4,1.4,0,0,0,0-.87c-.08-.1-.26-.08-.46,0a1.71,1.71,0,0,0-.29.22,4.76,4.76,0,0,0-.84,1.45,1,1,0,0,1-.41.49.37.37,0,0,1-.26.06c-.22,0-.29-.33-.15-.67a7,7,0,0,1,1.3-2.15A3,3,0,0,1,140.36,265.64Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "140.804px 269.027px 0px",
          }}
          id="el892h6p4cr2h"
          className="animable"
        ></path>
        <path
          d="M156.81,249.22c.27-.15.48,0,.48.29a1.06,1.06,0,0,1-.48.83L149,254.75a60.88,60.88,0,0,1-2.54,17.5c-1.14,3.58-3.33,7.8-6.13,9.42a5.1,5.1,0,0,1-.57.29,3.1,3.1,0,0,1-4.07-1.1,10.28,10.28,0,0,1-1.21-4.82,80.08,80.08,0,0,1,.69-13.5l-11.83,6.67a48.8,48.8,0,0,1-.28,16.86,24.72,24.72,0,0,1-2.23,6.56,13.24,13.24,0,0,1-4.61,5.3c-2.8,1.57-4.9.15-5.75-1.93s-.81-5.27-.74-8l.33-11.35L98.81,283a.44.44,0,0,1,.07.25,1.09,1.09,0,0,1-.49.81l-2.83,1.5.23,9.48,2.15-1.21c.27-.15.48,0,.48.29a1.06,1.06,0,0,1-.48.83l-2.12,1.19.34,13.56a17.61,17.61,0,0,1,2-.94c.27-.11.45.06.41.39a1.08,1.08,0,0,1-.48.75,19.24,19.24,0,0,0-1.88.9l.15,5.91a1.05,1.05,0,0,1-.46.84c-.27.15-.48.06-.51-.22l-.11-1.28a1.06,1.06,0,0,1,.07-.38l-.11-4.29a21.16,21.16,0,0,0-2.36,1.73c-.26.16-.4.16-.49.07a11.41,11.41,0,0,1-4,4.79,5.48,5.48,0,0,1-.6.29c-2,.83-3.75-.27-4.82-3.1-1.7-4.52-1.9-10.54-.55-16.94a1.07,1.07,0,0,1,.47-.68c.38-.12.54.1.46.44-1.29,6.15-1.1,11.93.53,16.28.55,1.45,1.8,3.73,4,2.82a4,4,0,0,0,.46-.23c1.76-1,3.31-3.6,4-5.8a24,24,0,0,0,.79-7.11v-.4q0-3,.18-6l-.88.49c-.27.15-.49,0-.49-.29a1.07,1.07,0,0,1,.49-.82l.93-.53c.19-3.33.47-6.71.87-10.13l-.55.29c-.27.15-.48,0-.47-.31L80,293.61c-.26.15-.48,0-.48-.28a1.11,1.11,0,0,1,.49-.83l14.51-8.18c0-.1,0-.2,0-.3l-.21-8.35-.92.66c-.3.18-.51.1-.54-.17a1,1,0,0,1,.42-.86l1-.73L94,262.15l-1.39.85c-.28.16-.49.05-.5-.25a1.06,1.06,0,0,1,.46-.84l1.4-.86-.26-10.65L91.23,257a1,1,0,0,1-.42.53.43.43,0,0,1-.23.07c-.24,0-.32-.31-.2-.65l4.26-11.43a1.08,1.08,0,0,1,.43-.54c.22-.11.38-.06.45.1l2.62,6.44a.92.92,0,0,1-.28.88c-.37.25-.55.22-.63,0L95,246.9l-1.11,3a1,1,0,0,1,.3-.3c.28-.17.48,0,.49.25l.27,10.65,2.4-1.49c.29-.16.48,0,.49.25a1.05,1.05,0,0,1-.46.85L95,261.55l.31,12.32,1-.74a32.82,32.82,0,0,1,2.87-8.56A17,17,0,0,1,104.9,258a5.17,5.17,0,0,1,2.35-.77c1.72-.07,3,1.17,3.63,3.4a24,24,0,0,1,.38,6.54L111,275l11.15-6.29c-.16-1.14-.34-2.29-.52-3.44-.81-5.22-1.64-10.61-1.16-16.66.34-4.16,1.58-7.57,3.59-9.85a8.71,8.71,0,0,1,2.16-1.8,5.7,5.7,0,0,1,5.4-.35c5,2.48,5.59,10.61,5.24,17-.13,2.35-.39,4.79-.65,7.18L148,254.17c0-.64,0-1.27,0-1.89s0-1.43,0-2.13c.19-7.39.87-15.32,4.59-23.21a1,1,0,0,1,.39-.45.4.4,0,0,1,.29-.06c.22.06.26.38.1.72-3.56,7.56-4.22,15.27-4.4,22.48,0,.7,0,1.41,0,2.11s0,1.25-.05,1.88Zm-33.64,19,12.11-6.82c.26-2.42.52-4.89.65-7.25.34-6.14-.24-13.95-4.93-16.28a5,5,0,0,0-4.73.25,7.15,7.15,0,0,0-1.74,1.46c-2.14,2.43-2.84,6-3,8.65-.48,5.9.35,11.22,1.15,16.37.18,1.2.37,2.4.54,3.62m-1.07,18.14a47,47,0,0,0,.24-16.55L111,276.14l-.32,11.38c-.08,2.59-.16,5.53.67,7.56a3.23,3.23,0,0,0,4.83,1.75l.06,0a11.32,11.32,0,0,0,3.84-4.46,22.94,22.94,0,0,0,2-6m-11.81-18.58a23.32,23.32,0,0,0-.35-6.24c-.51-1.94-1.64-3-3.1-3a4.25,4.25,0,0,0-2,.63,14.94,14.94,0,0,0-5,5.73,29.64,29.64,0,0,0-2.55,7.49l1-.75.06,0c.24-.14.45-.05.48.21a1,1,0,0,1-.41.86l-1.43,1c-.11.53-.2,1.06-.29,1.57-.5,2.79-.91,5.54-1.27,8.28v.21l14.56-8.2.22-7.82m35.27,4.57a59.63,59.63,0,0,0,2.45-17L136.13,262a79.37,79.37,0,0,0-.71,13.41,9.69,9.69,0,0,0,1.1,4.44,2.58,2.58,0,0,0,3.34,1l.42-.22c2.37-1.37,4.31-5.24,5.28-8.27M92.92,311.92a25.36,25.36,0,0,1,2.27-1.64l-.34-13.59-.56.32c-.09,2-.16,4-.17,6v.4a25.05,25.05,0,0,1-.86,7.58c-.1.32-.21.62-.33.94m2.46-33.66c.14-.89.29-1.8.45-2.7.06-.37.13-.74.21-1.13l-.74.54.08,3.29m-.67,12.65q-.22,2.49-.36,4.95l.48-.27-.12-4.68"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "118.405px 272.477px 0px",
          }}
          id="eldiv7g17y0i6"
          className="animable"
        ></path>
        <path
          d="M104.11,200.15c.24-.14.45,0,.47.23a1.05,1.05,0,0,1-.44.86c-3.65,2.47-7.34,4.78-11,6.91q-3.74,2.15-7.44,4c-.27.14-.47,0-.46-.32a1.06,1.06,0,0,1,.49-.81c2.48-1.26,5-2.61,7.42-4q5.48-3.17,10.93-6.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "94.9098px 206.149px 0px",
          }}
          id="eldyjgkhh8yy"
          className="animable"
        ></path>
        <path
          d="M97.1,194.55a1.5,1.5,0,0,1,.94-.26c.72.1.81,1.14.51,2.13a1.31,1.31,0,0,1,1.41-.1c.5.37.56,1.39.14,2.47a7.15,7.15,0,0,1-1.61,2.39,8.58,8.58,0,0,1-1.76,1.4,4.61,4.61,0,0,1-2.25.68c-.23,0-.33-.28-.21-.62a1.1,1.1,0,0,1,.43-.56.37.37,0,0,1,.22-.06,3.66,3.66,0,0,0,1.8-.55,6.35,6.35,0,0,0,1.42-1.13,5.09,5.09,0,0,0,1.12-1.62c.21-.55.2-1.08,0-1.25s-.45-.08-.78.11l-.23.16a8.71,8.71,0,0,0-1.31,1.38.7.7,0,0,1-.23.2c-.17.1-.33.1-.42,0a.8.8,0,0,1,.17-.85,8.36,8.36,0,0,0,1.19-1.84c.17-.46.17-1-.1-1.07a.7.7,0,0,0-.43.14l-.23.14a8.84,8.84,0,0,0-2.31,2.46,1,1,0,0,1-.31.31.34.34,0,0,1-.37,0c-.17-.14-.15-.5.06-.82a10.73,10.73,0,0,1,2.84-3Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "97.0825px 198.774px 0px",
          }}
          id="elv1eodwbj7g"
          className="animable"
        ></path>
        <path
          d="M94,209.7a.42.42,0,0,1,.34,0c.19.1.21.44,0,.78a65.89,65.89,0,0,0-3.12,6.45L95,215.11q.12-2.18.09-4.26a1.06,1.06,0,0,1,.47-.84c.26-.14.49,0,.5.27,0,1.42,0,2.88-.09,4.37l.28-.14c.27-.12.46,0,.44.35a1.07,1.07,0,0,1-.48.79l0,0-.27.13c-.1,1.59-.25,3.21-.47,4.85a1.06,1.06,0,0,1-.47.74l-.08,0c-.27.1-.45-.08-.4-.41.21-1.61.35-3.2.46-4.76l-4.56,2.15a.27.27,0,0,1-.38-.07.66.66,0,0,1,0-.55,69.08,69.08,0,0,1,3.63-7.71A1.18,1.18,0,0,1,94,209.7Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "93.3357px 215.531px 0px",
          }}
          id="elk1adpb1q7io"
          className="animable"
        ></path>
        <path
          d="M112,196.43c.23-.13.45-.05.48.21a1,1,0,0,1-.42.87l-4.9,3.58-.06,0c-.24.14-.45.05-.48-.21a1,1,0,0,1,.42-.86l4.89-3.58Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "109.55px 198.762px 0px",
          }}
          id="eld5l36pz9wca"
          className="animable"
        ></path>
        <path
          d="M111.38,192.88c.25-.14.46,0,.48.25a1.07,1.07,0,0,1-.46.85l-4.53,2.93,0,0c-.25.14-.47,0-.48-.25a1,1,0,0,1,.45-.85l4.53-2.93Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "109.125px 194.895px 0px",
          }}
          id="elof03sn1fq6"
          className="animable"
        ></path>
        <path
          d="M118.87,185.06a.3.3,0,0,1,.39,0c.16.16.11.53-.11.84a16.08,16.08,0,0,0-3,7.62c-.21,2.46.5,4.48,1.89,5.4.18.12.18.48,0,.8a1,1,0,0,1-.33.34.32.32,0,0,1-.35,0c-1.59-1-2.39-3.33-2.15-6.12a18.21,18.21,0,0,1,3.41-8.65A.76.76,0,0,1,118.87,185.06Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "117.261px 192.55px 0px",
          }}
          id="el9z811353bk"
          className="animable"
        ></path>
        <path
          d="M126.88,179.22a1.13,1.13,0,0,1,1.67.29,3.41,3.41,0,0,1-.05,2.56,7.66,7.66,0,0,1-.39,1l.23-.14a10.4,10.4,0,0,1,1.49-.69c.26-.09.43.1.39.43a1.09,1.09,0,0,1-.48.72l-.09.05a7.87,7.87,0,0,0-1.33.62,11,11,0,0,0-1.27.87L127,185a.29.29,0,0,1-.42-.05.68.68,0,0,1,.07-.69,11.55,11.55,0,0,0,1-2.13,2.3,2.3,0,0,0,.06-1.63.56.56,0,0,0-.79-.16,1,1,0,0,0-.16.12,3.46,3.46,0,0,0-.81,1.62,1.05,1.05,0,0,1-.44.61l-.18.06c-.25,0-.37-.21-.28-.55a5.46,5.46,0,0,1,1.44-2.65A2.92,2.92,0,0,1,126.88,179.22Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "127.623px 182.02px 0px",
          }}
          id="eld9r8dvvwl0e"
          className="animable"
        ></path>
        <path
          d="M124.17,185.47c.27-.15.49,0,.49.26a1.06,1.06,0,0,1-.47.85,10.31,10.31,0,0,0-2.74,2.47,5.59,5.59,0,0,0-.82,1.29,1.38,1.38,0,0,0-.13,1c.1.24.4.29.74.13l.14-.07a3.78,3.78,0,0,0,1-.91,8.7,8.7,0,0,0,1.79-3.61,1.1,1.1,0,0,1,.47-.68l.1,0c.25-.08.42.1.38.41a6.51,6.51,0,0,0,0,2.83.86.86,0,0,0,1.28.44,1.43,1.43,0,0,0,.26-.19.48.48,0,0,1,.15-.11c.2-.12.39-.08.46.11a.93.93,0,0,1-.31.88,3.3,3.3,0,0,1-.54.42,1.44,1.44,0,0,1-2.2-.64,2.92,2.92,0,0,1-.2-.87,11.46,11.46,0,0,1-1.2,1.77,5.85,5.85,0,0,1-1.46,1.31l-.22.11c-.7.32-1.31.19-1.55-.35a2.88,2.88,0,0,1,.21-2.08,8.18,8.18,0,0,1,1.14-1.84A12.57,12.57,0,0,1,124.17,185.47Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "123.386px 189.126px 0px",
          }}
          id="elv73k26nh8bh"
          className="animable"
        ></path>
        <path
          d="M130.4,176a.52.52,0,0,1,.19-.06c1.78-.2,3.17,1,3.63,3a13.52,13.52,0,0,1-.8,7,33,33,0,0,1-3.6,7.11.83.83,0,0,1-.31.31.32.32,0,0,1-.37,0c-.18-.13-.15-.5.05-.82a30.66,30.66,0,0,0,3.36-6.63,12,12,0,0,0,.73-6.21c-.39-1.77-1.56-2.76-3.05-2.6-.25,0-.37-.23-.27-.57A1.05,1.05,0,0,1,130.4,176Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "131.696px 184.669px 0px",
          }}
          id="eltta7ncoudzp"
          className="animable"
        ></path>
        <path
          d="M88.73,225.26a.58.58,0,0,1,.21-.07c.2,0,.31.2.26.48l-1.79,9.75a1.06,1.06,0,0,1-.46.7l-.11,0c-.26.08-.43-.13-.37-.47l1.27-6.91-.51,1.06a1,1,0,0,1-.38.44.37.37,0,0,1-.3.05c-.21-.07-.25-.39-.09-.73l1.89-3.91A1,1,0,0,1,88.73,225.26Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "87.787px 230.663px 0px",
          }}
          id="elx3sjz010ck9"
          className="animable"
        ></path>
        <path
          d="M88.07,239c.83-.48,1.46-.48,1.74,0a2.21,2.21,0,0,1-.07,1.72,8.06,8.06,0,0,1-.82,1.55,30.53,30.53,0,0,1-2.52,3.23L90.64,243c.27-.15.48,0,.48.27a1,1,0,0,1-.48.84L84,248c-.23.13-.43.06-.47-.17a1,1,0,0,1,.29-.8,38.27,38.27,0,0,0,4.46-5.28,5.35,5.35,0,0,0,.59-1.07,1,1,0,0,0,0-.69c-.12-.22-.5-.1-.88.12l-.26.16a12.2,12.2,0,0,0-3,3.16,1.07,1.07,0,0,1-.3.3.31.31,0,0,1-.38,0c-.17-.14-.13-.51.08-.82a13.88,13.88,0,0,1,3.53-3.69A3.61,3.61,0,0,1,88.07,239Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "87.3229px 243.352px 0px",
          }}
          id="el312x18305xm"
          className="animable"
        ></path>
        <path
          d="M121.45,212c.21-.12.4-.07.46.14a1,1,0,0,1-.34.88,10,10,0,0,0-2.75,3.89c-.53,1.47-.31,2.86.48,3.1a1.54,1.54,0,0,0,1.18-.24,4.09,4.09,0,0,0,1.06-.93,5.78,5.78,0,0,0,1.22-3.05,2.51,2.51,0,0,0-.84-2.23c-.17-.14-.15-.5,0-.82a1.08,1.08,0,0,1,.32-.32.33.33,0,0,1,.37,0,3.29,3.29,0,0,1,1.06,2.91,7.8,7.8,0,0,1-1.7,4.21,6,6,0,0,1-1.53,1.35,2.4,2.4,0,0,1-1.78.36c-1.17-.35-1.5-2.27-.75-4.35a12.28,12.28,0,0,1,3.36-4.79Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "120.606px 216.614px 0px",
          }}
          id="elra11bz4oxt9"
          className="animable"
        ></path>
        <path
          d="M151.47,189.83c.24-.14.45-.05.48.22a1,1,0,0,1-.43.86l-11.73,8.26,0,0c-.25.14-.46.05-.48-.22a1.06,1.06,0,0,1,.42-.86l11.74-8.25A.1.1,0,0,1,151.47,189.83Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "145.63px 194.5px 0px",
          }}
          id="elpwv2d7zqdwj"
          className="animable"
        ></path>
        <path
          d="M154.91,198.77l0,0,2.36-1.29c.27-.15.49,0,.48.3a1.1,1.1,0,0,1-.48.82h0l-2.36,1.29c-.27.15-.48,0-.47-.3A1.08,1.08,0,0,1,154.91,198.77Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "156.095px 198.685px 0px",
          }}
          id="elchgyywx6fat"
          className="animable"
        ></path>
        <path
          d="M154.27,195.92l4.12-2.33c.27-.15.48,0,.48.28a1.06,1.06,0,0,1-.48.83L154.27,197c-.27.16-.49,0-.48-.28A1.05,1.05,0,0,1,154.27,195.92Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "156.33px 195.297px 0px",
          }}
          id="elqmm9w7z5yu"
          className="animable"
        ></path>
        <path
          d="M159.76,184.51c.21-.12.4-.07.47.13l1.4,4.63a1,1,0,0,1-.33.88l-.13.1c-.21.12-.41.08-.47-.13l-1.4-4.63a1,1,0,0,1,.33-.88Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "160.465px 187.381px 0px",
          }}
          id="elkoxrf9wdgqj"
          className="animable"
        ></path>
        <path
          d="M189.3,177.92a2.17,2.17,0,0,1,1.46-.33c.22,0,.28.36.13.7a1.11,1.11,0,0,1-.4.47.37.37,0,0,1-.28.06,1.32,1.32,0,0,0-.9.21,2.67,2.67,0,0,0-.65.54,3.62,3.62,0,0,0-.92,2c0,.4,0,.84.35.9a1.45,1.45,0,0,0,.84-.3l.21-.12,1.49-.9a2.82,2.82,0,0,0,.52-.36.84.84,0,0,0,.21-.29,1.08,1.08,0,0,1,.43-.54.38.38,0,0,1,.22-.07c.24,0,.33.29.21.63a3,3,0,0,1-.79,1.18,4.53,4.53,0,0,1-.78.55l-1.48.89-.26.16a2.14,2.14,0,0,1-1.36.4c-.56-.1-.86-.78-.77-1.71a5.86,5.86,0,0,1,1.48-3.19A4.32,4.32,0,0,1,189.3,177.92Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "189.519px 180.637px 0px",
          }}
          id="elm4qvgjwin2"
          className="animable"
        ></path>
        <path
          d="M191.69,170.56a.42.42,0,0,1,.32-.05l2.23.93c.2.08.22.43,0,.76a1,1,0,0,1-.37.4.33.33,0,0,1-.31.05l-1.89-.79-1.83,3.2a1.08,1.08,0,0,1-.34.36.36.36,0,0,1-.34,0c-.2-.11-.2-.46,0-.78l2.15-3.75A1,1,0,0,1,191.69,170.56Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "191.704px 172.98px 0px",
          }}
          id="elm2u0bvx8yj"
          className="animable"
        ></path>
        <path
          d="M201.78,172.28c.27-.16.48,0,.49.27a1.1,1.1,0,0,1-.48.84l-2.14,1.24c-.27.15-.49,0-.49-.27a1.07,1.07,0,0,1,.48-.84Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "200.715px 173.453px 0px",
          }}
          id="elsqm9hwi8wys"
          className="animable"
        ></path>
        <path
          d="M201.87,170.36c.27-.15.49,0,.49.27a1.07,1.07,0,0,1-.48.84l-3,1.78c-.27.16-.49,0-.49-.27a1.05,1.05,0,0,1,.48-.84Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "200.375px 171.807px 0px",
          }}
          id="elokpqzc0a7t"
          className="animable"
        ></path>
        <path
          d="M196.71,166.36c.36-.21.73-.26.95,0a1.24,1.24,0,0,1,.12,1,4.13,4.13,0,0,1-.35,1c-.13.29-.27.57-.42.85a9,9,0,0,1,1-.47c.26-.11.44.07.4.4a1.09,1.09,0,0,1-.47.74l-.08,0a7.27,7.27,0,0,0-1,.48,8.29,8.29,0,0,0-1.18.81l-.09.06c-.19.11-.36.08-.44-.09a.79.79,0,0,1,.16-.76,14.46,14.46,0,0,0,1.31-2.26,2.55,2.55,0,0,0,.2-.54.29.29,0,0,0,0-.19s-.07,0-.14,0a.51.51,0,0,0-.16.12,4.39,4.39,0,0,0-.55.92,1,1,0,0,1-.37.42.33.33,0,0,1-.31.05c-.21-.07-.24-.4-.07-.73a6.16,6.16,0,0,1,.91-1.45A2.31,2.31,0,0,1,196.71,166.36Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "196.763px 168.739px 0px",
          }}
          id="elop3rzqpomin"
          className="animable"
        ></path>
        <path
          d="M204.6,176.55a.49.49,0,0,1,.22-.06c.24,0,.34.28.22.62a89.89,89.89,0,0,0-4.39,18.41,1.11,1.11,0,0,1-.47.75l-.08,0c-.27.11-.44-.08-.41-.4a91.63,91.63,0,0,1,4.48-18.79A1.14,1.14,0,0,1,204.6,176.55Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "202.389px 186.396px 0px",
          }}
          id="elwsxw1sm4hhn"
          className="animable"
        ></path>
        <path
          d="M165.62,182.22a.34.34,0,0,1,.25-.06c.23,0,.3.34.15.68a83.53,83.53,0,0,0-3.87,13l-1.32,5.53a1.13,1.13,0,0,1-.46.65.44.44,0,0,1-.15.05c-.26.06-.4-.17-.31-.51l1.31-5.53a85.84,85.84,0,0,1,4-13.33A1.06,1.06,0,0,1,165.62,182.22Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "162.991px 192.118px 0px",
          }}
          id="el5xkndasjdco"
          className="animable"
        ></path>
        <path
          d="M179.38,216.26h0c.27-.14.48,0,.46.32l-.37,8a1,1,0,0,1-.48.8h0c-.26.14-.47,0-.45-.32l.36-8A1.1,1.1,0,0,1,179.38,216.26Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "179.19px 220.82px 0px",
          }}
          id="ele0q8dht6vnr"
          className="animable"
        ></path>
        <path
          d="M194.31,225.18a.53.53,0,0,1,.23-.06c.24,0,.33.29.2.64l-7.16,19.58a1.1,1.1,0,0,1-.43.53.43.43,0,0,1-.23.07c-.24,0-.33-.29-.2-.64l7.17-19.58A1,1,0,0,1,194.31,225.18Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "190.73px 235.53px 0px",
          }}
          id="el57kgjr577ct"
          className="animable"
        ></path>
        <path
          d="M188.08,228.87a.29.29,0,0,1,.48.26l.31,6.5a1.05,1.05,0,0,1-.46.85l0,0c-.26.15-.47,0-.49-.25l-.31-6.51a1.07,1.07,0,0,1,.46-.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "188.24px 232.668px 0px",
          }}
          id="elr6smgim4zh"
          className="animable"
        ></path>
        <path
          d="M194.1,233.39a.55.55,0,0,1,.23-.07c.24,0,.33.29.21.63l-2.33,6.6.34-.21a5.11,5.11,0,0,1,1.39-.57l.18-2.82a1.1,1.1,0,0,1,.48-.79l0,0c.27-.13.46,0,.44.35l-.46,7.13a1.07,1.07,0,0,1-.48.79l0,0c-.27.13-.47,0-.44-.34l.2-3.13a4,4,0,0,0-1.33.51,6.18,6.18,0,0,0-1.07.78.41.41,0,0,1-.13.1.31.31,0,0,1-.37,0,.52.52,0,0,1-.06-.57l2.78-7.85A1,1,0,0,1,194.1,233.39Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "192.941px 238.9px 0px",
          }}
          id="el80f8c8fbyzt"
          className="animable"
        ></path>
        <path
          d="M201.15,228.55a.43.43,0,0,1,.23-.07c.24,0,.32.31.2.65L199.74,234l2.74,3.91a.8.8,0,0,1-.18.86.79.79,0,0,1-.24.21c-.17.1-.33.09-.42,0l-2.44-3.49-1.76,4.71a1.13,1.13,0,0,1-.42.54.53.53,0,0,1-.24.06c-.23,0-.32-.3-.19-.64l2-5.48-1.6-2.28c-.14-.19-.05-.58.18-.87a.9.9,0,0,1,.23-.21.31.31,0,0,1,.43,0l1.31,1.86,1.55-4.15A1.09,1.09,0,0,1,201.15,228.55Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "199.533px 234.64px 0px",
          }}
          id="elu510o6piuw"
          className="animable"
        ></path>
        <path
          d="M178.54,210.24a.47.47,0,0,1,.15-.06,45.53,45.53,0,0,0,13.6-5.36,64.18,64.18,0,0,0,5.84-3.83c.31-.18.51-.1.54.16a1,1,0,0,1-.41.87,63.52,63.52,0,0,1-6,3.91,46.78,46.78,0,0,1-13.39,5.38,91.44,91.44,0,0,1-6.4,20.06,1,1,0,0,1-.4.46l-.12,0a.26.26,0,0,1-.36-.26l-1.49-12.49a1.07,1.07,0,0,1,.42-.86c.3-.18.51-.09.54.17l1.32,11.11a87.2,87.2,0,0,0,5.66-18.6,1.2,1.2,0,0,1,.23-.5A1.13,1.13,0,0,1,178.54,210.24Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "184.386px 216.372px 0px",
          }}
          id="eltmz8zoti6p"
          className="animable"
        ></path>
        <path
          d="M167.5,190.43c.55-.32,1.05-.3,1.3.06a1.79,1.79,0,0,1,.09,1.41,7.31,7.31,0,0,1-.54,1.35,26.75,26.75,0,0,1-1.57,2.77l3-1.12c.26-.1.44.09.4.42a1.11,1.11,0,0,1-.48.73l-.08,0-4.11,1.53a.27.27,0,0,1-.39-.21.94.94,0,0,1,.2-.68,25.66,25.66,0,0,0,2.25-3.73,4.93,4.93,0,0,0,.38-.93.76.76,0,0,0,0-.55c-.07-.1-.27-.09-.47,0l-.15.1a4.14,4.14,0,0,0-.85,1.13,1,1,0,0,1-.35.36.33.33,0,0,1-.34,0c-.19-.1-.19-.46,0-.78a6.47,6.47,0,0,1,1.34-1.71A2.6,2.6,0,0,1,167.5,190.43Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "167.65px 193.907px 0px",
          }}
          id="eldwhpevwieyw"
          className="animable"
        ></path>
        <path
          d="M146.52,183.79a1.79,1.79,0,0,1,2-.12c.18.13.16.5,0,.81a1,1,0,0,1-.32.32.34.34,0,0,1-.37,0,1.12,1.12,0,0,0-1.21.07l-.24.16a3.76,3.76,0,0,0-1.22,1.8,1.35,1.35,0,0,0-.05.75.38.38,0,0,0,.37.2,1.94,1.94,0,0,0,.7-.2l.58-.3a9.2,9.2,0,0,0,1.56-1.17.53.53,0,0,1,.14-.12c.21-.11.4-.07.46.13a1,1,0,0,1-.31.88,10.18,10.18,0,0,1-1.86,1.4,6.16,6.16,0,0,1-.68.34,2.43,2.43,0,0,1-1,.28.84.84,0,0,1-.84-.51,2.39,2.39,0,0,1,.05-1.6,6.08,6.08,0,0,1,1.95-2.89A3.52,3.52,0,0,1,146.52,183.79Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "146.523px 186.222px 0px",
          }}
          id="eld2m42j706aa"
          className="animable"
        ></path>
        <path
          d="M149.22,161.83a3.18,3.18,0,0,1-.76,1.95,4.83,4.83,0,0,1-1.24,1.07l0,0a.41.41,0,0,1-.27.06v.3a1.07,1.07,0,0,1-.44.81l0,0c-.23.13-.43.06-.48-.17a7.57,7.57,0,0,1-.15-1.2q-.37.69-.81,1.35a1,1,0,0,1-.3.3.33.33,0,0,1-.38,0c-.17-.14-.14-.51.07-.82a15.29,15.29,0,0,0,1.48-2.87,17,17,0,0,1,.9-3.74,1.13,1.13,0,0,1,.43-.54l.14,0c.22-.05.37.11.34.38A13.69,13.69,0,0,1,147,162a3,3,0,0,1,.87-.81,1.58,1.58,0,0,1,.23-.11A.77.77,0,0,1,149.22,161.83ZM148,163.1a1.14,1.14,0,0,0,.28-.63c0-.16-.16-.24-.33-.17l-.07,0a1.59,1.59,0,0,0-.53.58,2.91,2.91,0,0,0-.31.88l.12-.09a.55.55,0,0,1,.22-.07,2.62,2.62,0,0,0,.62-.54"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "146.751px 162.341px 0px",
          }}
          id="elkkxcuahjpy"
          className="animable"
        ></path>
        <path
          d="M213.37,122.13c.69-.4,1.42-.43,1.68.23a3.1,3.1,0,0,1-.47,2.35l-.08.14,1.56-.72c.26-.13.46,0,.43.36a1.07,1.07,0,0,1-.48.78l0,0-3,1.38a.27.27,0,0,1-.43-.21,1,1,0,0,1,.27-.76,7.56,7.56,0,0,0,1.06-1.36,1.51,1.51,0,0,0,.26-1.08c-.1-.24-.43-.21-.75,0a1.31,1.31,0,0,0-.28.2,8,8,0,0,0-1.36,1.88,1.1,1.1,0,0,1-.34.34.32.32,0,0,1-.35,0c-.18-.11-.18-.47,0-.79a10.18,10.18,0,0,1,1.78-2.39A2.66,2.66,0,0,1,213.37,122.13Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "213.724px 124.273px 0px",
          }}
          id="elwnox3ldoc9"
          className="animable"
        ></path>
        <path
          d="M214.12,142.08c.27-.15.49,0,.49.29a1.06,1.06,0,0,1-.49.83c-.54.31-1.08.59-1.63.85l.37,4.5a1.05,1.05,0,0,1-.44.86l0,0c-.25.15-.46,0-.49-.22l-.38-4.72c-.34.14-.68.27-1,.38a45.36,45.36,0,0,1-1.46,4.35,1.09,1.09,0,0,1-.42.51.5.5,0,0,1-.25.07c-.23,0-.3-.33-.16-.68a39.86,39.86,0,0,0,1.33-4l-.39.12c-.26.07-.41-.15-.34-.49a1.12,1.12,0,0,1,.46-.68l.14-.05.47-.15c.46-1.75.83-3.49,1.2-5.21a1,1,0,0,1,.47-.67l0,0a.28.28,0,0,1,.44.26l.38,4.7C213,142.7,213.55,142.42,214.12,142.08Zm-3.28,1.53.58-.21-.13-1.65q-.21.93-.45,1.86"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "211.399px 143.849px 0px",
          }}
          id="eld5l5ovnd7h5"
          className="animable"
        ></path>
        <path
          d="M206.82,130.25a5.77,5.77,0,0,1,.87-.42c.27-.1.44.08.4.41a1.11,1.11,0,0,1-.47.74l-.08,0a5.07,5.07,0,0,0-.71.34,8,8,0,0,0-1.69,1.35c-.33.36-.67.86-.63,1.09s.14.18.3.15a1.37,1.37,0,0,0,.37-.15l.36-.24a12.91,12.91,0,0,0,3.38-3.86,1,1,0,0,1,.34-.35.43.43,0,0,1,.3-.06c.19.06.25.34.12.65a2.94,2.94,0,0,0-.13,2.08,1.07,1.07,0,0,0,1.27.63c.26-.06.4.17.32.51a1,1,0,0,1-.46.66.27.27,0,0,1-.14.05,1.55,1.55,0,0,1-1.89-.93,2.78,2.78,0,0,1-.2-1.11,14,14,0,0,1-2.78,2.76,5.21,5.21,0,0,1-.49.32,2.06,2.06,0,0,1-.68.27.74.74,0,0,1-.95-.67,3.75,3.75,0,0,1,1.22-2.61A9.58,9.58,0,0,1,206.82,130.25Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "207.356px 132.207px 0px",
          }}
          id="el6ac2c2yi2lc"
          className="animable"
        ></path>
        <path
          d="M228.4,149.52a.33.33,0,0,1,.34,0c.2.11.2.46,0,.79a15.52,15.52,0,0,0-2.21,7.45,1.56,1.56,0,0,0,.24,1.08c.17.16.48.1.78-.07a2.17,2.17,0,0,0,.48-.38,6.11,6.11,0,0,0,1.18-2,3.43,3.43,0,0,0,.3-1.27c0-.29-.16-.48-.34-.44l-.1,0a1.57,1.57,0,0,0-.55.75,5.26,5.26,0,0,0-.3,1.52,1.09,1.09,0,0,1-.48.77l-.06,0c-.26.11-.45-.06-.42-.37a6.77,6.77,0,0,1,.43-2.07,3.86,3.86,0,0,1,1.38-1.75,1.66,1.66,0,0,1,.38-.15c.58-.13,1,.31,1,1.07a5.32,5.32,0,0,1-.43,1.94,8.3,8.3,0,0,1-1.65,2.77,4.11,4.11,0,0,1-.84.67,1.33,1.33,0,0,1-1.56.08,2.31,2.31,0,0,1-.44-1.64,17.64,17.64,0,0,1,2.49-8.4A.91.91,0,0,1,228.4,149.52Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "227.982px 154.799px 0px",
          }}
          id="elvpdzp9e2vd"
          className="animable"
        ></path>
        <path
          d="M232.6,144.56a.42.42,0,0,1,.28-.06l4.79,1.09c.22,0,.28.37.12.71a1,1,0,0,1-.39.46.38.38,0,0,1-.28.06l-4.31-1a29,29,0,0,1-2.32,5.21,1.08,1.08,0,0,1-.34.36.36.36,0,0,1-.34,0c-.2-.11-.2-.46,0-.79a26,26,0,0,0,2.35-5.49,1.28,1.28,0,0,1,.31-.51Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "233.77px 147.964px 0px",
          }}
          id="el5zwep8iaw1y"
          className="animable"
        ></path>
        <path
          d="M231.46,127.92a.38.38,0,0,1,.28-.06c.22.06.27.38.1.72-.4.88-.79,1.84-1.17,2.77-.24.6-.49,1.2-.73,1.78a22.31,22.31,0,0,0-.87,2.58,19.38,19.38,0,0,1-1.34,3.61l-.09.17a11.92,11.92,0,0,0-1.44,3.64,1.05,1.05,0,0,1-.48.78l-.05,0c-.27.12-.46,0-.43-.36a13.29,13.29,0,0,1,1.66-4.37l.1-.18a17.59,17.59,0,0,0,1.17-3.22,23.34,23.34,0,0,1,1-2.81c.24-.57.48-1.16.71-1.74.39-1,.79-1.95,1.23-2.88A1,1,0,0,1,231.46,127.92Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "228.589px 135.905px 0px",
          }}
          id="els2cz53vx64p"
          className="animable"
        ></path>
        <path
          d="M232.42,117.87c.51.62.22,1.94-.27,2.9a11.61,11.61,0,0,1-1.76,2.43,7.2,7.2,0,0,1-1.61,1.47,1.2,1.2,0,0,1-1,.18c-.42-.15-.57-.62-.6-1.12a42,42,0,0,1-2.7,3.81.84.84,0,0,1-.25.22.3.3,0,0,1-.42,0,.82.82,0,0,1,.17-.86,41.64,41.64,0,0,0,3.38-5,41,41,0,0,1,1.11-4.61,10.43,10.43,0,0,1,1.06-2.51,4.58,4.58,0,0,1,1.49-1.56,1.78,1.78,0,0,1,.65-.24.25.25,0,0,1,.27.16.64.64,0,0,1,0,.43,43.24,43.24,0,0,1-3.68,8.38l0,.14c-.15.93-.1,1.45.16,1.54a.51.51,0,0,0,.42-.09,5.37,5.37,0,0,0,1.18-1.1,10.22,10.22,0,0,0,1.44-2c.28-.55.44-1.27.2-1.55-.08-.11-.28-.1-.46,0l0,0a.7.7,0,0,0-.28.32,1.08,1.08,0,0,1-.43.56.42.42,0,0,1-.21.06c-.25,0-.34-.27-.22-.62a2.72,2.72,0,0,1,1.09-1.4l.08-.05C231.65,117.55,232.15,117.55,232.42,117.87Zm-3.09-.64q-.3,1-.54,2a40,40,0,0,0,1.93-4.64,3.23,3.23,0,0,0-.57.7,8.9,8.9,0,0,0-.82,2"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "228.221px 120.412px 0px",
          }}
          id="eljrowyx4g88"
          className="animable"
        ></path>
        <path
          d="M220.53,121.64l.12,0c.26-.07.41.14.35.48l-.51,2.64,2.7-1.59c.27-.16.49,0,.5.26a1.1,1.1,0,0,1-.48.84l-3,1.74-.76,4a1.11,1.11,0,0,1-.47.69l-.12.05c-.26.07-.42-.14-.35-.47l.7-3.63-1.76,1c-.27.15-.49,0-.49-.27a1.1,1.1,0,0,1,.47-.84l2-1.18.57-3A1.11,1.11,0,0,1,220.53,121.64Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "220.325px 126.195px 0px",
          }}
          id="elhcrwntp3rq"
          className="animable"
        ></path>
        <path
          d="M241.29,114.86a.29.29,0,0,1,.47.18,1,1,0,0,1-.39.87l-3.22,2.61-.09.07c-.23.13-.43.06-.48-.18a1,1,0,0,1,.38-.87l3.22-2.6Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "239.67px 116.725px 0px",
          }}
          id="el9wwelu0ag37"
          className="animable"
        ></path>
        <path
          d="M241.42,112.4c.23-.14.44-.06.48.18a1,1,0,0,1-.39.87l-3.31,2.61-.09.06c-.23.13-.43.07-.48-.18a1.07,1.07,0,0,1,.39-.87l3.31-2.61A.24.24,0,0,1,241.42,112.4Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "239.766px 114.259px 0px",
          }}
          id="el8q0khudbbpi"
          className="animable"
        ></path>
        <path
          d="M237.1,107.46l.21-.1a.75.75,0,0,1,.86,0c.37.35.35,1.16,0,2.23a11.73,11.73,0,0,1-.79,1.69l.72-.39c.27-.15.48,0,.47.3a1.07,1.07,0,0,1-.48.82h0l-2.09,1.12c-.21.12-.4,0-.45-.17a1,1,0,0,1,.24-.75,9.33,9.33,0,0,0,1.55-2.68c.15-.4.28-.92.13-1.06s-.12,0-.22,0l-.08,0a1.55,1.55,0,0,0-.43.42,5.91,5.91,0,0,0-.67,1.69,1.05,1.05,0,0,1-.45.61.64.64,0,0,1-.18.06c-.24,0-.37-.22-.27-.57a8.06,8.06,0,0,1,1-2.32A3.25,3.25,0,0,1,237.1,107.46Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "236.853px 110.202px 0px",
          }}
          id="elvsrbtvuexk"
          className="animable"
        ></path>
        <path
          d="M253.34,100.51c.6-.35,1.19-.23,1.38.34a3.49,3.49,0,0,1-.4,2.27,17.73,17.73,0,0,1-.94,1.84l2.48-1.52h0c.26-.15.48,0,.49.26a1.06,1.06,0,0,1-.47.84l-4,2.42h0c-.22.12-.41.07-.47-.13a1,1,0,0,1,.21-.76,14.4,14.4,0,0,0,1.86-3.11,2.11,2.11,0,0,0,.28-1.25c0-.17-.26-.21-.45-.1l-.08.06a1,1,0,0,0-.34.79,1,1,0,0,1-.39.87l-.09,0c-.23.14-.43.06-.47-.19a3.11,3.11,0,0,1,1.06-2.47A1.6,1.6,0,0,1,253.34,100.51Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "253.875px 103.669px 0px",
          }}
          id="el5l68mhkeiwu"
          className="animable"
        ></path>
        <path
          d="M247.63,107.35l.05,0c1-.58,2-.22,2.08.82a1,1,0,0,1-.42.86l-.06,0c-.23.14-.45,0-.48-.21-.06-.51-.58-.7-1.14-.39l0,0a4.61,4.61,0,0,0-1.54,1.84,4,4,0,0,0-.5,1.67,1,1,0,0,0,1,1.16,2.66,2.66,0,0,0,1.27-.42,6.57,6.57,0,0,0,.82-.57,21.75,21.75,0,0,0,2.2-2.2,1,1,0,0,1,.2-.17c.18-.1.36-.08.44.08a.87.87,0,0,1-.24.87,22.75,22.75,0,0,1-2.41,2.4,8.15,8.15,0,0,1-1,.71,3.47,3.47,0,0,1-1.71.54,1.62,1.62,0,0,1-1.55-1.86,6.05,6.05,0,0,1,.73-2.5A6.54,6.54,0,0,1,247.63,107.35Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "248.103px 110.707px 0px",
          }}
          id="elxpv8mhtg2z"
          className="animable"
        ></path>
        <path
          d="M217.79,143.3a.38.38,0,0,1,.13-.06,8.94,8.94,0,0,0,2.29-.94c.3-.18.59-.37.88-.57l.06,0c.24-.14.45-.05.48.22a1,1,0,0,1-.43.86,11.59,11.59,0,0,1-1,.63,9.86,9.86,0,0,1-2.57,1.06c-.25.07-.4-.15-.33-.49A1.12,1.12,0,0,1,217.79,143.3Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "219.457px 143.089px 0px",
          }}
          id="ell2zc3af0zzr"
          className="animable"
        ></path>
        <path
          d="M216.86,141.44h0l4.08-2.3c.26-.15.48,0,.48.29a1.09,1.09,0,0,1-.48.83l-4.09,2.3a.3.3,0,0,1-.48-.28A1,1,0,0,1,216.86,141.44Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "218.894px 140.852px 0px",
          }}
          id="elijiijzhl3r"
          className="animable"
        ></path>
        <path
          d="M226.56,129c.22-.13.42-.06.46.18l.78,4.19a1,1,0,0,1-.38.87l-.09.06c-.23.14-.43.07-.48-.17l-.77-4.19a1,1,0,0,1,.38-.87Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "226.94px 131.654px 0px",
          }}
          id="elrfiyiyxmqlf"
          className="animable"
        ></path>
        <path
          d="M233.43,132.53a1.06,1.06,0,0,1,.43-.15c.46-.06.76.33.75,1a4.45,4.45,0,0,1-.34,1.48,16.15,16.15,0,0,1-2.26,4l1.36-.46c.26-.09.43.11.38.44a1.11,1.11,0,0,1-.48.72l-.09,0-2.79.94c-.21.08-.37,0-.38-.29a1,1,0,0,1,.33-.75,13.2,13.2,0,0,0,3.08-4.7,2.59,2.59,0,0,0,.22-.87c0-.16-.07-.27-.13-.27l-.07,0a2.25,2.25,0,0,0-.35.3,10.62,10.62,0,0,0-1.8,2.45.92.92,0,0,1-.36.39.35.35,0,0,1-.32.05c-.2-.09-.22-.43,0-.77a12.8,12.8,0,0,1,2.18-3A3.38,3.38,0,0,1,233.43,132.53Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "232.31px 136.452px 0px",
          }}
          id="elkryet1d4to"
          className="animable"
        ></path>
        <path
          d="M241,129.79c.26-.11.45.06.41.39a1,1,0,0,1-.48.75l-.06,0-.83.34.49,3.59a1.06,1.06,0,0,1-.38.84l-.1.07c-.21.12-.4.07-.46-.13l-.15-.48a.59.59,0,0,1,0-.39l-.43-3.08-.85.35-.4,3a1.1,1.1,0,0,1-.48.74l-.08,0c-.26.1-.44-.09-.4-.42l.4-2.93-.91.38c-.27.11-.45-.06-.41-.39a1.06,1.06,0,0,1,.47-.75l.07,0,.94-.39.81-5.94a1.06,1.06,0,0,1,.46-.73c.26-.14.46-.05.5.2l.74,5.43Zm-2.66,1.1.55-.23-.26-1.89-.29,2.12"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "238.645px 130.189px 0px",
          }}
          id="elnvxkh2muklm"
          className="animable"
        ></path>
        <path
          d="M245.79,120.67a1.93,1.93,0,0,1,.62-.23,1.66,1.66,0,0,1,2.09,1.85,6.37,6.37,0,0,1-1.43,3.4,9.44,9.44,0,0,1-.83.94,1,1,0,0,1,.91.8,3.26,3.26,0,0,1-.3,2,8.69,8.69,0,0,1-1,1.74,17.93,17.93,0,0,1-3.24,3.46l-.09.07c-.23.13-.43.06-.48-.18a1,1,0,0,1,.38-.87,16.64,16.64,0,0,0,2.88-3.07,6.69,6.69,0,0,0,.78-1.29,1.8,1.8,0,0,0,.18-1,.58.58,0,0,0-.58-.4,3.52,3.52,0,0,0-1.08.22c-.22.07-.38-.07-.38-.32a1.11,1.11,0,0,1,.37-.76,12.76,12.76,0,0,0,2-2,4.39,4.39,0,0,0,1-2.23,1.1,1.1,0,0,0-1.43-1.14.79.79,0,0,0-.3.12,3.57,3.57,0,0,0-.78.71,7.83,7.83,0,0,1-.76.77L244,130a1.09,1.09,0,0,1-.48.81c-.29.16-.5,0-.49-.3l.25-7.15a1.11,1.11,0,0,1,.44-.78,5.81,5.81,0,0,0,.89-.84A5.24,5.24,0,0,1,245.79,120.67Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "245.278px 127.571px 0px",
          }}
          id="elkshagdrisug"
          className="animable"
        ></path>
        <path
          d="M268.62,129.14a1.88,1.88,0,0,1,2-.12c.17.13.15.5-.05.81a1,1,0,0,1-.32.33.34.34,0,0,1-.36,0,1.21,1.21,0,0,0-1.31.07l-.13.09a4,4,0,0,0-1.32,1.69,3,3,0,0,0-.24,1.21.94.94,0,0,0,1.45.75,3.39,3.39,0,0,0,1.37-1.79,1.06,1.06,0,0,1,.44-.58.35.35,0,0,1,.19-.06c.25,0,.36.24.25.59a5.51,5.51,0,0,1-2.25,2.95,2.58,2.58,0,0,1-.41.2,1.43,1.43,0,0,1-2-1.44,4.79,4.79,0,0,1,.39-1.94,6.13,6.13,0,0,1,2.06-2.64Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "268.329px 132.095px 0px",
          }}
          id="ellkjb4qd5d7"
          className="animable"
        ></path>
        <path
          d="M278.29,125.34a1,1,0,0,1-.3.88,3,3,0,0,1-.63.48,2.25,2.25,0,0,1-.67.26,7.85,7.85,0,0,1-2.76,3.76,2.11,2.11,0,0,1-.22.14,1.51,1.51,0,0,1-.61.23.59.59,0,0,1-.67-.59,3.09,3.09,0,0,1,.86-1.95l2.29-2.85a.9.9,0,0,1,.24-.21c.17-.1.33-.09.42,0a.46.46,0,0,1,.06.35l.14-.1a.4.4,0,0,1,.29-.06.79.79,0,0,0,.63-.12,1.41,1.41,0,0,0,.32-.24.79.79,0,0,1,.15-.12C278,125.11,278.22,125.15,278.29,125.34Zm-4.44,4.33a5.82,5.82,0,0,0,2.1-3.15l-2.18,2.71a1.91,1.91,0,0,0-.38.59s0,0,.08,0a.72.72,0,0,0,.24-.1l.14-.08"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "275.366px 128.125px 0px",
          }}
          id="el6jdmhgyi10d"
          className="animable"
        ></path>
        <path
          d="M281.75,120.2l.14-.07a2.1,2.1,0,0,1,1.58-.23c.21.07.25.39.09.73a1.08,1.08,0,0,1-.38.43.37.37,0,0,1-.3,0,1.44,1.44,0,0,0-1,.16l-.08,0a2.19,2.19,0,0,0-.77.71,1.31,1.31,0,0,0-.27.88c.08.35.51.37.75.35l.37,0a2.27,2.27,0,0,1,1.1,0c.56.2.88,1,.44,2a4,4,0,0,1-1.43,1.59L279,129l-.06,0c-.24.14-.45,0-.48-.22a1,1,0,0,1,.42-.86l3-2.13a2.26,2.26,0,0,0,.75-.72.49.49,0,0,0-.25-.64,2.12,2.12,0,0,0-.83,0,3,3,0,0,1-.41,0c-.73.06-1.19-.22-1.31-.81a3.14,3.14,0,0,1,.6-2.18A4.26,4.26,0,0,1,281.75,120.2Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "281.059px 124.447px 0px",
          }}
          id="eldgdgm1q5zcs"
          className="animable"
        ></path>
        <path
          d="M268.09,198.84l.07,0,6.06-2.57c.27-.11.45.06.42.38a1.07,1.07,0,0,1-.48.76l-.06,0L268,200c-.26.12-.45-.06-.42-.38A1.14,1.14,0,0,1,268.09,198.84Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "271.11px 198.137px 0px",
          }}
          id="elat8aewfe0uj"
          className="animable"
        ></path>
        <path
          d="M252.63,119.32a3.58,3.58,0,0,1,1.91-.54c.24,0,.32.31.19.65a1.07,1.07,0,0,1-.42.54.43.43,0,0,1-.24.06,2.69,2.69,0,0,0-1.44.41,3,3,0,0,0-.33.21,3.15,3.15,0,0,0-1,1.09c-.19.36-.21.77-.05.87s.52-.09.9-.29l.18-.09a2.47,2.47,0,0,1,1.33-.37,1,1,0,0,1,.9,1,4.36,4.36,0,0,1-1.06,2.68,6.58,6.58,0,0,1-1.9,1.71,3.37,3.37,0,0,1-1.4.49c-.24,0-.36-.25-.25-.59a1,1,0,0,1,.44-.6.47.47,0,0,1,.19-.06,2.59,2.59,0,0,0,1-.35,4.76,4.76,0,0,0,1.39-1.25,2.44,2.44,0,0,0,.6-1.36.42.42,0,0,0-.41-.39,1.79,1.79,0,0,0-.9.27l-.17.09c-.49.26-1.11.58-1.55.32s-.51-1.31,0-2.3a5.21,5.21,0,0,1,1.64-1.88C252.33,119.5,252.48,119.41,252.63,119.32Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "252.35px 123.26px 0px",
          }}
          id="eluu0m4mcgskg"
          className="animable"
        ></path>
        <path
          d="M260.77,115.72a1,1,0,0,1,.83-.15c.42.14.6.73.45,1.51a8.72,8.72,0,0,1-.44,1.42l-.1.23a3.43,3.43,0,0,0-.27,1.11.43.43,0,0,0,.3.44.62.62,0,0,0,.4-.09,1.46,1.46,0,0,0,.21-.16.79.79,0,0,1,.15-.12c.21-.12.4-.08.47.11a1,1,0,0,1-.3.88,3.62,3.62,0,0,1-.53.41,1.42,1.42,0,0,1-.94.21,1,1,0,0,1-.72-1.07,4.72,4.72,0,0,1,.39-1.78l.1-.24a7.52,7.52,0,0,0,.34-1.06c.05-.3,0-.55-.11-.59a.28.28,0,0,0-.22,0,1.56,1.56,0,0,0-.4.38,6.09,6.09,0,0,0-.64,1.36,1,1,0,0,1-.39.49,40.41,40.41,0,0,1-.87,4.15,1.05,1.05,0,0,1-.46.63.31.31,0,0,1-.16.06c-.25,0-.38-.2-.29-.54a38.45,38.45,0,0,0,1.09-5.92,1.05,1.05,0,0,1,.48-.76l.06,0c.24-.11.41,0,.42.31.06-.11.13-.22.2-.33A3.23,3.23,0,0,1,260.77,115.72Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "260.162px 119.694px 0px",
          }}
          id="elqxjbi2vcj2p"
          className="animable"
        ></path>
        <path
          d="M256.93,117.31l.12,0c.26-.08.42.12.36.46l-1,5.62a1.1,1.1,0,0,1-.47.7l-.11,0c-.26.08-.42-.13-.36-.46l1-5.62A1.1,1.1,0,0,1,256.93,117.31Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "256.44px 120.7px 0px",
          }}
          id="elyl0xd9gdyf"
          className="animable"
        ></path>
        <path
          d="M266.71,112.2a2.27,2.27,0,0,1,1-.33c.24,0,.35.25.24.6a1.1,1.1,0,0,1-.44.58.6.6,0,0,1-.2.07,1.2,1.2,0,0,0-.59.19,2.75,2.75,0,0,0-.75.67,3.25,3.25,0,0,0-.67,1.72,1.44,1.44,0,0,0,.4,1.09,1.21,1.21,0,0,0,1.41.15l.13-.07a3.05,3.05,0,0,0,1.2-1.44,1.14,1.14,0,0,1,.42-.51.4.4,0,0,1,.25-.06c.23,0,.3.32.17.66a5.15,5.15,0,0,1-2,2.47l-.19.1a1.81,1.81,0,0,1-2.11-.19,2.16,2.16,0,0,1-.6-1.68,5.3,5.3,0,0,1,1.13-2.89A4.4,4.4,0,0,1,266.71,112.2Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "266.859px 115.107px 0px",
          }}
          id="elpa5lz46k5v"
          className="animable"
        ></path>
        <path
          d="M271.33,110.08l0,0,2.5-1.25c.27-.14.47,0,.46.33a1.09,1.09,0,0,1-.49.8l0,0-2.5,1.25c-.27.13-.47,0-.45-.33A1,1,0,0,1,271.33,110.08Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "272.569px 110.018px 0px",
          }}
          id="elrmz5dn7m95f"
          className="animable"
        ></path>
        <path
          d="M271.05,111.64l.15-.06a11.15,11.15,0,0,0,2.7-1c.27-.13.47,0,.46.33a1.09,1.09,0,0,1-.48.8l0,0a12.52,12.52,0,0,1-2.94,1.08c-.25.06-.4-.17-.32-.51A1.07,1.07,0,0,1,271.05,111.64Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "272.479px 111.665px 0px",
          }}
          id="elfkf30aixvhu"
          className="animable"
        ></path>
        <path
          d="M294,98.37c.28-.15.49,0,.48.29l0,1.53a25.73,25.73,0,0,0,2.3-1.84.51.51,0,0,1,.13-.09c.21-.13.41-.08.47.14a1,1,0,0,1-.34.88,31.7,31.7,0,0,1-2.58,2l0,1.68a1.07,1.07,0,0,1-.49.83c-.27.15-.48,0-.48-.29l0-1.55c-.36.23-.72.46-1.09.67s-.48,0-.49-.27a1.1,1.1,0,0,1,.48-.84c.38-.22.75-.45,1.12-.69l0-1.68A1.1,1.1,0,0,1,294,98.37Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "294.649px 101.019px 0px",
          }}
          id="elke6huhtj4lh"
          className="animable"
        ></path>
        <path
          d="M290.83,93.22a.94.94,0,0,1,.61-.16c.3,0,.5.31.54.73a3,3,0,0,1-.1,1,8.27,8.27,0,0,1-.61,1.7l1.57-1c.26-.15.5-.06.51.24a1.06,1.06,0,0,1-.46.84L290,98.43h0c-.21.13-.4.08-.47-.12a.94.94,0,0,1,.21-.76A7,7,0,0,0,291,95a1.54,1.54,0,0,0,.06-.55c0-.09,0-.17-.09-.17l-.09,0a.7.7,0,0,0-.21.19,5.15,5.15,0,0,0-.48.79,1,1,0,0,1-.36.4.35.35,0,0,1-.32.05c-.2-.08-.22-.42-.05-.76a7.33,7.33,0,0,1,.74-1.19A2.56,2.56,0,0,1,290.83,93.22Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "291.348px 95.7792px 0px",
          }}
          id="elpj3slsmfyp"
          className="animable"
        ></path>
        <path
          d="M289.87,103.09a5.29,5.29,0,0,1-1.13,3,12.53,12.53,0,0,1-2,2.05l-.11.09-.05,0v.35a1,1,0,0,1-.48.83c-.27.15-.49,0-.48-.28l.06-10a11.89,11.89,0,0,0-1,.77l-.11.08c-.21.12-.42.07-.47-.15a1,1,0,0,1,.35-.88A10.25,10.25,0,0,1,286,97.92a4.11,4.11,0,0,1,1.14-.48,1.49,1.49,0,0,1,2,1.23,4.14,4.14,0,0,1-.54,2.48c-.08.16-.18.31-.28.47a3,3,0,0,1,.42,0A1.44,1.44,0,0,1,289.87,103.09Zm-1.69,2.44a3.15,3.15,0,0,0,.72-1.83.83.83,0,0,0-.71-.81,3.32,3.32,0,0,0-1.5.2h-.08l0,4.08a9.15,9.15,0,0,0,1.6-1.64m-1.54-6.79,0,3.34a1.35,1.35,0,0,1,.19-.16h0l.08,0a2.68,2.68,0,0,0,.95-1,2.38,2.38,0,0,0,.31-1.41,1,1,0,0,0-1.31-.74l-.23.07"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "286.982px 103.408px 0px",
          }}
          id="elrjfafu8xgt"
          className="animable"
        ></path>
        <path
          d="M304.58,86.69a.93.93,0,0,1,.87-.14c.35.15.49.63.43,1.37a7.85,7.85,0,0,1-.62,2.33,6.27,6.27,0,0,1,1.49-.63c.26-.07.41.15.35.48a1.15,1.15,0,0,1-.47.69l-.12,0a5.33,5.33,0,0,0-1.3.55,8,8,0,0,0-1.07.75l-.1.07c-.19.11-.36.09-.44-.06a.8.8,0,0,1,.15-.77,6.72,6.72,0,0,0,1.17-3c0-.34,0-.57-.11-.62a.33.33,0,0,0-.23.06.73.73,0,0,0-.18.14,5.11,5.11,0,0,0-.65.81,1,1,0,0,1-.29.27.31.31,0,0,1-.39,0c-.16-.16-.11-.53.1-.84a7.15,7.15,0,0,1,.95-1.15A2.26,2.26,0,0,1,304.58,86.69Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "305.044px 89.3642px 0px",
          }}
          id="elxjaw1gk9i7o"
          className="animable"
        ></path>
        <path
          d="M301.42,92.92c.78-.45,1.52-.4,1.85.15a.86.86,0,0,1-.21.87,1,1,0,0,1-.22.19.3.3,0,0,1-.43-.06c-.16-.27-.58-.27-1,0l-.22.16a5,5,0,0,0-1.31,1.86,15.49,15.49,0,0,0-.76,2.44c-.17.68-.33,1.44-.11,1.76s1,0,1.26-.13l.11-.06a9,9,0,0,0,2.95-3,1.05,1.05,0,0,1,.32-.34.34.34,0,0,1,.36,0c.18.12.17.49,0,.81a11,11,0,0,1-3.6,3.66l-.13.08c-1,.53-1.71.55-2.07,0s-.15-1.94,0-2.62a17.05,17.05,0,0,1,.88-2.79A7.2,7.2,0,0,1,301,93.21,3.52,3.52,0,0,1,301.42,92.92Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "301.076px 97.1657px 0px",
          }}
          id="ele6wqmc2nike"
          className="animable"
        ></path>
        <path
          d="M211.49,166.13c.27-.15.49,0,.49.28a1.08,1.08,0,0,1-.48.83,2,2,0,0,1-1.93.21,1.46,1.46,0,0,1-.49-.47,12.91,12.91,0,0,1-2.75,3.94,5.56,5.56,0,0,1-1.07.85,2.55,2.55,0,0,1-.58.24.93.93,0,0,1-1.28-.78,3.26,3.26,0,0,1,.5-1.93,7.49,7.49,0,0,1,1.12-1.43,12.75,12.75,0,0,1,2.84-2.28A8.16,8.16,0,0,1,209,165l.1,0,.16-.13.09,0c.23-.08.39,0,.39.31a1.22,1.22,0,0,0,.54,1.11A1.29,1.29,0,0,0,211.49,166.13ZM206,170a10.8,10.8,0,0,0,2.45-3.66l-.6.31a11.57,11.57,0,0,0-2.49,2,5.42,5.42,0,0,0-.78,1,1.46,1.46,0,0,0-.24.83c0,.25.27.37.56.29a1.42,1.42,0,0,0,.34-.15A4.28,4.28,0,0,0,206,170"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "207.687px 168.46px 0px",
          }}
          id="elx1yfbn39i9"
          className="animable"
        ></path>
        <path
          d="M209.76,158.55a.4.4,0,0,1,.29-.06l2.48.66c.21.06.26.37.1.72a1,1,0,0,1-.39.45.38.38,0,0,1-.28.06l-2.14-.58-1.65,2.83a1,1,0,0,1-.34.36.33.33,0,0,1-.34,0c-.2-.11-.19-.46,0-.78l2-3.34A.93.93,0,0,1,209.76,158.55Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "210.034px 160.761px 0px",
          }}
          id="elksgjhp0wvm"
          className="animable"
        ></path>
        <path
          d="M216.87,153.07c.52-.31,1-.24,1.2.17a1.88,1.88,0,0,1-.06,1.29,5.91,5.91,0,0,1-.52,1.1c-.37.66-.76,1.31-1.18,1.93l1.65-.79c.27-.13.47,0,.45.35a1.1,1.1,0,0,1-.49.79l0,0-2.95,1.41a.28.28,0,0,1-.43-.17,1,1,0,0,1,.21-.72,29,29,0,0,0,2.08-3.18,4.31,4.31,0,0,0,.35-.72.65.65,0,0,0,0-.37c0-.08-.18-.07-.3,0l0,0a1.79,1.79,0,0,0-.53.62,7.53,7.53,0,0,0-.48,1.08,1.14,1.14,0,0,1-.42.51.4.4,0,0,1-.25.06c-.23,0-.3-.32-.17-.66a10.32,10.32,0,0,1,.63-1.38,3.85,3.85,0,0,1,1.17-1.32Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "216.473px 156.123px 0px",
          }}
          id="elbcvy1xebr4v"
          className="animable"
        ></path>
        <path
          d="M221.78,156.43l.09-.05c.26-.09.44.1.39.43l-.4,2.73c.44-.18.87-.35,1.3-.5.27-.1.44.1.39.43a1,1,0,0,1-.47.72l-.1,0-1.3.51-.16,1.16a1.08,1.08,0,0,1-.48.73l-.09,0c-.26.1-.43-.09-.38-.43l.15-1.07c-.43.2-.86.41-1.29.64-.26.14-.47,0-.47-.31a1.11,1.11,0,0,1,.49-.82h0c.47-.25.95-.49,1.43-.71l.41-2.81A1,1,0,0,1,221.78,156.43Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "221.259px 159.487px 0px",
          }}
          id="elvuo0jg8dou"
          className="animable"
        ></path>
        <path
          d="M241.15,140a1.3,1.3,0,0,1,.86-.2.72.72,0,0,1,.57.65,3,3,0,0,1-.31,1.54,11.31,11.31,0,0,1-.91,1.72l2.2-.82c.27-.1.44.08.4.41a1.12,1.12,0,0,1-.48.74l-.08,0-3.49,1.31c-.21.08-.37,0-.39-.27a1,1,0,0,1,.3-.75,7.92,7.92,0,0,0,1.62-2.5,1.55,1.55,0,0,0,.18-.69.16.16,0,0,0-.14-.14.48.48,0,0,0-.32.07l-.11.08a3,3,0,0,0-.75,1.27,1.09,1.09,0,0,1-.43.58.42.42,0,0,1-.21.06c-.24,0-.35-.25-.24-.59a5.05,5.05,0,0,1,1.39-2.27A3.53,3.53,0,0,1,241.15,140Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "241.672px 142.585px 0px",
          }}
          id="elgdll38us3r7"
          className="animable"
        ></path>
        <path
          d="M245.21,146.36c.24-.14.46,0,.48.23a1.08,1.08,0,0,1-.44.86l-5.05,3.38,0,0c-.24.14-.46,0-.48-.24a1.08,1.08,0,0,1,.44-.85l5-3.39Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "242.705px 148.595px 0px",
          }}
          id="elg0tnm4iykvg"
          className="animable"
        ></path>
        <path
          d="M251.78,144c.26-.07.42.14.36.47a1,1,0,0,1-.47.69l-.11.06a7.54,7.54,0,0,1-3.42.26c-.14,0-.22-.17-.21-.38a1.07,1.07,0,0,1,.27-.62c.3-.34.6-.7.9-1.06-.25.07-.41-.14-.34-.48a9.54,9.54,0,0,1,.55-2,4.46,4.46,0,0,1,1.53-2l.07,0a1.11,1.11,0,0,1,1-.13.84.84,0,0,1,.42.78,4.49,4.49,0,0,1-1,2.38c-.61.82-1.25,1.63-1.9,2.41A6.9,6.9,0,0,0,251.78,144Zm-2.09-1.32v0c.37-.46.72-.93,1.07-1.4a2.63,2.63,0,0,0,.62-1.17.21.21,0,0,0-.12-.18.36.36,0,0,0-.35.05h0a2.27,2.27,0,0,0-.76,1.05,8.45,8.45,0,0,0-.44,1.62"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "250.13px 142.157px 0px",
          }}
          id="elnkbuvvwsa0o"
          className="animable"
        ></path>
        <path
          d="M290.64,111.49l.18-.1c.27-.14.48,0,.47.31a1.05,1.05,0,0,1-.49.82l-.15.09a7.42,7.42,0,0,0-2.76,3.13,13.41,13.41,0,0,0-1.07,5.58c0,.94,0,1.89.45,2.24.3.23.82.18,1.42-.14l.14-.08a11.58,11.58,0,0,0,1.69-1.3l.12-.08c.22-.13.42-.07.47.15a1,1,0,0,1-.35.88,13.39,13.39,0,0,1-1.94,1.47l-.16.09a2,2,0,0,1-2.13.16c-.68-.52-.7-1.76-.67-2.88a14.56,14.56,0,0,1,1.27-6.34A9.63,9.63,0,0,1,290.64,111.49Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "288.571px 118.14px 0px",
          }}
          id="elhltduyuykc8"
          className="animable"
        ></path>
        <path
          d="M294.39,112.45a7,7,0,0,1,1-.47c.26-.11.44.08.4.4a1.07,1.07,0,0,1-.47.75l-.08,0a6.66,6.66,0,0,0-.86.39,2.6,2.6,0,0,0-.82.73,3.63,3.63,0,0,0-.49,1.36,2.33,2.33,0,0,0,.05,1.5c.23.37.78.38,1.42,0l0,0a11,11,0,0,0,1.91-1.61l.16-.12c.21-.12.39-.08.46.11a1,1,0,0,1-.29.88,12.13,12.13,0,0,1-2.22,1.84l-.08,0c-1,.54-1.87.49-2.26-.15a3.31,3.31,0,0,1-.13-2.23,5.54,5.54,0,0,1,.84-2.17A4.21,4.21,0,0,1,294.39,112.45Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "294.519px 115.265px 0px",
          }}
          id="eli4bm78g4f2o"
          className="animable"
        ></path>
        <path
          d="M297.81,108.11a.48.48,0,0,1,.2-.07,6,6,0,0,1,2.92.36,2.88,2.88,0,0,1,1.28,3.13,11.08,11.08,0,0,1-1.73,4,35.3,35.3,0,0,1-2.91,4,1,1,0,0,1-.22.2c-.18.1-.34.09-.43-.06a.83.83,0,0,1,.2-.86,33.9,33.9,0,0,0,2.72-3.7,9,9,0,0,0,1.42-3.17,2.14,2.14,0,0,0-1-2.29,5.49,5.49,0,0,0-2.66-.3c-.24,0-.35-.26-.23-.61A1,1,0,0,1,297.81,108.11Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "299.583px 113.894px 0px",
          }}
          id="el1qg2jxrclh6"
          className="animable"
        ></path>
        <path
          d="M190,189a2.1,2.1,0,0,1,1-.31.88.88,0,0,1,.89.64,4,4,0,0,1-.37,2.49,18.56,18.56,0,0,1-2.21,4.05l2.57-1c.27-.1.45.08.4.41a1.05,1.05,0,0,1-.47.74l-.08,0-3.94,1.55a.27.27,0,0,1-.4-.24,1,1,0,0,1,.28-.74,15.66,15.66,0,0,0,3-4.87,2.72,2.72,0,0,0,.29-1.54.4.4,0,0,0-.4-.26,1.2,1.2,0,0,0-.57.17,1.85,1.85,0,0,0-.39.3,6.83,6.83,0,0,0-1.44,2.43,1.08,1.08,0,0,1-.42.51.39.39,0,0,1-.25.06c-.22,0-.3-.33-.16-.66a9,9,0,0,1,1.95-3.21A3.46,3.46,0,0,1,190,189Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "189.774px 193.146px 0px",
          }}
          id="elvz0wt6hrhb9"
          className="animable"
        ></path>
        <path
          d="M194.61,185.66l.07,0,3.55-1.52a.29.29,0,0,1,.36.06.53.53,0,0,1,0,.47l-1.52,5.27.32-.06c.25,0,.39.18.31.52a1,1,0,0,1-.45.65.52.52,0,0,1-.16.06l-.39.08-1.57,5.44v.05l-.07.24,0,.05a1.11,1.11,0,0,1-.45.58.58.58,0,0,1-.17.06c-.25,0-.38-.2-.28-.54l1.65-5.69-1.27.25c-.26.05-.4-.18-.31-.52a1.08,1.08,0,0,1,.45-.65.47.47,0,0,1,.15-.06l1.34-.27,1.32-4.55-2.94,1.25c-.26.12-.45-.06-.42-.38A1.09,1.09,0,0,1,194.61,185.66Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "196.386px 190.856px 0px",
          }}
          id="elg0lkd6mvqp"
          className="animable"
        ></path>
        <path
          d="M208.14,177.71c.48-.27.87-.29,1.11,0s.35.72-.05,1.86a11.11,11.11,0,0,1-.75,1.71,1,1,0,0,1,1,.14c.69.59.32,2.24-.41,3.43a10.92,10.92,0,0,1-2.36,2.52l-.12.08c-.21.12-.41.07-.47-.16a1,1,0,0,1,.36-.88,8.9,8.9,0,0,0,1.94-2c.4-.65.63-1.56.3-1.84-.18-.15-.47-.08-.78.1a3.27,3.27,0,0,0-.73.58.73.73,0,0,1-.18.14c-.18.11-.35.09-.43-.06a.85.85,0,0,1,.19-.84,10,10,0,0,0,1.61-2.9c.13-.4.18-.69.11-.77s-.16,0-.3.06a2.68,2.68,0,0,0-.47.37,10.77,10.77,0,0,0-1.56,2,1.21,1.21,0,0,1-.32.32.34.34,0,0,1-.37,0c-.17-.13-.16-.49,0-.81a12.51,12.51,0,0,1,1.88-2.35A4.39,4.39,0,0,1,208.14,177.71Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "207.576px 182.507px 0px",
          }}
          id="elwt4e80bgbk9"
          className="animable"
        ></path>
        <path
          d="M214.44,174.41l.24-.13c.78-.35,1.47-.1,1.66.6.27,1.05-.47,2.52-1.06,3.53-.72,1.27-1.5,2.51-2.31,3.72l2.48-1.08c.27-.12.46,0,.43.38a1.09,1.09,0,0,1-.48.76l-.06,0-3.68,1.61a.27.27,0,0,1-.41-.18.9.9,0,0,1,.19-.7c1.12-1.58,2.18-3.23,3.15-4.93.66-1.13.92-1.89.81-2.31s-.44-.43-.83-.26l-.13.07a3.36,3.36,0,0,0-1.07,1.11,9.22,9.22,0,0,0-.89,1.88,1.11,1.11,0,0,1-.43.55.55.55,0,0,1-.23.07c-.23,0-.33-.3-.2-.64a11.41,11.41,0,0,1,1.13-2.37A5.4,5.4,0,0,1,214.44,174.41Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "213.819px 178.982px 0px",
          }}
          id="elmmjyraq16x9"
          className="animable"
        ></path>
        <path
          d="M221.53,174.67c.25-.15.47,0,.48.24a1,1,0,0,1-.45.85l-3.23,2.12,0,0c-.25.14-.46,0-.48-.24a1.06,1.06,0,0,1,.45-.86l3.22-2.11Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "219.93px 176.273px 0px",
          }}
          id="elf9wzhnc5fuu"
          className="animable"
        ></path>
        <path
          d="M221.64,172.64c.25-.15.48,0,.49.25a1.06,1.06,0,0,1-.46.84l-3.52,2.2h0c-.26.15-.48,0-.49-.26a1.09,1.09,0,0,1,.46-.84l3.51-2.2Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "219.895px 174.285px 0px",
          }}
          id="elaozcjb2xzm9"
          className="animable"
        ></path>
        <path
          d="M226.8,167.4c.25-.15.46-.05.49.23a1.1,1.1,0,0,1-.46.86,8.43,8.43,0,0,0-2.88,3.62,2.65,2.65,0,0,0-.29,1.37c.1.42.58.44,1,.25l.15-.08a6,6,0,0,0,1.39-1.27,6.11,6.11,0,0,0,1.26-2c.18-.54.11-1.16-.24-1.17s-.33-.29-.2-.64a1,1,0,0,1,.42-.54.43.43,0,0,1,.23-.07c.86,0,1,1.25.67,2.39a8.47,8.47,0,0,1-1.7,2.75,7.77,7.77,0,0,1-1.83,1.65l-.24.12c-.89.42-1.65.17-1.83-.61a4,4,0,0,1,.42-2.31,10.54,10.54,0,0,1,3.63-4.55Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "225.608px 171.201px 0px",
          }}
          id="el6e8goq2yhij"
          className="animable"
        ></path>
        <path
          d="M229.49,170.46c.23-.12.43-.07.48.16l.41,1.85a1,1,0,0,1-.36.88l-.11.07c-.22.13-.42.07-.47-.16l-.42-1.85a1,1,0,0,1,.37-.87Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "229.701px 171.942px 0px",
          }}
          id="elviihniu1jwc"
          className="animable"
        ></path>
        <path
          d="M239.06,160.2c.27-.12.46.05.43.37l-.25,3a.43.43,0,0,1,.08.24,1,1,0,0,1-.14.46l-.26,3a1.06,1.06,0,0,1-.48.77l-.05,0c-.27.12-.46,0-.43-.36l.23-2.74-1.91,1.09a1.79,1.79,0,0,1,.12.53,5.13,5.13,0,0,1-1.72,3.7,3.75,3.75,0,0,1-.68.49,1.8,1.8,0,0,1-1.64.24c-.64-.29-.91-1.21-.66-2.28a4.61,4.61,0,0,1,1.93-2.76l0,0,0,0a1.38,1.38,0,0,1-.89-1.22A3.67,3.67,0,0,1,234,162a3.16,3.16,0,0,1,.39-.28c.63-.36,1.26-.28,1.52.24a3,3,0,0,1-.18,2.23,6.6,6.6,0,0,1-.42.89l.27.15a2.43,2.43,0,0,1,.25.2l1.72-5.33a1.06,1.06,0,0,1,.44-.58.47.47,0,0,1,.2-.06c.24,0,.35.26.24.6L237,164.5l1.26-.71.24-2.78a1.05,1.05,0,0,1,.48-.78Zm-4.64,9.15a3,3,0,0,0,1-2.11,1.08,1.08,0,0,0-.53-.83l-.28-.15a.84.84,0,0,1-.28.26.38.38,0,0,1-.28.06,1.1,1.1,0,0,1-.41.49h0a2.47,2.47,0,0,0-1,1.44,1.09,1.09,0,0,0,.38,1.28,1.12,1.12,0,0,0,1-.15,2.26,2.26,0,0,0,.42-.31m-.14-6.4a1.62,1.62,0,0,0-.5,1.1c0,.32.24.55.68.72l.13,0a5.73,5.73,0,0,0,.34-.71,1.68,1.68,0,0,0,.13-1.18c-.1-.21-.38-.23-.63-.08a.56.56,0,0,0-.15.1"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "235.55px 165.274px 0px",
          }}
          id="elyvoop2j1xrm"
          className="animable"
        ></path>
        <path
          d="M242.06,157.1a.49.49,0,0,1,.23-.06,6.28,6.28,0,0,0,2.53-.4c.27-.1.45.08.41.4a1.07,1.07,0,0,1-.47.75l-.08,0a6.84,6.84,0,0,1-2.35.45l-.65,2.4a1.56,1.56,0,0,1,.52-.19,1.07,1.07,0,0,1,1.28.54c.42.84.08,2.45-.78,3.73a5.59,5.59,0,0,1-1.7,1.64,2.8,2.8,0,0,1-1,.36c-.25,0-.37-.22-.28-.56a1.06,1.06,0,0,1,.45-.62.64.64,0,0,1,.18-.06,1.81,1.81,0,0,0,.62-.23,3.51,3.51,0,0,0,1.11-1.07,2.64,2.64,0,0,0,.5-2.23.58.58,0,0,0-.69-.27,1,1,0,0,0-.32.12,1.58,1.58,0,0,0-.42.36.94.94,0,0,1-.25.24.35.35,0,0,1-.31,0c-.16,0-.22-.27-.14-.53l1.14-4.22a1.05,1.05,0,0,1,.28-.49A.75.75,0,0,1,242.06,157.1Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "242.463px 161.666px 0px",
          }}
          id="el4ucvmdr562t"
          className="animable"
        ></path>
        <path
          d="M250.6,151.81a.31.31,0,0,1,.12-.05c.26-.08.42.12.36.45l-.65,3.65c.15.06.22.25.15.51a1.11,1.11,0,0,1-.35.58l-.66,3.68a1.09,1.09,0,0,1-.47.71l-.11,0c-.26.08-.43-.12-.37-.45l.67-3.75a5.73,5.73,0,0,1-3.09-.45c-.19-.1-.21-.44,0-.77a1.06,1.06,0,0,1,.36-.39.32.32,0,0,1,.32,0,5.22,5.22,0,0,0,2.67.42l.62-3.45A1,1,0,0,1,250.6,151.81Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "248.571px 156.55px 0px",
          }}
          id="elaql2gh2xdv"
          className="animable"
        ></path>
        <path
          d="M182.9,213.85l0,0c.27-.12.46,0,.44.36l-.63,8.2a1.11,1.11,0,0,1-.48.78l-.05,0c-.27.12-.46,0-.44-.35l.63-8.21A1.11,1.11,0,0,1,182.9,213.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "182.54px 218.52px 0px",
          }}
          id="elfw3kvcie0t"
          className="animable"
        ></path>
        <path
          d="M188.87,211.34a.33.33,0,0,1,.39,0l2.48,2.34,1.91-4.7a1.07,1.07,0,0,1,.41-.51.43.43,0,0,1,.26-.06c.23,0,.3.33.16.67l-2.11,5.19,1.84,1.75c.16.15.13.52-.09.83a1,1,0,0,1-.29.28.31.31,0,0,1-.39,0l-1.62-1.53-1.9,4.68a1,1,0,0,1-.41.5.43.43,0,0,1-.25.07c-.24,0-.31-.33-.17-.68l2.1-5.16-2.7-2.56c-.16-.15-.12-.52.09-.83A1.09,1.09,0,0,1,188.87,211.34Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "191.472px 214.629px 0px",
          }}
          id="el9rbqycxfqpi"
          className="animable"
        ></path>
        <path
          d="M185.32,217.45l0,0,3.63-1.78c.27-.13.47,0,.45.34a1.07,1.07,0,0,1-.48.79l0,0-3.63,1.78c-.27.13-.47,0-.45-.34A1.05,1.05,0,0,1,185.32,217.45Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "187.12px 217.125px 0px",
          }}
          id="elobmgqb2d9mp"
          className="animable"
        ></path>
        <path
          d="M211.47,199.61c.26-.15.45,0,.47.25a1,1,0,0,1-.45.85l-10.08,6.51,0,0c-.26.14-.47,0-.49-.25a1.08,1.08,0,0,1,.46-.85l10.08-6.51Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "206.43px 203.413px 0px",
          }}
          id="elgkz9aa8327u"
          className="animable"
        ></path>
        <path
          d="M206.61,192.22c.27-.14.48,0,.47.31l-.26,7.49a1.06,1.06,0,0,1-.47.81h0c-.27.14-.47,0-.46-.31l.25-7.48A1.15,1.15,0,0,1,206.61,192.22Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "206.485px 196.525px 0px",
          }}
          id="eltu4jfyts2yk"
          className="animable"
        ></path>
        <path
          d="M203.92,208.22a.37.37,0,0,1,.32,0l2.33.93c.23-.65.44-1.3.62-2a1,1,0,0,1,.45-.62.36.36,0,0,1,.17-.07c.25,0,.38.21.29.55-.22.8-.48,1.6-.78,2.39l1.72.69c.2.08.23.42.06.75a1,1,0,0,1-.37.41.42.42,0,0,1-.32.05l-1.59-.64a30.56,30.56,0,0,1-2,4,.83.83,0,0,1-.33.34.32.32,0,0,1-.35,0c-.18-.12-.18-.47,0-.8a29.09,29.09,0,0,0,1.93-3.82l-2.47-1c-.2-.08-.23-.41-.06-.75A1.07,1.07,0,0,1,203.92,208.22Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "206.32px 210.756px 0px",
          }}
          id="elogr266kd33d"
          className="animable"
        ></path>
        <path
          d="M216.76,194.24c.2-.11.39-.07.46.12a10.43,10.43,0,0,1,.46,1.85l1.55-1.07.05,0c.25-.14.45,0,.48.23a1.06,1.06,0,0,1-.43.86l-1.52,1a17,17,0,0,1,.07,1.77,1.1,1.1,0,0,1-.48.82h0c-.27.14-.48,0-.47-.3a14.36,14.36,0,0,0-.06-1.63L215.26,199l0,0c-.25.14-.46.05-.48-.22a1,1,0,0,1,.43-.86l1.55-1.07a11.24,11.24,0,0,0-.4-1.64,1,1,0,0,1,.3-.88A.79.79,0,0,1,216.76,194.24Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "217.27px 197.027px 0px",
          }}
          id="el14xv47dtl01"
          className="animable"
        ></path>
        <path
          d="M229.41,188.36c.25-.14.46-.05.48.23a1.07,1.07,0,0,1-.44.86,45.54,45.54,0,0,0-5.89,4.78.48.48,0,0,1-.15.11c-.21.12-.39.08-.46-.11a.94.94,0,0,1,.3-.88,46.69,46.69,0,0,1,6.12-5Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "226.412px 191.351px 0px",
          }}
          id="elnk8o3gwxk1"
          className="animable"
        ></path>
        <path
          d="M226.13,180.68h0c.27-.14.48,0,.47.31l-.22,6.67a1.05,1.05,0,0,1-.48.81l0,0c-.27.14-.48,0-.47-.31l.22-6.68A1.08,1.08,0,0,1,226.13,180.68Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "226.015px 184.575px 0px",
          }}
          id="elzyadzwa9hha"
          className="animable"
        ></path>
        <path
          d="M224.05,198.43l.27-.13a.7.7,0,0,1,1,.48,2.45,2.45,0,0,1-.36,1.53,6.2,6.2,0,0,1-.76,1.05l-2,2.38,1.9-.27c.25,0,.38.21.29.55a1.07,1.07,0,0,1-.46.62.35.35,0,0,1-.17.06l-2.89.41c-.18,0-.3-.09-.31-.3a1,1,0,0,1,.25-.67l2.91-3.49a4.42,4.42,0,0,0,.51-.7.79.79,0,0,0,.13-.39c0-.07-.12-.11-.25-.06l-.09,0a2.32,2.32,0,0,0-.47.42,5.1,5.1,0,0,0-1,1.84,1.12,1.12,0,0,1-.44.6.52.52,0,0,1-.19.06c-.25,0-.37-.24-.26-.58a7.39,7.39,0,0,1,1.51-2.69A4.12,4.12,0,0,1,224.05,198.43Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "222.946px 201.667px 0px",
          }}
          id="elcjkcvipwmv5"
          className="animable"
        ></path>
        <path
          d="M230.21,193.35a.42.42,0,0,1,.28-.06c.22,0,.28.36.13.7a64.8,64.8,0,0,0-3.32,9.34,1.07,1.07,0,0,1-.46.62.35.35,0,0,1-.17.06c-.25,0-.38-.2-.28-.55.43-1.6.94-3.22,1.51-4.82a5.18,5.18,0,0,1-2.41-1.07c-.17-.14-.14-.51.07-.82a1,1,0,0,1,.31-.31.32.32,0,0,1,.37,0,4.44,4.44,0,0,0,2.13.95c.45-1.19.93-2.37,1.45-3.56A1,1,0,0,1,230.21,193.35Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "228.041px 198.648px 0px",
          }}
          id="eluce2t3peq7"
          className="animable"
        ></path>
        <path
          d="M241.64,208.05a.29.29,0,0,1,.47.25,1.07,1.07,0,0,1-.46.86l-10.16,6.47h0c-.25.15-.47.05-.48-.25a1.05,1.05,0,0,1,.45-.84l10.17-6.48Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "236.56px 211.843px 0px",
          }}
          id="eldqxpops8ae"
          className="animable"
        ></path>
        <path
          d="M244.69,197.26a.3.3,0,0,1,.42,0c1.88,2.69,2.6,6.72,2,11.35A37,37,0,0,1,242,222.85a.94.94,0,0,1-.33.33.34.34,0,0,1-.36,0c-.18-.12-.17-.48,0-.8A34.68,34.68,0,0,0,246.18,209c.54-4.36-.14-8.15-1.91-10.69a.79.79,0,0,1,.17-.86A.68.68,0,0,1,244.69,197.26Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "244.248px 210.203px 0px",
          }}
          id="elfkg5iahluen"
          className="animable"
        ></path>
        <path
          d="M245,169.38a.39.39,0,0,1,.32,0,.35.35,0,0,1,.17.35l-.1,3.48a1.07,1.07,0,0,1-.48.81c-.29.15-.5,0-.49-.3l.08-2.77-10,7.87,9.4.27c.15,0,.25.13.26.33a1.1,1.1,0,0,1-.25.64,108.11,108.11,0,0,0-9.17,12.92l.39-.23a30.63,30.63,0,0,1,10.44-3.9l-.08-1.88a1,1,0,0,1,.45-.85c.27-.16.5-.06.51.23l.12,2.72a1,1,0,0,1-.2.59.89.89,0,0,1-.28.27.43.43,0,0,1-.18.06,28.89,28.89,0,0,0-10.74,3.85c-.55.32-1.11.66-1.66,1-.22.13-.39.09-.47-.06a.79.79,0,0,1,.1-.68,111.1,111.1,0,0,1,9.52-13.81l-9.85-.28c-.18,0-.29-.18-.25-.43a1.09,1.09,0,0,1,.38-.69l11.93-9.42Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "239.561px 182.132px 0px",
          }}
          id="elx9ni32krtwo"
          className="animable"
        ></path>
        <path
          d="M248.73,184.66c.27-.15.49,0,.49.27l0,1.79a4.05,4.05,0,0,1,1.23-1.27,1.23,1.23,0,0,1,.73-.2c.47.05.7.46.83.93l.59-.41,0,0c.25-.14.46,0,.49.22a1.05,1.05,0,0,1-.43.86l-1,.72-.06,0c-.22.13-.42.06-.47-.17-.09-.42-.2-.88-.48-.91a.43.43,0,0,0-.23.07,2.11,2.11,0,0,0-.72.87,6.46,6.46,0,0,0-.49,2,1.09,1.09,0,0,1-.47.74l0,0a.29.29,0,0,1-.45-.29l-.06-4.37A1.09,1.09,0,0,1,248.73,184.66Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "250.66px 187.411px 0px",
          }}
          id="els2wdzrig9xr"
          className="animable"
        ></path>
        <path
          d="M296.71,171.26a.47.47,0,0,1,.19-.06c.24,0,.36.24.26.58a17.77,17.77,0,0,1-.75,2l1.19.61c.19.11.2.45,0,.78a1.18,1.18,0,0,1-.35.38.35.35,0,0,1-.34,0L295.8,175a18.52,18.52,0,0,1-1.36,2.11,1.17,1.17,0,0,1-.27.24.31.31,0,0,1-.41,0,.77.77,0,0,1,.15-.85,15.36,15.36,0,0,0,1.19-1.85l-.82-.42c-.19-.1-.2-.45,0-.78a1,1,0,0,1,.35-.37.35.35,0,0,1,.34,0l.75.39a13.47,13.47,0,0,0,.56-1.53A1.08,1.08,0,0,1,296.71,171.26Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "295.72px 174.314px 0px",
          }}
          id="el7eu9niypfzc"
          className="animable"
        ></path>
        <path
          d="M165.17,248.38a.37.37,0,0,1,.33,0c.2.1.21.44,0,.77-.48.89-.92,1.79-1.33,2.7l1.77.81c.2.09.22.43,0,.77a1,1,0,0,1-.36.39.34.34,0,0,1-.32,0l-1.67-.76a34.34,34.34,0,0,0-1.75,5.6,1,1,0,0,1-.47.67l-.13.05c-.25.06-.4-.16-.33-.49a36.22,36.22,0,0,1,2-6.16l-1.65-.76c-.2-.09-.22-.43,0-.76a1,1,0,0,1,.36-.39.37.37,0,0,1,.33,0l1.54.71c.42-.92.86-1.83,1.35-2.71A1,1,0,0,1,165.17,248.38Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "163.495px 253.866px 0px",
          }}
          id="elbxsz1inhaxl"
          className="animable"
        ></path>
        <path
          d="M178.93,237.12l.09,0c.26-.1.44.08.39.41A53.71,53.71,0,0,1,174,254.18a1,1,0,0,1-.37.41.33.33,0,0,1-.31,0c-.2-.07-.24-.41-.07-.74a55.62,55.62,0,0,0,3.64-9.09,7.55,7.55,0,0,1-5.59-1.69c-.17-.15-.13-.52.07-.83a1,1,0,0,1,.3-.29.3.3,0,0,1,.38,0,7,7,0,0,0,5.21,1.57,46.77,46.77,0,0,0,1.18-5.71A1.07,1.07,0,0,1,178.93,237.12Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "175.306px 245.861px 0px",
          }}
          id="el3o5b4iugwe6"
          className="animable"
        ></path>
        <path
          d="M180.4,245l.09,0,5.23-2.06c.26-.1.44.08.4.41a1,1,0,0,1-.48.74l-.08,0-5.22,2.05c-.27.11-.45-.07-.4-.4A1,1,0,0,1,180.4,245Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "183.029px 244.542px 0px",
          }}
          id="el4gummgbmb0r"
          className="animable"
        ></path>
        <path
          d="M180.87,242.8a.31.31,0,0,1,.13-.06l3.55-.94c.26-.07.41.15.34.49a1.06,1.06,0,0,1-.47.68l-.12.05-3.56.94c-.26.07-.41-.15-.34-.48A1,1,0,0,1,180.87,242.8Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "182.645px 242.88px 0px",
          }}
          id="el7ecaa261d2q"
          className="animable"
        ></path>
        <path
          d="M203.47,231.75l0,0,4.93-2.39c.27-.12.47,0,.45.34a1.11,1.11,0,0,1-.49.8l0,0-4.92,2.38c-.27.13-.46,0-.44-.35A1.05,1.05,0,0,1,203.47,231.75Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "205.925px 231.122px 0px",
          }}
          id="elj5g9w2ypo6a"
          className="animable"
        ></path>
        <path
          d="M212.31,217.54c.2-.11.38-.08.45.1a13.2,13.2,0,0,1,.81,5.94,1.05,1.05,0,0,1-.48.78l0,0c-.27.13-.46,0-.44-.35a12.27,12.27,0,0,0-.75-5.48.93.93,0,0,1,.28-.88A.75.75,0,0,1,212.31,217.54Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "212.753px 220.943px 0px",
          }}
          id="el5rdwj6s4jdx"
          className="animable"
        ></path>
        <path
          d="M218.86,216.86a.35.35,0,0,1,.29-.05c.22.06.26.39.1.72l-7.83,16.52a1,1,0,0,1-.39.44.4.4,0,0,1-.29.06c-.21-.06-.25-.39-.09-.73l7.82-16.51A1.09,1.09,0,0,1,218.86,216.86Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "214.95px 225.677px 0px",
          }}
          id="el5c6mma9uaav"
          className="animable"
        ></path>
        <path
          d="M220.42,222.56a3.31,3.31,0,0,1-.26,2,10.62,10.62,0,0,1-1,1.74l-.5.77.09.26a4.1,4.1,0,0,1-.39,3.24A3.75,3.75,0,0,1,217,232a1.54,1.54,0,0,1-1.44.19,1.22,1.22,0,0,1-.54-.65.29.29,0,0,1-.18-.11.63.63,0,0,1,0-.58,4.07,4.07,0,0,1,.18-1.5,1.08,1.08,0,0,1,.45-.6.32.32,0,0,1,.18-.06c.25,0,.37.22.26.57,0,.1-.05.19-.06.29.55-.7,1.09-1.42,1.61-2.17a4.86,4.86,0,0,1-.42-1.27,4.42,4.42,0,0,1,1.11-3.48,2.44,2.44,0,0,1,.58-.46,1.48,1.48,0,0,1,.75-.23A.86.86,0,0,1,220.42,222.56Zm-2.71,7.63a2.55,2.55,0,0,0,.17-2c-.6.85-1.23,1.67-1.88,2.47a.59.59,0,0,0,.26.28.85.85,0,0,0,.77-.11,1.92,1.92,0,0,0,.68-.68m1.62-5.74a1.83,1.83,0,0,0,.15-1,.34.34,0,0,0-.36-.25.7.7,0,0,0-.33.1,1.12,1.12,0,0,0-.21.17,2.46,2.46,0,0,0-.53,1.92,3.82,3.82,0,0,0,.26.85l.26-.4a8.61,8.61,0,0,0,.76-1.35"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "217.621px 227.111px 0px",
          }}
          id="elqwjdaeu9dl"
          className="animable"
        ></path>
        <path
          d="M229.21,209.16a.34.34,0,0,1,.36,0c.18.12.16.48,0,.8a24.23,24.23,0,0,0-3.52,9.69,8.46,8.46,0,0,0,.32,4.1,2.34,2.34,0,0,0,2.37,1.67c.24,0,.36.24.25.59a1.1,1.1,0,0,1-.45.59.62.62,0,0,1-.19.07,2.85,2.85,0,0,1-2.89-2,9.69,9.69,0,0,1-.37-4.62,26.46,26.46,0,0,1,3.82-10.54A1,1,0,0,1,229.21,209.16Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "227.331px 217.892px 0px",
          }}
          id="el41jp0qwlunw"
          className="animable"
        ></path>
        <path
          d="M237,200.91l0,0c.26-.15.48,0,.47.3l-.13,6.2a1,1,0,0,1-.48.82c-.28.15-.49,0-.48-.29l.12-6.2A1.07,1.07,0,0,1,237,200.91Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "236.925px 204.57px 0px",
          }}
          id="el4en9cysd5k3"
          className="animable"
        ></path>
        <path
          d="M231.3,218.14a.43.43,0,0,1,.26-.06,7.26,7.26,0,0,1,1.92.59l1.05-2.13a1.15,1.15,0,0,1,.38-.43.37.37,0,0,1,.3-.05c.21.07.25.4.08.74L234.18,219a7.55,7.55,0,0,1,1.58,1.3.76.76,0,0,1-.12.85,1,1,0,0,1-.28.26.31.31,0,0,1-.4,0,6.7,6.7,0,0,0-1.39-1.16l-1.43,2.88a.94.94,0,0,1-.37.43.4.4,0,0,1-.31,0c-.21-.07-.24-.4-.08-.73l1.49-3a6.61,6.61,0,0,0-1.83-.57c-.23,0-.29-.35-.14-.69A1,1,0,0,1,231.3,218.14Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "233.328px 219.819px 0px",
          }}
          id="el5tv6177si1g"
          className="animable"
        ></path>
        <path
          d="M241.12,212.5a.39.39,0,0,1,.29-.05c.22.06.26.38.1.72-.62,1.31-1.21,2.64-1.79,4l.25.16c.19.12.18.47,0,.79a1,1,0,0,1-.33.36.37.37,0,0,1-.35,0l-.11-.07c-.94,2.19-1.83,4.4-2.65,6.59a1.07,1.07,0,0,1-.42.54.57.57,0,0,1-.24.06c-.24,0-.32-.3-.19-.65.87-2.32,1.81-4.65,2.81-7l-2.42-1.48c-.19-.11-.18-.47,0-.79a1.08,1.08,0,0,1,.34-.36.34.34,0,0,1,.35,0l2.26,1.39c.56-1.25,1.13-2.51,1.71-3.76A1.09,1.09,0,0,1,241.12,212.5Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "238.613px 219.02px 0px",
          }}
          id="elco74pv79suu"
          className="animable"
        ></path>
        <path
          d="M250.92,204c.25-.14.46,0,.48.22l.26,2.52,1.32-.87,0,0a.29.29,0,0,1,.48.24,1.1,1.1,0,0,1-.45.85l-1.29.86.24,2.39a1,1,0,0,1-.43.86l0,0c-.24.14-.45,0-.48-.22l-.24-2.44-1.87,1.24,0,0c-.25.15-.46.05-.49-.24a1.06,1.06,0,0,1,.45-.85l1.83-1.21-.25-2.49a1,1,0,0,1,.43-.86Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "250.955px 207.535px 0px",
          }}
          id="elj4rvghs8xai"
          className="animable"
        ></path>
        <path
          d="M264.92,190.29a1.31,1.31,0,0,1,1.24-.14,1.19,1.19,0,0,1,.59,1.09,4.62,4.62,0,0,1-.69,2.24,12.14,12.14,0,0,1-1.24,1.74l-.66.82,4.11-2.19c.26-.14.47,0,.47.31a1.11,1.11,0,0,1-.49.82l-5.78,3.09c-.22.11-.4,0-.45-.17a.92.92,0,0,1,.22-.74l2.09-2.61a12.33,12.33,0,0,0,1-1.44,2.68,2.68,0,0,0,.42-1.27.55.55,0,0,0-.28-.5.62.62,0,0,0-.57,0,1.9,1.9,0,0,0-.58.66,1.7,1.7,0,0,0-.23.8,1.05,1.05,0,0,1-.46.85l0,0c-.25.14-.47,0-.48-.26a3.48,3.48,0,0,1,.5-1.76,3.78,3.78,0,0,1,1.24-1.39Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "265.375px 194.084px 0px",
          }}
          id="ell8181jkwirq"
          className="animable"
        ></path>
        <path
          d="M270.69,195.43l.07,0L274.4,194c.26-.1.44.08.4.41a1.09,1.09,0,0,1-.48.74l-.08,0-3.62,1.42c-.27.1-.45-.08-.41-.41A1.1,1.1,0,0,1,270.69,195.43Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "272.505px 195.285px 0px",
          }}
          id="elgaso92c94vg"
          className="animable"
        ></path>
        <path
          d="M279.78,185.87c.24-.14.46,0,.48.24a40,40,0,0,1-1.06,11.67,1.07,1.07,0,0,1-.46.66l-.14.06c-.26.05-.4-.17-.33-.51a38.45,38.45,0,0,0,1-11.24,1,1,0,0,1,.45-.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "279.288px 192.161px 0px",
          }}
          id="elmvmj98k10wb"
          className="animable"
        ></path>
        <path
          d="M128.14,214l6.29-3.55c.27-.16.49,0,.48.28a1,1,0,0,1-.48.83l-6.3,3.56c-.27.16-.48,0-.48-.28A1,1,0,0,1,128.14,214Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "131.28px 212.785px 0px",
          }}
          id="el8z4idv1pyd"
          className="animable"
        ></path>
        <path
          d="M132.76,204.86a.33.33,0,0,1,.19-.06l10.26-1.13c.17,0,.28.1.3.29a1,1,0,0,1-.21.64l-9.59,13a.79.79,0,0,1-.27.25.3.3,0,0,1-.4,0c-.15-.17-.09-.55.13-.85L142,205l-9.43,1c-.25,0-.37-.22-.27-.56A1.11,1.11,0,0,1,132.76,204.86Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "137.888px 210.798px 0px",
          }}
          id="elfbrel1io8u6"
          className="animable"
        ></path>
        <path
          d="M133.5,207.5c.26-.16.48-.05.49.24a1,1,0,0,1-.45.85L128,212.12l0,0c-.26.14-.47,0-.49-.25A1.07,1.07,0,0,1,128,211l5.5-3.53Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "130.75px 209.801px 0px",
          }}
          id="el48wr5kyorxb"
          className="animable"
        ></path>
        <path
          d="M204.43,158.17a1.05,1.05,0,0,1-.35.88,3,3,0,0,1-.39.27,1.34,1.34,0,0,1-1.59,0,2.12,2.12,0,0,1-.53-.82,14,14,0,0,1-2.5,2.81,3.22,3.22,0,0,1-.46.34.81.81,0,0,1-.77.11c-.25-.14-.35-.49-.3-1a5.73,5.73,0,0,1,1.58-3.19,3.86,3.86,0,0,1,.81-.63,1.85,1.85,0,0,1,1.68-.23.27.27,0,0,1,.14.17l0,0,.12-.05a.26.26,0,0,1,.35.18,2.74,2.74,0,0,0,.6,1.22.71.71,0,0,0,.82.05.91.91,0,0,0,.16-.11L204,158C204.17,157.89,204.37,158,204.43,158.17Zm-5.57,2.15a11.93,11.93,0,0,0,2.15-2.44l-.06,0a1.09,1.09,0,0,0-1,.14,2.29,2.29,0,0,0-.48.37,3.48,3.48,0,0,0-1,1.93.51.51,0,0,0,0,.25s0,0,.08,0a1.57,1.57,0,0,0,.26-.19"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "200.981px 159.208px 0px",
          }}
          id="elhpax214aldv"
          className="animable"
        ></path>
        <path
          d="M199.84,154.13c.23,0,.36.14.33.43a1,1,0,0,1-.48.74c-7.75,4.42-15.77,8.8-23.54,13s-15.76,8.6-23.5,13c-.25.15-.46,0-.48-.24l-1-21.63a1,1,0,0,1,.25-.66.7.7,0,0,1,.23-.2.4.4,0,0,1,.29-.06c8.22,2.13,18.65.5,28.63-1.36,3.07-.57,6.41-1.06,9.64-1.53S196.78,154.7,199.84,154.13Zm-13.58,7.56a4.09,4.09,0,0,1-.26-1.91,7.73,7.73,0,0,1,.64-2.4c-2.17.32-4.33.66-6.37,1-7.66,1.43-15.58,2.72-22.61,2.3a14.15,14.15,0,0,1-5.12,6.71l.26,5.8,4.31-2.48c.26-.16.48,0,.49.26,0,1.06.1,2.16.17,3.22s.13,2,.17,3c6.07-3.4,12.23-6.77,18.24-10.05,3.33-1.81,6.7-3.65,10.08-5.51m1.09-.6c3.15-1.74,6.3-3.48,9.41-5.24-2.25.37-4.59.71-6.87,1.05l-2.29.33a5.65,5.65,0,0,0-.63,2.11,2.63,2.63,0,0,0,.38,1.75M152.2,160l.29,6.37a12.2,12.2,0,0,0,4.32-5.69,33.87,33.87,0,0,1-4.61-.68m.92,20c1.27-.73,2.56-1.45,3.85-2.17,0-1-.1-2-.16-2.94s-.12-1.82-.16-2.73l-3.8,2.19.27,5.65"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "175.672px 167.745px 0px",
          }}
          id="ellbzurmjtxj"
          className="animable"
        ></path>
        <path
          d="M287.81,186.62a7.78,7.78,0,0,1-2.19,5.62,4.91,4.91,0,0,1-.94.72,2,2,0,0,1-1.58.3c-.92-.32-1.2-1.58-.71-3.29a7.91,7.91,0,0,1,3-4.37l.18-.09C286.81,184.89,287.65,185.31,287.81,186.62Zm-2.5,4.74a5.67,5.67,0,0,0,1.54-4c-.07-.58-.36-1.15-1.35-.66l-.11.06a5.66,5.66,0,0,0-2.1,3.13c-.16.56-.43,1.89.42,2.19a1.24,1.24,0,0,0,1-.2,3.29,3.29,0,0,0,.63-.48"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "284.982px 189.27px 0px",
          }}
          id="eltv9lr2g768"
          className="animable"
        ></path>
        <path
          d="M254.84,199a.34.34,0,0,1,.36,0l2.78,1.91,2-4.33a1.06,1.06,0,0,1,.39-.46.43.43,0,0,1,.28-.06c.22.06.27.38.12.71l-2.09,4.59,2.06,1.42c.18.12.17.48,0,.8a1.08,1.08,0,0,1-.33.34.36.36,0,0,1-.36,0l-1.92-1.31-1.93,4.24a1,1,0,0,1-.4.46.36.36,0,0,1-.28.06c-.22-.05-.27-.37-.11-.71l2.05-4.52-2.92-2c-.19-.13-.17-.49,0-.81A1,1,0,0,1,254.84,199Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "257.638px 201.717px 0px",
          }}
          id="el2i1h44mw85g"
          className="animable"
        ></path>
        <path
          d="M288.05,144.24c.14.07.19.26.14.5a1.14,1.14,0,0,1-.4.62,16.19,16.19,0,0,0-4.66,5.74,1.08,1.08,0,0,1-.38.43.52.52,0,0,1-.16.06c-.19,0-.32-.1-.32-.34a23.3,23.3,0,0,1,.17-2.6l.09-1a14,14,0,0,0-1.27.66,27.64,27.64,0,0,0-7.09,6.25,64.34,64.34,0,0,0-7.2,11A116.07,116.07,0,0,0,258.91,184a1.09,1.09,0,0,1-.44.57.44.44,0,0,1-.21.07c-.24,0-.34-.27-.23-.61a118,118,0,0,1,8.22-18.84,67.29,67.29,0,0,1,7.46-11.34,29.66,29.66,0,0,1,7.54-6.65c.44-.26.88-.48,1.31-.68,0-1.77.07-2.67.43-3.27a1.39,1.39,0,0,1,.5-.52c.79-.46,2,.07,4.05,1.22C287.77,144.09,288,144.2,288.05,144.24Zm-4.74,4.91a18.28,18.28,0,0,1,3.42-4.07c-1.61-.91-2.65-1.33-3.11-1.26a18.24,18.24,0,0,0-.09,2.25v.23a.45.45,0,0,1,.08.34.87.87,0,0,1-.1.31c0,.42-.07.85-.11,1.28l-.09.92"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "273.097px 163.602px 0px",
          }}
          id="el802dlmzd77l"
          className="animable"
        ></path>
        <path
          d="M256,149.25c.28-.11.44,0,.48.2l.68,4.9a1,1,0,0,1-.41.87c-.3.18-.51.1-.55-.15l-.44-3.2-.53,1.63a.32.32,0,0,1,.18.32l.16,35.33c10.48-5.13,22-11.16,37-19.38L290,169.3c-.23,0-.29-.35-.14-.69a1,1,0,0,1,.4-.48.42.42,0,0,1,.27-.07l3.72.71.28-.15c.26-.14.47,0,.47.29l1.49.29c.16,0,.24.21.2.46a1.14,1.14,0,0,1-.4.66l-4.8,3.59c-.31.18-.51.1-.55-.15a1.06,1.06,0,0,1,.41-.87l3.55-2.66-.94-.18c-16,8.78-28,15.11-39,20.47-.26.12-.45,0-.45-.3l-.15-34.35-1.05,3.18a1,1,0,0,1-.43.57.42.42,0,0,1-.21.06c-.24,0-.35-.26-.23-.6l3-9.25A1.09,1.09,0,0,1,256,149.25Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "274.546px 169.886px 0px",
          }}
          id="elnqssp2pi5t7"
          className="animable"
        ></path>
        <path
          d="M264.59,133.48c.58.48.37,1.79-.18,2.78a7.58,7.58,0,0,1-1.9,2.16,5,5,0,0,1-.62.44,1.18,1.18,0,0,1-1,.19c-.49-.23-.49-1-.45-1.62s.1-1,.17-1.48l-.77,1.53a4.84,4.84,0,0,1-1.55,2,.92.92,0,0,1-.75.12,5.85,5.85,0,0,1-.3.68,4.35,4.35,0,0,1-1.48,1.68,1.51,1.51,0,0,1-.64.21c-.53,0-.88-.43-.92-1.14a4.62,4.62,0,0,1,.49-2,5.94,5.94,0,0,1,1.31-1.84,3.4,3.4,0,0,1,.53-.39,1.43,1.43,0,0,1,1.17-.21c.2.08.23.39.08.71.21,0,.31.21.25.5l-.06.32a.35.35,0,0,0,.05.18.2.2,0,0,0,.26.07,3.13,3.13,0,0,0,.8-1.17l2.2-4.32a29.33,29.33,0,0,1,1.56-4.2,1.09,1.09,0,0,1,.39-.45.42.42,0,0,1,.14-.06c.19,0,.33.06.35.29a7.58,7.58,0,0,1-1.12,3.57l-.47.93a21.3,21.3,0,0,0-.72,4c0,.53,0,.81.13.87s.2,0,.38-.1a3.36,3.36,0,0,0,.43-.31,5.3,5.3,0,0,0,1.39-1.53c.25-.46.37-1.1.15-1.29s-.38-.07-.65.08l-.05,0a6.32,6.32,0,0,0-.93.72l-.12.09c-.22.12-.41.07-.47-.15a1,1,0,0,1,.35-.88,7.36,7.36,0,0,1,1.17-.89l.08,0A1.22,1.22,0,0,1,264.59,133.48Zm-7.49,4.41,0-.07H257a.63.63,0,0,0-.54.1,1.26,1.26,0,0,0-.27.2,3.54,3.54,0,0,0-.79,1.13,2.69,2.69,0,0,0-.31,1.18c0,.3.16.5.36.5a.46.46,0,0,0,.23-.08,2.19,2.19,0,0,0,.74-.86,5.87,5.87,0,0,0,.5-1.48,2.42,2.42,0,0,1,.14-.61"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "259.568px 135.17px 0px",
          }}
          id="elus8llmvyn1"
          className="animable"
        ></path>
        <path
          d="M282.51,104.11l0,0c.27-.14.47,0,.46.32,0,.72,0,1.42,0,2.1l1.25-.84.05,0c.25-.15.45,0,.48.23a1.08,1.08,0,0,1-.44.86l-1.28.86c0,.42.08.84.13,1.25a1,1,0,0,1-.4.86l-.07,0c-.24.14-.44.06-.48-.2-.06-.43-.11-.87-.14-1.32L281,109l0,0c-.25.14-.46,0-.48-.23a1,1,0,0,1,.44-.86l1.08-.73c0-.73,0-1.49,0-2.25A1.07,1.07,0,0,1,282.51,104.11Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "282.635px 106.937px 0px",
          }}
          id="el4oz8t2x84hm"
          className="animable"
        ></path>
        <path
          d="M280.18,107c.25-.15.46,0,.48.23a1.06,1.06,0,0,1-.45.86l-.78.52c.21,1,.42,2,.61,3.06a1,1,0,0,1-.38.88l-.09,0c-.23.14-.43.07-.48-.18-.2-1.13-.41-2.19-.63-3.16l-1.45,1-.39,4.12a1.09,1.09,0,0,1-.48.77l-.06,0c-.27.12-.45-.05-.42-.37l.36-3.89,0,0,0,0c-.25.15-.47,0-.48-.23a1.06,1.06,0,0,1,.43-.86l.25-.16.59-6.22a1.07,1.07,0,0,1,.41-.72l.07,0c.19-.11.37-.07.44.09a27.08,27.08,0,0,1,1.56,4.84l.92-.61Zm-3.06,2,1.11-.74c-.25-1-.51-2-.78-2.77l-.33,3.51"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "278.1px 108.863px 0px",
          }}
          id="elhmwsknii4x4"
          className="animable"
        ></path>
        <path
          d="M278.92,99a1.45,1.45,0,0,1,.29-.13.88.88,0,0,1,1.17.77,3.68,3.68,0,0,1-.33,2l-.07.15-.05.13,1.42-1,.06,0c.24-.15.45,0,.48.21a1.06,1.06,0,0,1-.42.86l-1.45,1a2,2,0,0,1-.24.16.69.69,0,0,1-.63.1c-.24-.12-.33-.49-.2-1a3.7,3.7,0,0,1,.22-.62l.06-.13a2,2,0,0,0,.2-1.08c-.05-.26-.23-.39-.43-.33l-.07,0a.81.81,0,0,0-.34.44,1.12,1.12,0,0,1-.47.69l-.12,0c-.27.08-.42-.14-.35-.48A2.9,2.9,0,0,1,278.92,99Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "279.762px 101.053px 0px",
          }}
          id="elbnfuxsmhzv"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--character-1--inject-26"
        style={{ transformOrigin: "176.401px 321.103px 0px" }}
        className="animable"
      >
        <path
          d="M203.73,244.42l15.92,36.08-8.12,8.88,2.89,12.14,16-13.92a8.67,8.67,0,0,0,2.12-10.29l-12.88-26.78a11,11,0,0,0-10.12-6.22Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "218.562px 272.914px 0px",
          }}
          id="elcunye8iudcl"
          className="animable"
        ></path>
        <g id="el4abf1vawxgy">
          <path
            d="M222.89,284.93a11.45,11.45,0,0,1-3.24-4.43L218.24,282A7.24,7.24,0,0,0,222.89,284.93Z"
            style={{
              opacity: "0.3",
              transformOrigin: "220.565px 282.715px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el8gj6iqzxp5c">
          <path
            d="M203.73,244.42l15.92,36.08-8.12,8.88,2.89,12.14,16-13.92a8.67,8.67,0,0,0,2.12-10.29l-12.88-26.78a11,11,0,0,0-10.12-6.22Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: "218.562px 272.914px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M192.4,436.28c-.66,1.4-2.78,2.69-5.1,3.07s-4.67-.12-7-.44a46.76,46.76,0,0,0-10.44-.27,56.82,56.82,0,0,1-6.5.47,10.34,10.34,0,0,1-6.12-1.94,6.23,6.23,0,0,1-2.29-3.9,5.91,5.91,0,0,0,2.29,5.26,10.34,10.34,0,0,0,6.12,1.94,56.82,56.82,0,0,0,6.5-.47,46.76,46.76,0,0,1,10.44.27c2.33.32,4.85,1,7.17.61s4.43-1.68,5.1-3.08Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "173.746px 437.134px 0px",
          }}
          id="elnmubhe9p3n"
          className="animable"
        ></path>
        <path
          d="M167,432.14c2,0,1.24-2.88,3.09-4.81-.75,0-1.51.05-2.27.05C166.2,429.78,165.73,432.14,167,432.14Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "168.182px 429.735px 0px",
          }}
          id="elceadjnswoc"
          className="animable"
        ></path>
        <path
          d="M171.09,432c2,0,1.45-3.44,3.38-5.44a12.73,12.73,0,0,1-1.34.38,11.27,11.27,0,0,1-1.16.21C170.26,429.57,169.76,432,171.09,432Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "172.401px 429.28px 0px",
          }}
          id="elrx3915ks8u"
          className="animable"
        ></path>
        <path
          d="M190.39,425.4a2.68,2.68,0,0,0-1-1.59l-10.53-.26a9.06,9.06,0,0,1-4.37,3c-1.93,2-1.42,5.44-3.38,5.44-1.33,0-.83-2.42.88-4.85-.61.09-1.22.15-1.84.19-1.85,1.93-1.14,4.81-3.09,4.81-1.31,0-.84-2.36.82-4.76h-1.47c-.45,0-.9,0-1.35-.08-3.87,3.07-4.2,6.39-3.7,11.6a15,15,0,0,0,2,.22,56.82,56.82,0,0,0,6.5-.47,46.76,46.76,0,0,1,10.44.27c2.33.32,4.68.82,7,.44s4.44-1.67,5.1-3.07Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "176.79px 431.523px 0px",
          }}
          id="elgrcakuntixu"
          className="animable"
        ></path>
        <path
          d="M165,427.29a16.93,16.93,0,0,0-5.27,0,6.29,6.29,0,0,0-4.74,4.13,4.62,4.62,0,0,0-.08,1.85,6.23,6.23,0,0,0,2.29,3.9,9.07,9.07,0,0,0,4.1,1.72C160.84,433.68,161.17,430.36,165,427.29Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "159.926px 432.987px 0px",
          }}
          id="elzzvom2btwfd"
          className="animable"
        ></path>
        <path
          d="M178.54,420.55v5.08a2.08,2.08,0,0,0,2.08,2.08h5.31a3.42,3.42,0,0,0,3.42-3.31l.13-3.85Z"
          style={{
            fill: "rgb(150, 102, 102)",
            transformOrigin: "184.01px 424.13px 0px",
          }}
          id="el8ljlfz8r2dt"
          className="animable"
        ></path>
        <path
          d="M213.64,418.29a3.89,3.89,0,0,1-3.19,2.24,6.76,6.76,0,0,1-4-1c-1.83-1.16-2.54-3-3.78-4.64a28,28,0,0,0-4.41-4.3,14.48,14.48,0,0,1-4.21-4.88,6.79,6.79,0,0,1-.5-1.79,6.45,6.45,0,0,0,.5,3.44,14.67,14.67,0,0,0,4.21,4.88,28,28,0,0,1,4.41,4.3c1.24,1.64,1.95,3.47,3.78,4.63a6.69,6.69,0,0,0,4,1,3.88,3.88,0,0,0,3.19-2.23,8.64,8.64,0,0,0,.19-2.83A3.41,3.41,0,0,1,213.64,418.29Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "203.684px 413.053px 0px",
          }}
          id="elb7fy1by1gbq"
          className="animable"
        ></path>
        <path
          d="M201.67,407.15a1.28,1.28,0,0,0-.25.87.91.91,0,0,0,.57.66,1.29,1.29,0,0,0,1.19-.31,6,6,0,0,0,.82-1,6.29,6.29,0,0,1,2.71-2,6,6,0,0,1,1.62-.35l-1.32-1.2a6.42,6.42,0,0,0-2.4.59A6.63,6.63,0,0,0,201.67,407.15Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "204.873px 406.269px 0px",
          }}
          id="elpkml57iuof"
          className="animable"
        ></path>
        <path
          d="M202,403a6.65,6.65,0,0,0-2.93,2.7,1.37,1.37,0,0,0-.26.87.9.9,0,0,0,.58.66,1.25,1.25,0,0,0,1.18-.31,5.54,5.54,0,0,0,.82-1,6.17,6.17,0,0,1,5.37-2.33l-1.3-1.18A6.55,6.55,0,0,0,202,403Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "202.784px 404.823px 0px",
          }}
          id="elybt5utof4x"
          className="animable"
        ></path>
        <path
          d="M204.58,401.65a13.53,13.53,0,0,0-4.13-2.76,5.5,5.5,0,0,0-5.69.78,4.92,4.92,0,0,0-1.26,4.26,6.79,6.79,0,0,0,.5,1.79,9.29,9.29,0,0,0,1.31,2.07C195.81,403.26,199.75,401.13,204.58,401.65Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "199px 403.109px 0px",
          }}
          id="elxrjqw5dlti"
          className="animable"
        ></path>
        <path
          d="M213.75,413.84a9.56,9.56,0,0,0-1-4.43l-2.56-2.69-1.83-1.66a6,6,0,0,0-1.62.35,6.29,6.29,0,0,0-2.71,2,6,6,0,0,1-.82,1,1.29,1.29,0,0,1-1.19.31.91.91,0,0,1-.57-.66,1.28,1.28,0,0,1,.25-.87,6.63,6.63,0,0,1,2.94-2.7,6.42,6.42,0,0,1,2.4-.59l-.3-.28a6.17,6.17,0,0,0-5.37,2.33,5.54,5.54,0,0,1-.82,1,1.25,1.25,0,0,1-1.18.31.9.9,0,0,1-.58-.66,1.37,1.37,0,0,1,.26-.87A6.65,6.65,0,0,1,202,403a6.55,6.55,0,0,1,3.46-.57l0,0-.78-.7c-4.83-.52-8.77,1.61-9.27,6.14a20.84,20.84,0,0,0,2.9,2.81,28,28,0,0,1,4.41,4.3c1.24,1.65,1.95,3.48,3.78,4.64a6.76,6.76,0,0,0,4,1,3.89,3.89,0,0,0,3.19-2.24,3.41,3.41,0,0,0,.19-1.18A32.27,32.27,0,0,0,213.75,413.84Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "204.646px 411.144px 0px",
          }}
          id="elofkt1crmnnl"
          className="animable"
        ></path>
        <path
          d="M204.5,405.82l.31,5.45c3.43,2,7.05.9,8.25-.35l.23-5.1Z"
          style={{
            fill: "rgb(150, 102, 102)",
            transformOrigin: "208.895px 409.095px 0px",
          }}
          id="el6xmnsssmlko"
          className="animable"
        ></path>
        <path
          d="M211.79,289a5.32,5.32,0,0,1-.51-.85,49.58,49.58,0,0,1-35.45,4c-2.51,18.68-4.67,50.32-3.34,71.2,1.1,24.3,5.57,58.71,5.57,58.71,5.83,1.75,10.21.68,11.86-.59,1.94-24.1,6.22-40.63,2.92-56.57,2.2-11.14,3.63-25.14,3.63-25.14l1.68,24.62,5.7,43.29a10.22,10.22,0,0,0,10.24-.52c4.15-24.75,5.7-41.52,2.07-53.81C221.7,312.7,222,302.31,211.79,289Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "196.033px 355.564px 0px",
          }}
          id="el3vmkpnkmkx3"
          className="animable"
        ></path>
        <g id="elerj7ltw6ipd">
          <path
            d="M198.92,334.87,202,322.05c3.57-.58,9.14-2.92,12.07-7.81a24.52,24.52,0,0,1-14.79,5.22l-2.78,20.28.59,8.67.24-3.16A66.3,66.3,0,0,1,198.92,334.87Z"
            style={{
              opacity: "0.3",
              transformOrigin: "205.285px 331.325px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M189.7,244.93l-8.92,1.76c-2,3.6-4,7-5.94,10.59-1.49,2.72-3,5.6-2.9,8.7a8.82,8.82,0,0,0,5.34,7.67l-4.64,30.7c12,10.92,43,3.11,46.76-.13-1.61-8.2-5.16-11.43-7-20-1.48-6.88,1.42-14.43,1.91-16.7a52.73,52.73,0,0,0,1.51-10,17.66,17.66,0,0,0-2.36-9.75l0-.09a10.9,10.9,0,0,0-10.94-4.7Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "195.668px 276.391px 0px",
          }}
          id="elcr6zz4w3cq4"
          className="animable"
        ></path>
        <g id="el5gy7ko01que">
          <path
            d="M189.7,244.93l-8.92,1.76c-2,3.6-4,7-5.94,10.59-1.49,2.72-3,5.6-2.9,8.7a8.82,8.82,0,0,0,5.34,7.67l-4.64,30.7c12,10.92,43,3.11,46.76-.13-1.61-8.2-5.16-11.43-7-20-1.48-6.88,1.42-14.43,1.91-16.7a52.73,52.73,0,0,0,1.51-10,17.66,17.66,0,0,0-2.36-9.75l0-.09a10.9,10.9,0,0,0-10.94-4.7Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: "195.668px 276.391px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M203.73,207.7a15,15,0,0,1,6.52,13.18c-.2,3-1.28,5.86-.94,8.79.19,1.73.87,3.48.42,5.16a5.34,5.34,0,0,1-2.8,3.17c-1.29.67-4.3.5-5.72.79-4.35,4-9.81,2.47-13.28-1S178.84,221,178.84,221a18.11,18.11,0,0,1-2.74-8.65,7.27,7.27,0,0,1,1.25-4.92c1.09-1.35,3.25-1.93,4.61-.85-1.29-1-.36-3.3,1-4.22a5.56,5.56,0,0,1,4.71-.36,45.64,45.64,0,0,0,4.64,1.51c2.11.38,4.29-.09,6.43.13S203.52,205.56,203.73,207.7Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "193.164px 221.404px 0px",
          }}
          id="el3leyflwi8f4"
          className="animable"
        ></path>
        <polygon
          points="177.94 224.9 175.22 229.61 178.2 230.71 177.94 224.9"
          style={{
            fill: "rgb(112, 67, 67)",
            transformOrigin: "176.71px 227.805px 0px",
          }}
          id="elil3t2n8mdq"
          className="animable"
        ></polygon>
        <path
          d="M177.63,222.79c.44-4.13,1.65-8,4.34-10a22.35,22.35,0,0,0,3.1,14.8,6.49,6.49,0,0,1,2-3.54,3.73,3.73,0,0,1,3.85-.83,3.79,3.79,0,0,1,1.94,2.11,5,5,0,0,1-6.28,6.64,9.66,9.66,0,0,0,7.42,7.52,12.44,12.44,0,0,0,7.2-.69l1.12,5.58C197.79,249.21,190,246,190,246l-1-5.49c-8.93.53-9.76.38-10.75-4.54A48.22,48.22,0,0,1,177.63,222.79Z"
          style={{
            fill: "rgb(150, 102, 102)",
            transformOrigin: "189.877px 229.918px 0px",
          }}
          id="el47y6xmq74hb"
          className="animable"
        ></path>
        <path
          d="M186.59,232c.06,1.68,0,3.29.08,5a13.41,13.41,0,0,1-.52,5.25,4.55,4.55,0,0,1-3.88,3.15A11.84,11.84,0,0,0,193,247.27a11.64,11.64,0,0,0,7.58-7.68,8.86,8.86,0,0,1-2.53,7.25,10.55,10.55,0,0,0,9.47-2.08,10.34,10.34,0,0,0,3.55-8.91c-.27-2.32-1.32-4.46-2-6.67s-1.11-4.73-.09-6.82a61.06,61.06,0,0,1-6.92,7.1,19.18,19.18,0,0,1-8.31,4.54,8.42,8.42,0,0,1-3.53.14A6.7,6.7,0,0,1,186.59,232Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "196.698px 235.089px 0px",
          }}
          id="elgl2yen87227"
          className="animable"
        ></path>
        <g id="elgny9q7jexk">
          <path
            d="M199.54,212.78a8.65,8.65,0,0,0,8.65,8.65,8.49,8.49,0,0,0,2-.25l0-.3a15,15,0,0,0-6.52-13.18,3.42,3.42,0,0,0-.8-1.79A8.65,8.65,0,0,0,199.54,212.78Z"
            style={{
              opacity: "0.2",
              transformOrigin: "204.875px 213.67px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elu8ijp46z4wc">
          <circle
            cx="207.08"
            cy="209.86"
            r="8.65"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin:
                "207.08px 209.86px 0px; transform: rotate(-75.73deg)",
            }}
            className="animable"
          ></circle>
        </g>
        <path
          d="M120.87,248.87a1.06,1.06,0,0,1-1.36-.56,1,1,0,0,1,.52-1.37l11.8-5.5a1.4,1.4,0,0,1,1.87.7h0a1.4,1.4,0,0,1-.76,1.85Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "126.61px 245.127px 0px",
          }}
          id="elts2zlznbs"
          className="animable"
        ></path>
        <path
          d="M130.7,260.26a175.23,175.23,0,0,0,19.11,24.56,4.7,4.7,0,0,0,5.94.62c9.71-6.4,17.73-17.25,17.73-17.25L163,261l-9.11,11.83-17.23-16.94-1.13-9.42a2.28,2.28,0,0,0-1.38-1.84l-4.85-2.11a2.32,2.32,0,0,0-1.81,0l-2.83,1.18a1.24,1.24,0,0,0-.53,1.88h0a1.26,1.26,0,0,0,1.35.46l1.4-.42L123.55,248a2.59,2.59,0,0,0-1,2.08v1.69a2.6,2.6,0,0,0,1.16,2.16l.4.27a1.34,1.34,0,0,0,1.91-.47h0C126.58,257.3,130.7,260.26,130.7,260.26Z"
          style={{
            fill: "rgb(150, 102, 102)",
            transformOrigin: "148.015px 264.278px 0px",
          }}
          id="elkqcnlu0p2i"
          className="animable"
        ></path>
        <path
          d="M126.84,245.57l.88-.58a1.45,1.45,0,0,1,1.07-.21l4,.79-3.75-1.29a1.42,1.42,0,0,0-1.6.49Z"
          style={{
            fill: "rgb(112, 67, 67)",
            transformOrigin: "129.815px 244.886px 0px",
          }}
          id="elbtgewdjn5kh"
          className="animable"
        ></path>
        <path
          d="M126,253.75c-.37-1.32-.58-3.09,0-3.74l-1.64.91.18,1.68Z"
          style={{
            fill: "rgb(112, 67, 67)",
            transformOrigin: "125.18px 251.88px 0px",
          }}
          id="el13sjgx3bou3n"
          className="animable"
        ></path>
        <path
          d="M146.11,263.27a2.11,2.11,0,0,1,2,.53l2.42,2.3a2.14,2.14,0,0,1,.63,1.84l0,.22-.7-.66c-8.59,2.73-7.66,11.33-7.66,11.33l1.21,1.54a2.12,2.12,0,0,1-2-.78l-3-3.79a2.05,2.05,0,0,1-.46-1.41C138.61,272,139.54,264.91,146.11,263.27Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "144.864px 271.8px 0px",
          }}
          id="elpouvbktbrw"
          className="animable"
        ></path>
        <path
          d="M146.11,263.27a2.11,2.11,0,0,1,2,.53l2.42,2.3a2.14,2.14,0,0,1,.63,1.84l0,.22-.7-.66c-8.59,2.73-7.66,11.33-7.66,11.33l1.21,1.54a2.12,2.12,0,0,1-2-.78l-3-3.79a2.05,2.05,0,0,1-.46-1.41C138.61,272,139.54,264.91,146.11,263.27Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "144.864px 271.8px 0px",
          }}
          id="el82z7v6v884"
          className="animable"
        ></path>
        <g id="elf8av04rq6a">
          <path
            d="M146.11,263.27a2.11,2.11,0,0,1,2,.53l2.42,2.3a2.14,2.14,0,0,1,.63,1.84l0,.22-.7-.66c-8.59,2.73-7.66,11.33-7.66,11.33l1.21,1.54a2.12,2.12,0,0,1-2-.78l-3-3.79a2.05,2.05,0,0,1-.46-1.41C138.61,272,139.54,264.91,146.11,263.27Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.5",
              transformOrigin: "144.864px 271.8px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M150.42,267.5l.7.66,2.9,2.74,1-1.57L166.78,254a19.49,19.49,0,0,1,13.09-7.46l1.57-.19s3.15,13.2-3.6,20.55l-12.9,13.65a51.34,51.34,0,0,1-8.62,6.65,6,6,0,0,1-8-1.34l-5.56-7.06S141.83,270.23,150.42,267.5Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "162.452px 267.26px 0px",
          }}
          id="elv4mhn0jjv8b"
          className="animable"
        ></path>
        <g id="elurw3du69rq">
          <path
            d="M150.42,267.5l.7.66,2.9,2.74,1-1.57L166.78,254a19.49,19.49,0,0,1,13.09-7.46l1.57-.19s3.15,13.2-3.6,20.55l-12.9,13.65a51.34,51.34,0,0,1-8.62,6.65,6,6,0,0,1-8-1.34l-5.56-7.06S141.83,270.23,150.42,267.5Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: "162.452px 267.26px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--character-2--inject-26"
        style={{ transformOrigin: "347.532px 243.766px 0px" }}
        className="animable"
      >
        <path
          d="M340.35,161.61c-8.58-1-9.38.94-14.94,6.19S314.22,179,314.22,179c-2.26,8.3-.46,21.44-.46,21.44,4.67-3.63,18.62-13.52,18.62-13.52Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "326.715px 180.898px 0px",
          }}
          id="elp8rwftqfvnj"
          className="animable"
        ></path>
        <g id="ell9d1yufrf4f">
          <path
            d="M325.41,167.8C319.85,173,314.22,179,314.22,179c-2.26,8.3-.46,21.44-.46,21.44,2.88-2.24,9.3-6.86,13.79-10.08l4.83-3.44,5.48-17.35,2.49-7.91C331.77,160.65,331,162.55,325.41,167.8Z"
            style={{
              opacity: "0.05",
              transformOrigin: "326.715px 180.92px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elc8zb1rvpc8i">
          <path
            d="M337.86,169.52a21.78,21.78,0,0,0-7.39,8.34,29.18,29.18,0,0,0-2.92,12.45l4.83-3.44Z"
            style={{
              opacity: "0.1",
              transformOrigin: "332.705px 179.915px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M319.49,354.34a9.53,9.53,0,0,0,7.17,2.63,21.39,21.39,0,0,0,7.58-1.91c2.42-1,5.47-3.78,8.09-3.73a63,63,0,0,0,7.66-.52,40.21,40.21,0,0,0-1.09-10.39l-12.23-.32c-3.3,4.52-9.73,8.29-14.59,9.7a4.29,4.29,0,0,0-3,3.22.17.17,0,0,1,0,.07A5.1,5.1,0,0,0,319.49,354.34Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "334.542px 348.544px 0px",
          }}
          id="eld38al0fp74k"
          className="animable"
        ></path>
        <path
          d="M342.33,351.33c-2.62-.05-5.67,2.74-8.09,3.73a21.39,21.39,0,0,1-7.58,1.91,9.53,9.53,0,0,1-7.17-2.63,5.1,5.1,0,0,1-.42-1.25.17.17,0,0,0,0-.07,4.07,4.07,0,0,0,0,1.63,5.11,5.11,0,0,0,.42,1.24,9.58,9.58,0,0,0,7.17,2.64,21.82,21.82,0,0,0,7.58-1.91c2.42-1,5.47-3.79,8.09-3.74a56.11,56.11,0,0,0,7.54-.43c.06-.55.1-1.1.12-1.64A63,63,0,0,1,342.33,351.33Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "334.489px 354.678px 0px",
          }}
          id="elnlkqvj1z6bi"
          className="animable"
        ></path>
        <path
          d="M376.86,355.49a17.75,17.75,0,0,1-.36,3.71,8.57,8.57,0,0,1-3.4,5.41,10.88,10.88,0,0,1-5.39,1.43,12,12,0,0,1-4.93-.5,5.6,5.6,0,0,1-2.88-2.36.13.13,0,0,0,0,.06,5.15,5.15,0,0,0,3.32,3.46,11.88,11.88,0,0,0,4.93.51,10.89,10.89,0,0,0,5.39-1.44,8.56,8.56,0,0,0,3.39-5.41,17.76,17.76,0,0,0,.37-3.71,6.29,6.29,0,0,1,2-4.53,12.25,12.25,0,0,0,.87-.9,2.21,2.21,0,0,0,.53-1.62c0-.23,0-.45-.07-.67-.45.52-1.51,1.77-1.78,2A6.33,6.33,0,0,0,376.86,355.49Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "370.302px 358.104px 0px",
          }}
          id="elxety1bigayi"
          className="animable"
        ></path>
        <path
          d="M367.51,342.56a13.51,13.51,0,0,1-1,7.52,28.32,28.32,0,0,1-4,6.55,19.47,19.47,0,0,0-2.08,3,5.46,5.46,0,0,0-.59,3.51,5.6,5.6,0,0,0,2.88,2.36,12,12,0,0,0,4.93.5,10.88,10.88,0,0,0,5.39-1.43,8.57,8.57,0,0,0,3.4-5.41,17.75,17.75,0,0,0,.36-3.71,6.33,6.33,0,0,1,2-4.54c.27-.25,1.33-1.5,1.78-2a13.64,13.64,0,0,0-1.83-5.25Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "370.173px 354.314px 0px",
          }}
          id="el57klktvlh8g"
          className="animable"
        ></path>
        <path
          d="M331.37,221.73l1,69.77,3.29,48.85c8.34,5.27,14.37.95,14.37.95,3.16-23.14,3.59-37.36,1.87-47l1.58-37.66,4.74,39.09,8,47.92c8.55,5.55,14.59,0,14.59,0,0-17.73,1.58-37.57-3.31-50.36a294,294,0,0,0-2.3-70.86Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "356.212px 283.923px 0px",
          }}
          id="elabf93q0w075"
          className="animable"
        ></path>
        <g id="el6qmo7hv89z3">
          <path
            d="M351.76,242.27l1.74,14.38-.74,17.64-3.21-29c-7.44-2.91-8.41-7-8.41-7A22.83,22.83,0,0,0,351.76,242.27Z"
            style={{ opacity: "0.3", transformOrigin: "347.32px 256.29px 0px" }}
            className="animable"
          ></path>
        </g>
        <path
          d="M347.21,160.79l-8.15.86c-6.69,5.89-10.14,18.25-8.7,31.9a242.22,242.22,0,0,1,1,28.18c18.11,13.22,41,3.59,43.83.71l-1.34-16.74a11.59,11.59,0,0,1,.92-5.51c1.71-4,4.76-11.79,5.17-17.85a31.69,31.69,0,0,0-3.31-15.59l-11.86-5.17Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "355.004px 194.659px 0px",
          }}
          id="eluwqvcnta79l"
          className="animable"
        ></path>
        <g id="eleqpycdh8fmj">
          <g
            style={{
              opacity: "0.1",
              transformOrigin: "355.004px 194.659px 0px",
            }}
            className="animable"
          >
            <path
              d="M347.21,160.79l-8.15.86c-6.69,5.89-10.14,18.25-8.7,31.9a242.22,242.22,0,0,1,1,28.18c18.11,13.22,41,3.59,43.83.71l-1.34-16.74a11.59,11.59,0,0,1,.92-5.51c1.71-4,4.76-11.79,5.17-17.85a31.69,31.69,0,0,0-3.31-15.59l-11.86-5.17Z"
              id="els28ya7whwlk"
              style={{ transformOrigin: "355.004px 194.659px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M345,172.68a88.24,88.24,0,0,0-6.72,31.87l3.36,7.22,5.26-6.9a272.36,272.36,0,0,1,.64-31.72Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "342.91px 192.225px 0px",
          }}
          id="el05l60cf180zd"
          className="animable"
        ></path>
        <path
          d="M344.66,166.75a24.6,24.6,0,0,0,.29,5.93,4.77,4.77,0,0,0,2.54.47,20.68,20.68,0,0,0,4.07-4.93l-4.07-1.47Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "348.078px 169.96px 0px",
          }}
          id="eld49ozvcrusb"
          className="animable"
        ></path>
        <path
          d="M347.49,166.75c3.51,1.29,6.63,7.55,6.63,7.55,9.23-7.84,10.66-12.72,10.66-12.72a18.34,18.34,0,0,0-4.47-4.72Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "356.135px 165.58px 0px",
          }}
          id="el6vjykuw9gmm"
          className="animable"
        ></path>
        <path
          d="M347.49,166.75c-2.68.07-5.06,3.81-5.06,3.81C342,164,347.49,159,347.49,159Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "344.948px 164.78px 0px",
          }}
          id="el3s4onx6j8wf"
          className="animable"
        ></path>
        <g id="ell0f99z2f2a">
          <g
            style={{
              opacity: "0.35",
              transformOrigin: "353.593px 165.58px 0px",
            }}
            className="animable"
          >
            <g id="elu7ridqwhmgm">
              <path
                d="M347.49,166.75c3.51,1.29,6.63,7.55,6.63,7.55,9.23-7.84,10.66-12.72,10.66-12.72a18.34,18.34,0,0,0-4.47-4.72Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.1",
                  transformOrigin: "356.135px 165.58px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="el1rk2q312rdh">
              <path
                d="M347.49,166.75c-2.68.07-5.06,3.81-5.06,3.81C342,164,347.49,159,347.49,159Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.1",
                  transformOrigin: "344.948px 164.78px 0px",
                }}
                className="animable"
              ></path>
            </g>
          </g>
        </g>
        <path
          d="M364.79,130.49a6.13,6.13,0,0,0-.59-.64c1.39-3.2-3.17-5.82-4.93-6.7a27.41,27.41,0,0,0-16-2.64c-2.67.38-5.45,1.26-7.19,3.32s-2.34,4.76-.22,6.44c-2.8,6-.56,10-.56,10-.38,9.18-.69,15,3.28,16.95a18.23,18.23,0,0,0,8.87,1.25,20.88,20.88,0,0,0,8.13-2.19l.13-.07a6.93,6.93,0,0,0,3.48-4.64,38.31,38.31,0,0,0,.84-5.43,21.46,21.46,0,0,1,.34-3.1,5.55,5.55,0,0,1,1.36-2.75,3.12,3.12,0,0,1,2.8-.95,3.41,3.41,0,0,1,.5.19C365.72,135.45,365.92,131.92,364.79,130.49Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "350.022px 139.415px 0px",
          }}
          id="el15e8jn64qkx"
          className="animable"
        ></path>
        <path
          d="M356.92,130.22a8,8,0,0,0-.7,6.13,38.6,38.6,0,0,1,1.54,5,8.29,8.29,0,0,1-.67,5.06,5.88,5.88,0,0,1-3.87,3.14c-2.6.56-5.15-1-7.77-1.5a10.72,10.72,0,0,0-7.3,1.31,1.27,1.27,0,0,1-1.92-1c-.31-5.29-.75-14.34.8-18.4l.08,0a26.56,26.56,0,0,1,19.81.3Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "346.911px 138.93px 0px",
          }}
          id="elt93ul1bk4ek"
          className="animable"
        ></path>
        <polygon
          points="358.37 154.8 358.37 154.8 358.36 154.8 358.37 154.8"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "358.365px 154.8px 0px",
          }}
          id="elynu86trzg5b"
          className="animable"
        ></polygon>
        <path
          d="M360.49,148.78s-.05,2.15-.1,4.71a7.39,7.39,0,0,0,2.26-3.56A3.27,3.27,0,0,1,360.49,148.78Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "361.52px 151.135px 0px",
          }}
          id="el2re0o2zvj"
          className="animable"
        ></path>
        <path
          d="M348.08,150.16l-3.42,1.07a2.07,2.07,0,0,0,2.3,1.07A1.92,1.92,0,0,0,348.08,150.16Z"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "346.389px 151.256px 0px",
          }}
          id="el22ewp3dodx6"
          className="animable"
        ></path>
        <g id="el18atr3d17wr">
          <path
            d="M348.08,150.16l-3.42,1.07a2.07,2.07,0,0,0,2.3,1.07A1.92,1.92,0,0,0,348.08,150.16Z"
            style={{
              opacity: "0.3",
              transformOrigin: "346.389px 151.256px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M345.84,152.24a1.88,1.88,0,0,0,1.12.06,1.72,1.72,0,0,0,1.11-1.56,2,2,0,0,0-1.32.24A2.06,2.06,0,0,0,345.84,152.24Z"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "346.955px 151.536px 0px",
          }}
          id="eld8wao8dkfdk"
          className="animable"
        ></path>
        <path
          d="M350.75,141.75a1.22,1.22,0,1,1-1.15-1.3A1.23,1.23,0,0,1,350.75,141.75Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "349.532px 141.668px 0px",
          }}
          id="elcoph759jx7"
          className="animable"
        ></path>
        <path
          d="M340.57,140.8a1.21,1.21,0,1,1-1.15-1.3A1.21,1.21,0,0,1,340.57,140.8Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "339.363px 140.709px 0px",
          }}
          id="elw76zdr2mok8"
          className="animable"
        ></path>
        <path
          d="M339.65,135.83l-2.79,1.74a1.77,1.77,0,0,1,.63-1.9A2,2,0,0,1,339.65,135.83Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "338.22px 136.498px 0px",
          }}
          id="elou2yglktlf"
          className="animable"
        ></path>
        <path
          d="M350.06,136.25l2.59,2a1.78,1.78,0,0,0-.42-2A2,2,0,0,0,350.06,136.25Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "351.427px 137.09px 0px",
          }}
          id="el08j5vpbuwn0n"
          className="animable"
        ></path>
        <path
          d="M366.71,141.32a3.36,3.36,0,0,0-2.18-2,3.12,3.12,0,0,0-2.8.95,5.55,5.55,0,0,0-1.36,2.75,21.46,21.46,0,0,0-.34,3.1,37.18,37.18,0,0,1-.87,5.56,6.85,6.85,0,0,1-3.46,4.52l-.12.06a20.88,20.88,0,0,1-8.13,2.19v8.28L358.94,160a2.79,2.79,0,0,0,1.36-2.34c0-1.33.06-2.79.09-4.13.05-2.56.1-4.71.1-4.71a3.27,3.27,0,0,0,2.16,1.15,2.84,2.84,0,0,0,1.13-.06,4.3,4.3,0,0,0,2.53-2.19,8.12,8.12,0,0,0,.8-3.34A6.72,6.72,0,0,0,366.71,141.32Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "357.297px 153.003px 0px",
          }}
          id="ellydxgn3vjoa"
          className="animable"
        ></path>
        <g id="elrlrzakjs8j7">
          <path
            d="M357.22,156.11a8,8,0,0,0,1.42-3,7,7,0,0,1-2.94,3.09l-.12.06a20.88,20.88,0,0,1-8.13,2.19v2.11a20.21,20.21,0,0,0,4.81-1A10.78,10.78,0,0,0,357.22,156.11Z"
            style={{
              opacity: "0.2",
              transformOrigin: "353.045px 156.835px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M333.88,137.38v1.56l.38.21a17.28,17.28,0,0,1,.36,3.06,4.15,4.15,0,0,0,1.05,2.7,4.06,4.06,0,0,0,2.84.79,5,5,0,0,0,2.37-.36,4,4,0,0,0,1.8-2.31c.34-1,.28-1.54.71-2.71a.8.8,0,0,1,.75-.54.87.87,0,0,1,.81.54c.45,1.17.39,1.73.75,2.71a4.07,4.07,0,0,0,1.93,2.31,5.69,5.69,0,0,0,2.53.36,4.55,4.55,0,0,0,3-.79,4,4,0,0,0,1.13-2.7,15.62,15.62,0,0,1,.38-3.06l.41-.21v-1.56a10.81,10.81,0,0,0-10.21,1h-1.47A9.56,9.56,0,0,0,333.88,137.38Zm11.83,1.53a9.91,9.91,0,0,1,5.2-1.52,9.52,9.52,0,0,1,2.59.36c.07,1.18.11,2.81.06,3.55l-.06.79a3.18,3.18,0,0,1-.87,2.17,3.91,3.91,0,0,1-2.51.61h-.33a4.36,4.36,0,0,1-1.81-.29,3.33,3.33,0,0,1-1.53-1.87,12.45,12.45,0,0,1-.74-2.93l-.06-.56S345.62,139,345.71,138.91Zm-10.33-1.16a8.4,8.4,0,0,1,2.42-.36,8.85,8.85,0,0,1,4.87,1.52c.08.05.06.31.06.31l-.06.56a13.76,13.76,0,0,1-.69,2.93,3.32,3.32,0,0,1-1.43,1.87,3.86,3.86,0,0,1-1.7.29h-.31a3.51,3.51,0,0,1-2.35-.61,3.27,3.27,0,0,1-.8-2.17c0-.26-.05-.52-.06-.79C335.28,140.56,335.32,138.93,335.38,137.75Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "344.48px 141.131px 0px",
          }}
          id="elxuh86siqnxj"
          className="animable"
        ></path>
        <path
          d="M355.11,137.38l7.05,2.54a5.17,5.17,0,0,0-1,1.05c-.08.09-6.08-2-6.08-2Z"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "358.62px 139.176px 0px",
          }}
          id="elhexs8mmb6zo"
          className="animable"
        ></path>
        <polygon
          points="344.08 139.81 339.65 145.25 343.71 146.71 344.08 139.81"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "341.865px 143.26px 0px",
          }}
          id="el2phdn4bzbet"
          className="animable"
        ></polygon>
        <path
          d="M319,169.05c4.68-.92,7.77,4,7,6C319.73,179.1,317.29,172.72,319,169.05Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "322.293px 172.643px 0px",
          }}
          id="elqqum3hoqgzi"
          className="animable"
        ></path>
        <g id="elf1q84k1or47">
          <path
            d="M319,169.05c4.68-.92,7.77,4,7,6C319.73,179.1,317.29,172.72,319,169.05Z"
            style={{
              opacity: "0.2",
              transformOrigin: "322.293px 172.643px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M334.74,168.52l3.52,1.62a1.4,1.4,0,0,1,.67,1.91h0a1.4,1.4,0,0,1-1.5.76l-8.67-1.56,2.65-3.36Z"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "333.921px 170.361px 0px",
          }}
          id="el27hbowx3h33"
          className="animable"
        ></path>
        <path
          d="M327,171.62,316,197.4a7.59,7.59,0,0,1-9.71,4.12h0a7.58,7.58,0,0,1-3.2-11.83L321,167.4a10.52,10.52,0,0,1,2.14-2l5.46-3.85a11.56,11.56,0,0,1,5.17-2h0l2.66-1.95a2.64,2.64,0,0,1,2.53-.34l4.09,1.57h0a2.68,2.68,0,0,1-3.08,1.49l-1.63-.4-1.91,1.41,2.48,3.45a2.16,2.16,0,0,1-.43,3l-4.69,3.6a1.68,1.68,0,0,1-1.51.28h0a1.67,1.67,0,0,1-1.15-2v0A5.94,5.94,0,0,1,327,171.62Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "322.234px 179.554px 0px",
          }}
          id="elbffrad2kxqq"
          className="animable"
        ></path>
        <path
          d="M336.45,161.28a6.5,6.5,0,0,0-1.7-1.41l3.29.24Z"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "336.395px 160.575px 0px",
          }}
          id="elt6bfqmcj5wd"
          className="animable"
        ></path>
        <path
          d="M318.41,178.5a9.62,9.62,0,0,0,5.66,1.53L326,175.1a7.5,7.5,0,0,1-4.41-1.76,8.26,8.26,0,0,1-2.58-4.29l-3.7,4.37A7.35,7.35,0,0,0,318.41,178.5Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "320.655px 174.545px 0px",
          }}
          id="ellsr6t8srbsd"
          className="animable"
        ></path>
        <path
          d="M318.41,178.5a7.35,7.35,0,0,1-3.15-5.08l-12.42,14.69a8.75,8.75,0,0,0,1.38,12.62l.23.18a8.49,8.49,0,0,0,13.07-3.73L324.07,180A9.62,9.62,0,0,1,318.41,178.5Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "312.418px 188.031px 0px",
          }}
          id="el9yr36878pr6"
          className="animable"
        ></path>
        <g id="el3p6uwez6cz3">
          <path
            d="M318.41,178.5a7.35,7.35,0,0,1-3.15-5.08l-12.42,14.69a8.75,8.75,0,0,0,1.38,12.62l.23.18a8.49,8.49,0,0,0,13.07-3.73L324.07,180A9.62,9.62,0,0,1,318.41,178.5Z"
            style={{
              opacity: "0.05",
              transformOrigin: "312.418px 188.031px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elxm6mcanfcs">
          <path
            d="M304.45,200.91a8.49,8.49,0,0,0,13.07-3.73L324.07,180l-7.6,16.38A9.15,9.15,0,0,1,304.45,200.91Z"
            style={{
              opacity: "0.1",
              transformOrigin: "314.26px 191.321px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M360.22,208.7c-3.89,3.7-.91,10.54,1,11.21C367.61,216.22,363.18,209.39,360.22,208.7Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "361.406px 214.305px 0px",
          }}
          id="elwgbku7h39xl"
          className="animable"
        ></path>
        <g id="elvqf7fv2ayo">
          <path
            d="M360.22,208.7c-3.89,3.7-.91,10.54,1,11.21C367.61,216.22,363.18,209.39,360.22,208.7Z"
            style={{
              opacity: "0.2",
              transformOrigin: "361.406px 214.305px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <polygon
          points="310.6 214.19 326.32 196.79 356.31 214.93 340.79 228.87 310.6 214.19"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "333.455px 212.83px 0px",
          }}
          id="eldokgyr2hvc"
          className="animable"
        ></polygon>
        <g id="elm12zb7xpfih">
          <polygon
            points="310.6 214.19 326.32 196.79 356.31 214.93 340.79 228.87 310.6 214.19"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.25",
              transformOrigin: "333.455px 212.83px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="326.32 196.79 326.32 195.16 310.43 213.03 308.5 212.36 307.72 188.46 306.72 189.14 307.8 213.01 310.6 214.19 326.32 196.79"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "316.52px 201.325px 0px",
          }}
          id="elx8aksvk10fe"
          className="animable"
        ></polygon>
        <g id="el7j8cmp6z0n4">
          <polygon
            points="326.32 196.79 326.32 195.16 310.43 213.03 308.5 212.36 307.72 188.46 306.72 189.14 307.8 213.01 310.6 214.19 326.32 196.79"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.25",
              transformOrigin: "316.52px 201.325px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="el0uqkx2i7piq">
          <polygon
            points="326.32 196.79 326.32 195.16 310.43 213.03 308.5 212.36 307.72 188.46 306.72 189.14 307.8 213.01 310.6 214.19 326.32 196.79"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.25",
              transformOrigin: "316.52px 201.325px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="326.32 195.16 355.84 213.09 356.31 214.93 326.32 196.79 326.32 195.16"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "341.315px 205.045px 0px",
          }}
          id="elvyssryu0y4b"
          className="animable"
        ></polygon>
        <g id="elx9ghaa8jxy">
          <polygon
            points="326.32 195.16 355.84 213.09 356.31 214.93 326.32 196.79 326.32 195.16"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.25",
              transformOrigin: "341.315px 205.045px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="el5bei1ra3dah">
          <polygon
            points="326.32 195.16 355.84 213.09 356.31 214.93 326.32 196.79 326.32 195.16"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: "341.315px 205.045px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="307.72 188.46 323.66 198.16 310.43 213.03 308.5 212.36 307.72 188.46"
          style={{
            fill: "rgb(170, 91, 49)",
            transformOrigin: "315.69px 200.745px 0px",
          }}
          id="elwh4htw5cmts"
          className="animable"
        ></polygon>
        <g id="el7yh5ofc45co">
          <polygon
            points="307.72 188.46 323.66 198.16 310.43 213.03 308.5 212.36 307.72 188.46"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.31",
              transformOrigin: "315.69px 200.745px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="310.39 189.61 323.93 197.85 310.43 213.03 309.02 212.54 310.46 202.87 310.25 192.49 310.39 189.61"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "316.475px 201.32px 0px",
          }}
          id="elr8kj9unx2i9"
          className="animable"
        ></polygon>
        <path
          d="M308.5,212.36c1.47-6.55,1.63-18.5.37-22.07l1.52-.68c1.57,5.5.58,18.53-.94,23.07Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "309.843px 201.145px 0px",
          }}
          id="ele8sugablm1d"
          className="animable"
        ></path>
        <path
          d="M310.43,213l15.28-17.16v-2.21c-7,5.24-13.87,14-16,19.11Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "317.71px 203.315px 0px",
          }}
          id="elxcxjzzgu1q"
          className="animable"
        ></path>
        <polygon
          points="325.71 193.65 354.56 211.08 354.56 212.32 326.32 195.16 325.71 195.86 325.71 193.65"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "340.135px 202.985px 0px",
          }}
          id="elwr1irxnt9w"
          className="animable"
        ></polygon>
        <path
          d="M394.26,210.14c-1.43-13.49-6.31-35.43-11.05-40.91-3.31-3.84-12.63-5-12.63-5-2.1,7.55,6.76,28.88,9.84,42.86h0l12.68,7.56A6.63,6.63,0,0,0,394.26,210.14Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "382.28px 189.44px 0px",
          }}
          id="elwz13dxccj6k"
          className="animable"
        ></path>
        <path
          d="M380.42,207.1c-11.19,1.83-17.76,2.44-21.17,2.64a6.21,6.21,0,0,1-5-2.08l-.88-1a6.34,6.34,0,0,0-2.52-1.72l-7-2.55a.48.48,0,0,0-.64.35,2.87,2.87,0,0,0,1.13,2.95l4,2.88c-4.72,3.25-12.53-2.67-14-.83a6.12,6.12,0,0,0,1.58,8.8,18.41,18.41,0,0,0,14,3l4.25-1.15c19.55.76,29,0,34.64-1a6.63,6.63,0,0,0,4.3-2.76Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "363.117px 211.112px 0px",
          }}
          id="el8zvdet0o5rr"
          className="animable"
        ></path>
        <path
          d="M369.52,213.8a8.5,8.5,0,0,0-2.81-5.62l-6.49.52a10,10,0,0,1,1,11.21l6.42-.32A8.39,8.39,0,0,0,369.52,213.8Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "364.877px 214.045px 0px",
          }}
          id="elhpu8cjlj7do"
          className="animable"
        ></path>
        <path
          d="M380.42,207.1l-13.71,1.08a8.5,8.5,0,0,1,2.81,5.62,8.39,8.39,0,0,1-1.84,5.79c7.2-.37,18.05-.94,19.6-1.15a7.46,7.46,0,0,0,5.82-3.78Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "379.905px 213.345px 0px",
          }}
          id="el84h185s3y0w"
          className="animable"
        ></path>
        <g id="elqj3tidwv9k">
          <path
            d="M394.26,210.14c-1.43-13.49-6.31-35.43-11.05-40.91-3.31-3.84-12.63-5-12.63-5-2.1,7.55,6.76,28.88,9.84,42.86h0l12.68,7.56A6.63,6.63,0,0,0,394.26,210.14Z"
            style={{
              opacity: "0.05",
              transformOrigin: "382.28px 189.44px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M369.52,213.8a8.5,8.5,0,0,0-2.81-5.62l-6.49.52a10,10,0,0,1,1,11.21l6.42-.32A8.39,8.39,0,0,0,369.52,213.8Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "364.877px 214.045px 0px",
          }}
          id="elyjbdwh1qjy"
          className="animable"
        ></path>
        <path
          d="M380.42,207.1l-13.71,1.08a8.5,8.5,0,0,1,2.81,5.62,8.39,8.39,0,0,1-1.84,5.79c7.2-.37,18.05-.94,19.6-1.15a7.46,7.46,0,0,0,5.82-3.78Z"
          style={{
            fill: "#f2c3aa",
            transformOrigin: "379.905px 213.345px 0px",
          }}
          id="el95it5qwl06r"
          className="animable"
        ></path>
        <g id="elq3m2rbc3p9">
          <path
            d="M380.42,207.1l-13.71,1.08a8.5,8.5,0,0,1,2.81,5.62,8.39,8.39,0,0,1-1.84,5.79c7.2-.37,18.05-.94,19.6-1.15a7.46,7.46,0,0,0,5.82-3.78Z"
            style={{
              opacity: "0.05",
              transformOrigin: "379.905px 213.345px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
    </svg>
  );
}
